import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
  XMLHttpRequestHandler,
  XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { articlesEdit_template_new } from "../components/templates/articlesEdit_template_new";
import { UploadStatusHandler } from "../utils/UploadStatusHandler";
//import {imagePickerHelper} from '../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
// @ts-ignore
import * as diff from "diff";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";
import EmbedHelper from "../utils/EmbedHelper";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
declare var Diff2Html: any;

let contentEditor;
let articleDirectoryItemDescriptionEditor;
let sandboxDirectoryItemDescriptionEditor;
let republishDirectoryItemDescriptionEditor;
let introTextEditor;
let sandboxEditor;
let republishEditor;
let sandboxIntroTextEditor;
let republishIntroTextEditor;
let faqEditor;
let prodRevReviewText;
let imageDescriptionEditor;
let imageCaptionEditor;
let galleryDescriptionEditor;
let additionalCreditEditor;
let bulkImageDescriptionEditor;
let bulkImageCaptionEditor;
let chartDiv;
let tagPickerSpecAreaEditor;
let promptResponseEditor;
let factualSummaryEditor;
let simpleSummaryEditor;
let satiricalCommentaryEditor;
let galleryCreditTextEditor;

const ID_TEMPLATE_VIDEO = 15;
const ID_TEMPLATE_THREAD = 16;

export class articles_edit_new extends vnModule_knockoutJS {
  public articlesEdit: articlesEdit_template_new;
  public XHRHdl: XMLHttpRequestHandler;
  protected XHRHdlCaller: string;
  protected XHRHdls: XMLHttpRequestHandler[] = [];
  protected imageXHRHdl: XMLHttpRequestHandler;
  protected galleryXHRHdl: XMLHttpRequestHandler;
  protected tagXHRHdl: XMLHttpRequestHandler;
  protected tagSearchXHRHdl: XMLHttpRequestHandler;
  protected contentImageXHRHdl: XMLHttpRequestHandler;
  protected keyPointsXHRHdl: XMLHttpRequestHandler;
  protected sensaiVaultXHRHdl: XMLHttpRequestHandler;
  protected autoCategorizeXHRHdl: XMLHttpRequestHandler;
  protected paymentCategoryXHR: XMLHttpRequestHandler;
  protected ImagePickerXHRHdl: XMLHttpRequestHandler;
  protected SensaiXHRHdl: XMLHttpRequestHandler;
  protected threadSuggestionXHRHdl: XMLHttpRequestHandler;
  protected tocXHRHdl: XMLHttpRequestHandler;
  protected progressBar: HTMLProgressElement;
  protected uploadProgress: any;
  protected recoveryTimeout: any;
  protected recoveryWarning: any;
  protected recoveryWarningShown = false;
  protected isSaveImage: any;
  protected isSaveGallery: any;
  protected recoveryDelay = 120; // set to 2 minutes
  protected recoveryWarningTimeout = 360; // set to 6 minutes
  protected lastSaved = new Date(Date.now()); // sets to current time, when page is loaded, this is considered saved from server
  protected lastUpdatedTimer: any;
  protected hasLastSuccessfulAutosave = false;
  protected isSaveAndStay = false;
  protected publishStatuses: any;
  private recoverySaveMode: string;
  public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
  protected _isLeavePageWarningNeeded: boolean = true;
  protected isSaveStuck = false;

  protected isSensaiProgressBarStuck = false;
  protected isCompensationTrackerStuck = false;
  //protected imagePickerHelper: imagePickerHelper;

  protected keyPointsAttempts = 0;
  protected imageMode: string;
  protected embedHelper: EmbedHelper;

  protected videoXHRHdl: XMLHttpRequestHandler;
  protected contentVideoXHRHdl: XMLHttpRequestHandler;
  private deleteVideoXHRHdl: XMLHttpRequestHandler;
  protected pollXhr: XMLHttpRequestHandler;

  protected eventSource: EventSource;

  protected isSensaiChat = false;

  constructor(vnAppZone) {
    super(vnAppZone);
    this.embedHelper = new EmbedHelper(this);
  }

  private getImageMode(): string {
    return this.imageMode;
  }

  private setImageMode(mode: string): void {
    this.imageMode = mode;
  }

  protected getModuleName(): string {
    return "articles_edit_new";
  }

  protected getImagePickerHelper() {
    return this.articlesEdit.imagePickerHelper;
  }

  public viewImage(target) {
    this.articlesEdit.viewImage(target);
  }

  public closeImage(target) {
    this.articlesEdit.closeImage(target);
  }

  public removeImage(target) {
    this.articlesEdit.removeImage(target);
  }

  buildContent(): Array<Element> {
    this.articlesEdit = new articlesEdit_template_new(
      "edit_template_new",
      this.viewModel,
      this as articles_edit_new
    );
    this.articlesEdit.setCanSearchUsers(true);
    this.template = this.articlesEdit;

    return [this.articlesEdit.build()];
  }

  public fillPage(): void {
    this.setUpCkEditorTagsPickerEditTextArea();
    this.minimizeSideNav();
    this.getArticleReferences();
    this.getPaymentCategories();
    this.articlesEdit.buildDatePickerCalendar();
    this.watchScroll();
    this.recoveryWarningShown = false;
  }

  public watchScroll() {
    let _this = this;
    _this.isSaveStuck = false;
    _this.isSensaiProgressBarStuck = false;
    _this.isCompensationTrackerStuck = false;
    window.onscroll = function (e) {
      let h = document.querySelector(".w-form-side-header");
      let j = document.querySelector(".form-side-header");

      let sensaiProgressBarWaypoint = document.getElementById(
        "sensai-progress-bar-container"
      );
      let sensaiProgressBar = document.getElementById("sensaiProgressBar");

      let sensaiStickPoint =
        sensaiProgressBarWaypoint.getBoundingClientRect().top +
        window.pageYOffset -
        j.getBoundingClientRect().bottom;
      let stickPoint = window.pageYOffset + h.getBoundingClientRect().top;

      let distance = articles_edit_new.getDistance(h) - window.pageYOffset;

      let offset = window.pageYOffset;

      // console.log(distance, offset, stickPoint, _this.isSaveStuck);

      if (offset >= sensaiStickPoint && !_this.isSensaiProgressBarStuck) {
        sensaiProgressBar.classList.add("sticky-progress-bar");
        _this.isSensaiProgressBarStuck = true;
        console.log("sensaiProgressBar stuck");
      } else if (_this.isSensaiProgressBarStuck && offset < sensaiStickPoint) {
        sensaiProgressBar.classList.remove("sticky-progress-bar");
        _this.isSensaiProgressBarStuck = false;
        console.log("sensaiProgressBar unstuck");
      }

      let compensationTrackerWaypoint = document.getElementById(
        "compensation-tracker-container"
      );
      let compensationTracker = document.getElementById("compensation-tracker");

      let ctStickPoint =
        compensationTrackerWaypoint.getBoundingClientRect().top - 100 +
        window.pageYOffset -
        j.getBoundingClientRect().bottom;


      if (offset >= ctStickPoint && !_this.isCompensationTrackerStuck) {
        compensationTracker.classList.add("sticky-compensation");
        _this.isCompensationTrackerStuck = true;
        console.log("ct stuck");
      } else if (_this.isCompensationTrackerStuck && offset < ctStickPoint) {
        compensationTracker.classList.remove("sticky-compensation");
        _this.isCompensationTrackerStuck = false;
        console.log("ct unstuck");
      }

      if (distance <= 0 && !_this.isSaveStuck) {
        j.classList.add("sticky-save");
        _this.isSaveStuck = true;
      } else {
        if (_this.isSaveStuck && offset <= stickPoint) {
          j.classList.remove("sticky-save");

          _this.isSaveStuck = false;
        }
      }
    };
  }

  private stopWatchScroll() {
    window.onscroll = null;
  }

  private static getDistance(h: any): any {
    return h.offsetTop;
  }

  public cancelForm() {
    this.cancelEditArticle();
  }

  protected minimizeAllEditors() {
    for (let name in CKEDITOR.instances) {
      if (
        CKEDITOR.instances[name].getCommand("maximize") != null &&
        CKEDITOR.instances[name].getCommand("maximize").state ===
        CKEDITOR.TRISTATE_ON
      ) {
        CKEDITOR.instances[name].execCommand("maximize");
      }
    }
  }

  protected initializeCkEditors() {
    for (let name in CKEDITOR.instances) {
      CKEDITOR.instances[name].destroy(true);
    }

    if (!CKEDITOR.stylesSet.registered.my_styles) {
      CKEDITOR.stylesSet.add("my_styles", [
        // Block-level styles.
        { name: "Heading 1", element: "h1" },
        { name: "Heading 2", element: "h2" },
        { name: "Heading 3", element: "h3" },
        { name: "Preformatted", element: "pre" },
        // Inline styles.
        {
          name: "Related: One link",
          element: "span",
          attributes: { class: "related-single" },
        },
        {
          name: "Next - One link",
          element: "span",
          attributes: { class: "next-single" },
        },
        {
          name: "Affiliate - One link",
          element: "span",
          attributes: { class: "affiliate-single" },
        },
        {
          name: "Spoiler Alert",
          element: "span",
          attributes: { class: "article-alert" },
        },
        {
          name: "Tip",
          element: "div",
          attributes: { class: "emaki-custom tip" },
        },
        {
          name: "Warning",
          element: "div",
          attributes: { class: "emaki-custom warning" },
        },
        {
          name: "Note",
          element: "div",
          attributes: { class: "emaki-custom note" },
        },
        {
          name: "Expandable",
          element: "div",
          attributes: { class: "emaki-custom expandable" },
        },
        {
          name: "Pullquote",
          element: "div",
          attributes: { class: "emaki-custom pullquote" },
        },
        {
          name: "Promoted",
          element: "div",
          attributes: { class: "emaki-custom promoted" },
        },
        {
          name: "Drop Cap",
          element: "div",
          attributes: { class: "emaki-custom paragraph-dropcap" },
        }
      ]);
    }
    //                {name: '', element: 'span', attributes: {'data-field': 'rating'}},

    CKEDITOR.on("dialogDefinition", function (ev) {

      var dialogName = ev.data.name;
      var dialogDefinition = ev.data.definition;

      //Remove background color and border color in dialog cells properties
      if (dialogName == "cellProperties") {
        // "bgColor"
        // "borderColor"
        const cellProps = dialogDefinition.getContents("info");
        cellProps.remove("borderColor");
        cellProps.remove("bgColor");
      }

      //remove features from tableProperties dialog
      if (dialogName == "tableProperties") {
        var infoTab = dialogDefinition.getContents("info");
        infoTab.remove("txtCaption");
        infoTab.remove("txtSummary");
      }

      //remove features from table dialog
      if (dialogName == "table") {
        // Get the advanced tab reference
        var infoTab2 = dialogDefinition.getContents("advanced");

        //Set the default
        // Remove the 'Advanced' tab completely
        dialogDefinition.removeContents("advanced");

        // Get the properties tab reference
        var infoTab = dialogDefinition.getContents("info");

        // Remove unnecessary bits from this tab
        /// infoTab.remove('txtBorder');
        infoTab.remove("cmbAlign");
        infoTab.remove("txtWidth");
        infoTab.remove("txtHeight");
        // infoTab.remove('txtCellSpace');
        //infoTab.remove('txtCellPad');
        infoTab.remove("txtCaption");
        infoTab.remove("txtSummary");
      }

      if (dialogName == "link") {
        /* Getting the contents of the Target tab */

        var targetTab = dialogDefinition.getContents("target");
        var informationTab = dialogDefinition.getContents("info");
        var advancedTab = dialogDefinition.getContents("advanced");

        //remove the browse server button
        informationTab.remove("browse");

        //moving the target dropdown to the main tab
        var targetField = targetTab.get("linkTargetType");

        targetTab.remove("linkTargetType");
        informationTab.add(targetField);
      }

    });

    let allEditors = [];

    //Directory item CK editor
    this.initCkEditor("article_directory_item_description");
    articleDirectoryItemDescriptionEditor =
      CKEDITOR.instances.article_directory_item_description;
    allEditors.push(articleDirectoryItemDescriptionEditor);

    //Directory item CK editor
    this.initCkEditor("sandbox_directory_item_description");
    sandboxDirectoryItemDescriptionEditor =
      CKEDITOR.instances.sandbox_directory_item_description;
    allEditors.push(sandboxDirectoryItemDescriptionEditor);

    //Directory item CK editor
    this.initCkEditor("republish_directory_item_description");
    republishDirectoryItemDescriptionEditor =
      CKEDITOR.instances.republish_directory_item_description;
    allEditors.push(republishDirectoryItemDescriptionEditor);

    // Main article content
    this.initCkEditor("article_content");
    contentEditor = CKEDITOR.instances.article_content;
    allEditors.push(contentEditor);

    // Article Intro
    //if (!CKEDITOR.instances.article_intro) {
    this.initCkEditor("productReview_intro_text");
    //}
    introTextEditor = CKEDITOR.instances.productReview_intro_text;
    allEditors.push(introTextEditor);

    // Article Sandbox
    //if (!CKEDITOR.instances.article_sandbox) {
    this.initCkEditor("article_sandbox");
    //}
    sandboxEditor = CKEDITOR.instances.article_sandbox;
    allEditors.push(sandboxEditor);

    // republish Sandbox
    this.initCkEditor("article_republish");
    republishEditor = CKEDITOR.instances.article_republish;
    allEditors.push(republishEditor);

    // Product Review Sandbox
    this.initCkEditor("productReviewSandbox_intro_text");
    sandboxIntroTextEditor = CKEDITOR.instances.productReviewSandbox_intro_text;
    allEditors.push(sandboxIntroTextEditor);

    // Product Review Republish
    this.initCkEditor("productReviewRepublish_intro_text");
    republishIntroTextEditor =
      CKEDITOR.instances.productReviewRepublish_intro_text;
    allEditors.push(republishIntroTextEditor);

    // Article FAQ
    //if (!CKEDITOR.instances.article_faq) {
    this.initCkEditor("article_faq");
    //}
    faqEditor = CKEDITOR.instances.article_faq;
    allEditors.push(faqEditor);

    // Product Review Text
    //if(!CKEDITOR.instances.product_review_text) {
    this.initCkEditor("product_review_text");
    prodRevReviewText = CKEDITOR.instances.product_review_text;
    //}
    allEditors.push(prodRevReviewText);

    // Image Description Editor
    this.initCkEditor("image_description");
    imageDescriptionEditor = CKEDITOR.instances.image_description;
    allEditors.push(imageDescriptionEditor);

    // Image Caption Editor
    this.initCkEditor("image_caption");
    imageCaptionEditor = CKEDITOR.instances.image_caption;
    allEditors.push(imageCaptionEditor);

    // Gallery Description
    this.initCkEditor("gallery_description");
    galleryDescriptionEditor = CKEDITOR.instances.gallery_description;
    allEditors.push(galleryDescriptionEditor);

    // Additional Credit
    this.initCkEditor("additional_credit");
    additionalCreditEditor = CKEDITOR.instances.additional_credit;
    allEditors.push(additionalCreditEditor);

    //Gallery credit text
    this.initCkEditor("gallery_credit_text");
    galleryCreditTextEditor = CKEDITOR.instances.gallery_credit_text;
    allEditors.push(galleryCreditTextEditor);

    let that = this;

    this.initCkEditor("bulk_image_description");
    bulkImageDescriptionEditor = CKEDITOR.instances.bulk_image_description;
    bulkImageDescriptionEditor.on("change", function () {
      that.articlesEdit.imagePicker.imagesBulkEdit
        .getTemplateViewModel()
        .description(this.getData());
    });
    allEditors.push(bulkImageDescriptionEditor);

    this.initCkEditor("bulk_image_caption");

    bulkImageCaptionEditor = CKEDITOR.instances.bulk_image_caption;
    bulkImageCaptionEditor.on("change", function () {
      that.articlesEdit.imagePicker.imagesBulkEdit
        .getTemplateViewModel()
        .caption(this.getData());
    });
    allEditors.push(bulkImageCaptionEditor);

     this.initCkEditorDisabled("factualSummary");
     factualSummaryEditor = CKEDITOR.instances.factualSummary;

    //  const toolbarElement = factualSummaryEditor.ui.view.toolbar.element;
    //   toolbarElement.style.display = 'none';

        
     allEditors.push(factualSummaryEditor);
    this.initCkEditorDisabled("simpleSummary");
         simpleSummaryEditor = CKEDITOR.instances.simpleSummary;
     allEditors.push(simpleSummaryEditor);
    this.initCkEditorDisabled("satiricalCommentary");
    satiricalCommentaryEditor = CKEDITOR.instances.satiricalCommentary;
    allEditors.push(satiricalCommentaryEditor);
    // this.initializeSummariesCKEditor("factualSummary");
    // Adds comments to specified editors
    //this.addLinkToolCommand(allEditors);
    this.addImagePickerCommand(allEditors);
    this.addEmbedBlockCommand(allEditors);
    this.addClassMaximize([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
    ]);
    this.addFocusHandler([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
    ]);
    this.addUpdateBlockCommand([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
      faqEditor,
      prodRevReviewText,
      imageDescriptionEditor,
      imageCaptionEditor,
      galleryDescriptionEditor,
      bulkImageDescriptionEditor,
      bulkImageCaptionEditor,
      galleryCreditTextEditor,
    ]);
    this.addTwoColumnCommand([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
      faqEditor,
      prodRevReviewText,
      imageDescriptionEditor,
      imageCaptionEditor,
      galleryDescriptionEditor,
      bulkImageDescriptionEditor,
      bulkImageCaptionEditor,
      galleryCreditTextEditor,
    ]);
    this.addOnClickContentHandler([
      contentEditor,
      sandboxEditor,
      republishEditor,
      faqEditor,
    ]);
    this.addArticlePickerCommand([
      contentEditor,
      sandboxEditor,
      republishEditor,
    ]);
    this.addTagPickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addSensaiVaultCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addVideoPickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addAIKeyPointsCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addDeleteElementCommand([
      contentEditor,
      sandboxEditor,
      republishEditor,
    ]);
    this.addQuicklinksCommandCKEditor([contentEditor, sandboxEditor, republishEditor]);
    //this.addAIContentCommand([ contentEditor ]);

    this.articlesEdit.initTagPickerCkEditors();
  }

  protected minimizeSideNav() {
    if (
      !document
        .getElementsByClassName("btn-sidebar")[0]
        .classList.contains("is-closed")
    ) {
      document
        .getElementsByClassName("btn-sidebar")[0]
        .classList.add("is-closed");
      document.getElementsByClassName("sidenav")[0].classList.add("is-closed");
      document.getElementsByClassName("sidenav")[0].classList.add("is-desable");
      document
        .getElementsByClassName("main-header")[0]
        .classList.add("is-desable");
      document.getElementById("closedHeader").classList.add("is-closed");
      document.getElementById("header").classList.add("is-closed");
      document.getElementById("closedContent").classList.add("is-closed");
    }
  }

  protected maximizeSideNav() {
    document
      .getElementsByClassName("btn-sidebar")[0]
      .classList.remove("is-closed");
    document.getElementsByClassName("sidenav")[0].classList.remove("is-closed");
    document
      .getElementsByClassName("sidenav")[0]
      .classList.remove("is-desable");
    document
      .getElementsByClassName("main-header")[0]
      .classList.remove("is-desable");
    document.getElementById("closedHeader").classList.remove("is-closed");
    document.getElementById("header").classList.remove("is-closed");
    document.getElementById("closedContent").classList.remove("is-closed");
  }

  protected addClassMaximize(editors) {
    editors.forEach(function (editor) {
      editor.on("maximize", function (evt) {
        if (evt.data === CKEDITOR.TRISTATE_ON) {
          document
            .getElementsByClassName("form-side-header")[0]
            .classList.add("editor-maximized");
        } else if (evt.data === CKEDITOR.TRISTATE_OFF) {
          document
            .getElementsByClassName("form-side-header")[0]
            .classList.remove("editor-maximized");
        }
      });
    });
  }

  protected addFocusHandler(editors) {
    let _myThis = this;
    editors.forEach(function (editor) {
      editor.on("focus", function (e) {
        if (e.editor.name == "article_sandbox") {
          _myThis.setIsSandboxContentAvailable(true);
        }

        if (_myThis.isSaveAndStay) {
          _myThis.isSaveAndStay = false;
        }

        _myThis.startAutosave(e.editor.name);

        e.removeListener();
      });
    });
  }

  protected startAutosave(callerName) {
    if (callerName != null) {
      let _myThis = this;
      _myThis.articlesEdit.showAutoSaveMessage(
        "Autosave timer initiated by " + callerName + "."
      );
      console.log(
        "startAutosave timer called. Last saved: " +
        Math.round(
          (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
        )
      );

      console.log("lastUpdateTimer: ", _myThis.lastUpdatedTimer);
      console.log("recoveryTimeout: ", _myThis.recoveryTimeout);

      // initialize lastsaved time
      if (
        typeof _myThis.lastUpdatedTimer === "undefined" ||
        _myThis.lastUpdatedTimer === null
      ) {
        console.log("Initializing lastsaved timer display");
        _myThis.lastUpdatedTimer = setInterval(function () {
          _myThis.displayLastSavedTime();
        }, 5050);
      }

      // set the lastSaved time (even though it wasn't actually saved yet, this is the first time content changed).
      // _myThis.lastSaved = new Date((Date.now()));

      if (
        typeof _myThis.recoveryTimeout === "undefined" ||
        _myThis.recoveryTimeout === null
      ) {
        console.log(
          "Initializing Saving recovery in " +
          _myThis.recoveryDelay +
          " seconds"
        );
        _myThis.recoveryTimeout = setTimeout(function () {
          console.log(
            "Autosaving (automatic timer - originally called by " +
            callerName +
            ")"
          );
          _myThis.save_recovery("automatic");
        }, _myThis.recoveryDelay * 1000);
      }

      // initialize autosave warning if not saved within a specific time period.
      //set timer to save the recovery of content

      console.log("Checking recoveryWarning: ", _myThis.recoveryWarning);
      if (
        typeof _myThis.recoveryWarning === "undefined" ||
        _myThis.recoveryWarning === null
      ) {
        console.log("Initialing recovery warning timer.");
        let timeLastSaved = Math.round(
          (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
        );

        let recoveryWarningTimeout = _myThis.recoveryWarningTimeout;
        // augment recovery warning time by amount since last saved. This extends the warning on the first save request
        recoveryWarningTimeout = recoveryWarningTimeout + timeLastSaved;

        _myThis.recoveryWarning = setInterval(function () {
          // todo: check to see if we are still on edit route?
          let timeSinceRecovery = Math.round(
            (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
          );
          console.log(
            "Last saved time: " +
            Math.round(
              (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
            )
          );
          console.log(
            "Time since last save: " +
            timeSinceRecovery +
            " Warning at: " +
            recoveryWarningTimeout
          );

          if (
            _myThis.hasLastSuccessfulAutosave &&
            recoveryWarningTimeout > _myThis.recoveryWarningTimeout
          ) {
            // reset to regular warning timeout after first/any save
            recoveryWarningTimeout = _myThis.recoveryWarningTimeout;
          }

          _myThis.displayLastSavedTime();

          if (
            timeSinceRecovery > recoveryWarningTimeout &&
            _myThis.recoveryWarningShown === false
          ) {
            console.log("Time since auto save is too long");

            _myThis.articlesEdit.setNoticeMessage(
              "\nYour work hasn't been autosaved in " +
              Math.floor(timeSinceRecovery / 60) +
              " minutes. In order to prevent content loss we recommend that you backup your article content and attempt to save your work manually. \n"
            );
            _myThis.articlesEdit.setIsNoticeVisible(true);
            _myThis.articlesEdit.showAutoSaveMessage(
              "Too long since auto save. Save post manually."
            );
            _myThis.articlesEdit.enableAutosaveBox();
            _myThis.recoveryWarningShown = true;
          }
        }, 55000); // checks every 60-ish seconds
      }
    }
  }

  protected getEditor(target) {
    let editor = null;
    switch (target) {
      case "article_content":
        editor = contentEditor;
        break;
      case "article_intro":
        editor = introTextEditor;
        break;
      case "article_sandbox":
        editor = sandboxEditor;
        break;
      case "article_faq":
        editor = faqEditor;
        break;
      case "article_directory_item_description":
        editor = articleDirectoryItemDescriptionEditor;
        break;
      case "sandbox_directory_item_description":
        editor = sandboxDirectoryItemDescriptionEditor;
        break;
      case "article_republish":
        editor = republishEditor;
        break;
      case "republish_directory_item_description":
        editor = republishDirectoryItemDescriptionEditor;
        break;
      case "featuredTag":
        editor = target;
    }

    return editor;
  }

  protected insertTagElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    let editor = this.getEditor(target);

    //set cursor position to end of current selection - to insert tag after elements
    if (editor != null) {
      if (editor == "featuredTag") {
        //set the featured tag
        //et newData = {"name": element.name, "image":}
        element.isVersusStyle = this.articlesEdit.getIsVersusStyle();
        this.articlesEdit.setFeaturedTags(element);
      } else {
        let range = null;
        let selectionElement = editor.getSelection().getStartElement();

        if (
          selectionElement != null &&
          selectionElement.$ &&
          selectionElement.$.nodeName != "BODY" &&
          selectionElement.$.nodeName != "TD" &&
          selectionElement.getParent() != null
        ) {
          range = editor.createRange();
          range.setStartAt(selectionElement, CKEDITOR.POSITION_AFTER_END);
          range.collapse(true);
        } else if (selectionElement == null) {
          range = editor.createRange();
          range.moveToElementEditEnd(range.root);
        }
        editor.insertHtml(element, "html", range);
      }
    }
  }

  protected insertTagHyperlinkElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    let editor = this.getEditor(target);
    if (editor != null) {
      this.insertTag(element, editor);
    }
  }

  protected editTagElement(element, editor) {
    let tagInsertedFields =
      this.articlesEdit.getTagElementInsertedFieldsInOrder(element);
    this.articlesEdit.setTagGroupTagElements([tagInsertedFields]);
    this.getTag(tagInsertedFields.id);

    this.articlesEdit.editTagElement(element, editor);
  }

  protected editTagGroupElement(element, editor) {
    let tagIds = [];
    let tagGroupFieldsInserted = [];
    for (let child of element.childNodes) {
      if (
        child.nodeName == "DIV" &&
        child.className == "emaki-displayCard tag"
      ) {
        let tagInsertedFields =
          this.articlesEdit.getTagElementInsertedFieldsInOrder(child);
        if (tagInsertedFields.id != null) {
          tagIds.push(tagInsertedFields.id);
          tagGroupFieldsInserted.push(tagInsertedFields);
        }
      }
    }

    this.articlesEdit.setTagGroupTagElements(tagGroupFieldsInserted);

    if (tagIds.length == 1) {
      this.getTags(tagIds);
      this.articlesEdit.editTagElement(element, editor);
    } else if (tagIds.length > 1) {
      this.getTags(tagIds);
      this.articlesEdit.editTagGroup(element, editor);
    }
  }

  protected editVideoCardElement(element, editorName) {
    let videoId = element.dataset.id;
    this.articlesEdit.showVideoPicker(editorName, "in-content");
    this.getVideo(videoId);
    this.articlesEdit.videoPickerHelper.setVideoCardElement(element);
  }

  protected editArticleElement(element, target) {
    this.articlesEdit.editArticleElement(element, target);
  }

  protected addOnClickContentHandler(editors) {
    let _myThis = this;
    editors.forEach(function (editor) {
      editor.on("pluginsLoaded", function (event) {
        editor.on("contentDom", function () {
          var editable = editor.editable();
          editable.attachListener(
            editable,
            "click",
            function (evt) {
              let target = evt.data.getTarget();
              let el = target.$;
              _myThis.onClickCkEditorElement(el, editor);
            },
            null,
            null,
            10
          );
          /*if(editor.name == "article_content"){
                        _myThis.updateKeyPointsButton(_myThis.keyPointsAttempts);
                    }*/
        });
      });
    });
  }

  public onClickCkEditorElement(element, editor, isSensaiChat = false) {

    if(isSensaiChat){
      this.isSensaiChat = true;
    }
    let editorName = editor.name;
    //handle tag
    let foundTag = false;
    let foundGroup = false;
    let foundVideo = false;
    let foundValnetMapPreviewImage = false;

    let tagDisplayCard = this.isTagDisplayCard(element);
    let articleDisplayCard = this.isArticleDisplayCard(element);
    foundValnetMapPreviewImage = this.isValnetMapPreviewImage(element);

    if (articleDisplayCard != null && articleDisplayCard.isSingleArticle) {
      if (articleDisplayCard.isHyperlink) {
        element = articleDisplayCard.element;
        this.editArticleElement(element, editorName);
        return;
      }
      console.log(element);
      element = articleDisplayCard.element;
      this.editArticleElement(element, editorName);
      return;
    }

    if (tagDisplayCard.isSingleTag) {
      foundTag = true;
      element = tagDisplayCard.element;
    }

    if (tagDisplayCard.isGroupTag) {
      element = tagDisplayCard.element;
      foundGroup = true;
      foundTag = false;
    }

    if (tagDisplayCard.isVideoCard) {
      foundVideo = true;
      element = tagDisplayCard.element;
    }

    if (this.articlesEdit.isSectionForTagPicker(editorName)) {
      if (!foundGroup && !foundTag) {
        foundGroup = true;
      }
    }

    if (foundGroup) {
      this.editTagGroupElement(element, editorName);
      return;
    }

    if (foundTag) {
      this.editTagElement(element, editorName);
      return;
    }

    if (foundVideo) {
      this.editVideoCardElement(element, editorName);
    }

    if (foundValnetMapPreviewImage) {
      return;
    }

    //handle image
    if (element.nodeName == "IMG") {
      let imgSrc = element.getAttribute("src");
      if (imgSrc.includes('?')) {
        imgSrc = imgSrc.split('?')[0];
      }
      let isMobileOptimized =
        element.getAttribute("data-mobile-optimized") || "false";
      this.articlesEdit.setImagePickerTarget(imgSrc);

      let target = { element: element, editor: editorName };

      this.articlesEdit.showImagePicker("content-select", target.editor);
      this.setImageMode("content-select");

      this.getImage(imgSrc, isMobileOptimized);
    }
  }

  public isTagDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isVideoCard: false,
      isSingleTag: false,
      isHyperlink: false,
      isGroupTag: false,
      element: originalElement,
    };

    while (element) {
      if (
        (element.nodeName == "DIV" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("tag")) || (element.classList && element.classList.contains("emaki-displayCard") && element.classList.contains("tag"))
      ) {
        elementInfo.isSingleTag = true;
        elementInfo.element = element;
        if (
          element.parentNode.nodeName == "DIV" &&
          element.parentNode.classList.contains("emaki-displayCard-group")
        ) {
          elementInfo.isSingleTag = false;
          elementInfo.isGroupTag = true;
          elementInfo.element = element.parentNode;
          break;
        }
      }

      if (
        element.nodeName === "DIV" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("video")
      ) {
        elementInfo.isVideoCard = true;
        elementInfo.element = element;
      }

      if (
        element.nodeName === "SPAN" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("hyperlink")
      ) {
        elementInfo.isSingleTag = true;
        elementInfo.isHyperlink = true;
        elementInfo.element = element;
      }

      element = element.parentNode;
    }

    return elementInfo;
  }

  public isArticleDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isSingleArticle: false,
      isHyperlink: false,
      element: originalElement,
    };

    while (element) {
      if (
        element.nodeName == "DIV" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("article")
      ) {
        elementInfo.isSingleArticle = true;
        elementInfo.element = element;
        break;
      }

      if (
        (element.nodeName == "SPAN" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("hyperlink-article") &&
        element.classList.contains("hyperlink")) || (element.classList && element.classList.contains("emaki-article-card"))
      ) {
        elementInfo.isSingleArticle = true;
        elementInfo.isHyperlink = true;
        elementInfo.element = element;
        break;
      }

      element = element.parentNode;
    }

    return elementInfo;
  }

  private isValnetMapPreviewImage(element) {

    if (element.nodeName == "IMG" && element.alt == 'Preview Image') {
      let parentElement = element.parentElement;
      if (parentElement.nodeName == "DIV" && parentElement.classList.contains("emaki-embed") && parentElement.classList.contains("valnet_map")) {
        return true;
      }
    }
  }

  protected getImage(imgSrc, isMobileOptimized = "false") {
    if (this.contentImageXHRHdl) {
      this.contentImageXHRHdl.cancelAndReset();
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;

    let formReq_url: string =
      "/api/brand/" + idBrand + "/images/get-content-image/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["imgSrc", imgSrc]);

    formReq_params.push(["isMobileOptimized", isMobileOptimized]);

    this.contentImageXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.contentImageXHRHdl.onReadyStateFunction = this.onImageRequestReturn;
    this.contentImageXHRHdl.execute();
  }

  protected getImagePicker() {
    return this.articlesEdit.getImagePicker();
  }

  protected onImageRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let image = responseParsed.image.data[0];
        if (responseParsed.isMobileOptimized) {
          image.isMobileOptimized =
            String(responseParsed.isMobileOptimized).toLowerCase() === "true";
        } else {
          image.isMobileOptimized = false;
        }
        obj.editImage(image, obj.getImageMode());

        obj.articlesEdit.imagePicker.hideLoading();
      });
    };
  }

  protected editImage(image, mode = "") {
    this.articlesEdit.imagePicker.editImage(image, mode);
  }

  protected showImagePicker(image, mode = "", selectedImages) {
    this.articlesEdit.showImagePicker(image, mode, selectedImages);
  }

  protected addImagePickerCommand(editors) {
    let _myThis = this;
    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showEditorImagePicker(editor);
          },
        };
      }

      if(editor && editor.name !== "additional_credit"){

        editor.addCommand("imagePickerCommand", showMyDialog(this));
        editor.ui.addButton("ImgBtn", {
          // add new button and bind our command
          label: "Insert Images",
          command: "imagePickerCommand",
          toolbar: "insert",
          icon: "/node_modules/ckeditor4/plugins/image2/icons/image.png",
        });
      }

    });
  }

  protected addVideoPickerCommand(editors) {
    let that = this;
    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            that.showVideoPicker(editor);
          },
        };
      }

      editor.addCommand("videoPickerCommand", showMyDialog(this));
      editor.ui.addButton("VideoBtn", {
        // add new button and bind our command
        label: "Insert Videos",
        command: "videoPickerCommand",
        toolbar: "insert",
        icon: "/assets/images/video.png",
      });
    });
  }

  protected addTagPickerCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showTagPicker(editor);
          },
        };
      }

      editor.addCommand("tagPickerCommand", showMyDialog(this));

      editor.ui.addButton("TagBtn", {
        // add new button and bind our command
        label: "Insert Tags",
        command: "tagPickerCommand",
        toolbar: "insert",
        icon: "/assets/images/tag.png",
      });
    });
  }

  protected addSensaiVaultCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showSensaiVault(editor);
          },
        };
      }
      editor.addCommand("sensaiCommand", showMyDialog(this));

      editor.ui.addButton("sensaiBtn", {
        // add new button and bind our command
        label: "Sensai Vault",
        command: "sensaiCommand",
        toolbar: "insert",
        icon: "/assets/images/tag.png",
      });
    });
  }

  protected showSensaiVault(editor) {

    this.articlesEdit.getTemplateViewModel().isSensaiVaultVisible(true);
    this.getSensaiVaultData();

  }

  protected addDeleteElementCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      // Ensure the contextMenu plugin is ready and the custom setup hasn't been added yet
      if (!editor.contextMenu) {
        editor.on("pluginsLoaded", function () {
          _myThis.setupContextMenu(editor);
        });
      } else {
        _myThis.setupContextMenu(editor);
      }
    });
  }

  setupContextMenu(editor) {
    // Define the command if it does not exist
    if (!editor.getCommand("deleteElement")) {
      editor.addCommand("deleteElement", {
        exec: function (edt) {
          var selection = edt.getSelection();
          var element = selection.getStartElement();
          if (element && element.is("span") && element.hasClass("hyperlink")) {
            var range = new CKEDITOR.dom.range(edt.document);
            range.setStartBefore(element);
            range.setEndAfter(element);

            range.deleteContents();
            var textNode = new CKEDITOR.dom.text(
              element.getText(),
              edt.document
            );
            range.insertNode(textNode);

            selection.selectRanges([range]);
          }
        },
      });
    }

    // Add the custom context menu item
    if (editor.contextMenu && !editor._deleteElementMenuAdded) {
      editor.addMenuGroup("deleteGroup");
      editor.addMenuItem("customUnlinkItem", {
        label: "Delete Element",
        command: "deleteElement",
        group: "deleteGroup",
        icon: editor.skinPath + "icons/unlink.png",
      });

      editor.contextMenu.addListener(function (element) {
        if (element && element.is("span") && element.hasClass("hyperlink")) {
          return { customUnlinkItem: CKEDITOR.TRISTATE_OFF };
        }
      });

      editor._deleteElementMenuAdded = true; // Flag to prevent re-adding
    }
  }

  /**
   * @deprecated Link tool is not used anymore on emaki
   */
  protected addLinkToolCommand(editors) {
    editors.forEach((editor) => {
      function showLinkTool(obj) {
        return {
          exec: function (editor) {
            obj.showLinkTool();
          },
        };
      }

      editor.addCommand("linkToolCommand", showLinkTool(this));

      editor.ui.addButton("LinkBtn", {
        // add new button and bind our command
        label: "Link Tool",
        command: "linkToolCommand",
        toolbar: "insert",
      });
    });
  }

  protected addUpdateBlockCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addUpdateBlock(obj) {
        return {
          exec: function (editor) {
            _myThis.addUpdateBlock(editor);
          },
        };
      }

      editor.addCommand("updateBlockCommand", addUpdateBlock(this));

      editor.ui.addButton("UpdateBtn", {
        // add new button and bind our command
        label: "Update",
        command: "updateBlockCommand",
        toolbar: "insert",
      });
    });
  }

  protected addTwoColumnCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addTwoColumns(obj) {
        return {
          exec: function (editor) {
            _myThis.addTwoColumns(editor);
          },
        };
      }

      editor.addCommand("twoColumnCommand", addTwoColumns(this));

      editor.ui.addButton("TwoColumnsBtn", {
        // add new button and bind our command
        label: "Two Columns",
        command: "twoColumnCommand",
        toolbar: "insert",
        icon: "/assets/images/2cols-icon.png",
      });
    });
  }

  protected addAIKeyPointsCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addAIKeyPoints(obj) {
        return {
          exec: function (editor) {
            _myThis.getAIKeyPoints(editor);
          },
        };
      }

      editor.addCommand("keyPointsCommand", addAIKeyPoints(this));

      editor.ui.addButton('KeyPointsBtn', { // add new button and bind our command
        label: "",
        command: 'keyPointsCommand',
        toolbar: 'insert',
      });
    });
  }

  /*
  PME-8871 - Custom Quick Links/Table of Contents Article in CKEditor
  Make BE call to content splitter & return content blocks in format
  Add Table of Contents button to CKEditor that injects formatted toc blocks
  */
  protected getQuicklinkBlocks(editor) {

    if (this.tocXHRHdl) {
      this.tocXHRHdl.cancelAndReset();
    }

    const editorNames = ["article_content", "article_sandbox", "article_republish"];
    if (editorNames.indexOf(editor.name) !== -1) {
      const editorElement = document.getElementById('cke_' + editor.name);
      editorElement.children[1].classList.add('loading');
    } else {
      console.error(`Unknown editor name: ${editor.name}`);
      return;
    }

    editor.setReadOnly(true);

    const idBrand = this.getVnAppZone().app.params.idBrand;
    const idArticle = this.articlesEdit.getId();

    const data = {
      "idArticle": idArticle,
      "content": editor.getData(),
      "editor": editor.name
    };

    let formReq_url: string = `/api/brand/${idBrand}/articles/tableOfContents/get/`;
    let formReq_params: Array<[string, string]> = [["data", JSON.stringify(data)]];

    this.tocXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
    this.tocXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.tocXHRHdl.onReadyStateFunction = this.onGetQuicklinkBlocksReturn;
    this.tocXHRHdl.execute();
  }


  protected onGetQuicklinkBlocksReturn(req, obj) {
    //set editor to be editable otherwise nothing from BE will inject
    contentEditor.setReadOnly(false);
    sandboxEditor.setReadOnly(false);
    republishEditor.setReadOnly(false);
    return () => {

      obj.manageResponse(req, obj, () => {
        const responseParsed = JSON.parse(req.request.response);

        if (!responseParsed || !responseParsed.quickLinks || !responseParsed.headings || !responseParsed.editor) return;

        const headings = responseParsed.headings;
        const quickLinksBlock = responseParsed.quickLinks;
        const editorInstance = CKEDITOR.instances[responseParsed.editor];

        //1. Quicklinks Insertion logic in CKEditor - active cursor position, non-selected cursor position, or first non-empty div, or beginning of article
        editorInstance.focus();

        const selection = editorInstance.getSelection();
        let range = selection ? selection.getRanges()[0] : null;

        const editorContent = editorInstance.document.$;
        const firstDiv = editorContent.querySelector('body > div:not(:empty)') || editorContent.querySelector('body > div'); // Select first non-empty div

        if (range) {
          // Get the start container of the current range
          const rangeStartElement = range.startContainer;
          // Check if the cursor is within or before the first div
          const isCursorAtStart = firstDiv && (firstDiv.contains(rangeStartElement.$) || rangeStartElement.$ === firstDiv);

          if (isCursorAtStart) {
            // Cursor is at or before the first div, so insert after the first div
            range = editorInstance.createRange();
            range.moveToPosition(new CKEDITOR.dom.element(firstDiv), CKEDITOR.POSITION_AFTER_END);
            range.collapse(true);
            editorInstance.insertHtml(quickLinksBlock, 'html', range);
          } else {
            // Insert at the current cursor position if it's not at the start
            editorInstance.insertHtml(quickLinksBlock, 'html', range);
          }
        } else {
          // If no range or selection, insert at the beginning of the editor content
          const newRange = editorInstance.createRange();
          newRange.moveToElementEditablePosition(editorInstance.editable(), true); // Move to the start of the editor
          editorInstance.insertHtml(quickLinksBlock, 'html', newRange);
        }

        // 2.search+replace: find matching h2+h3s in content & replace with headings+id
        let content = editorInstance.getData();
        let editor;
        headings.forEach(heading => {
          content = content.replace(heading.searchTerm, heading.replaceTerm);
        });

        editorInstance.setData(content);

        switch (responseParsed.editor) {
          case "article_content":
            editor = contentEditor;
            break;
          case "article_sandbox":
            editor = sandboxEditor;
            break;
          case "article_republish":
            editor = republishEditor;
            break;
          default:
            return;
        }

      });

      //remove the 'generating' modal after content injection
      ["article_content", "article_sandbox", "article_republish"].forEach(id => {
        document.getElementById(`cke_${id}`).children[1].classList.remove('loading');
      });

    };

  }

  protected addQuicklinksCommandCKEditor(editors) {
    let _myThis = this;

    editors.forEach((editor) => {
      function addTableOfContents(obj) {
        return {
          exec: function (editor) {
            _myThis.getQuicklinkBlocks(editor);
          }
        };
      }
      editor.addCommand("quicklinksCommand", addTableOfContents(this));
      editor.ui.addButton('TableOfContentsBtn', {
        label: "Jump Links",
        title: 'Insert Jump Links',
        command: 'quicklinksCommand',
        toolbar: 'insert',
        icon: '/assets/images/lightning-bolt.png'
      });
    });
  }



  protected addAIContentCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addAIContent(obj) {
        return {
          exec: function (editor) {
            _myThis.getAIContent();
          },
        };
      }

      editor.addCommand("contentCommand", addAIContent(this));

      editor.ui.addButton("ContentBtn", {
        // add new button and bind our command
        label: "",
        command: "contentCommand",
        toolbar: "insert",
      });
    });
  }

  protected addEmbedBlockCommand(editors) {
    let _myThis = this;

    editors.forEach((editor) => {
      function showEmbedDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showEmbedPopUp(editor);
          },
        };
      }
      if(editor && editor.name !== "additional_credit"){

        editor.addCommand("embedBlockCommand", showEmbedDialog(this));

        editor.ui.addButton("EmbedBtn", {
          // add new button and bind our command
          label: "Insert Embeds",
          command: "embedBlockCommand",
          toolbar: "insert",
        });
      }
    });
  }

  protected getSensaiVaultData() {

    if (this.sensaiVaultXHRHdl) {
      this.sensaiVaultXHRHdl.cancelAndReset();
    }

    let formReq_url: string = "/api/sensAI-vault/summarize/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = JSON.parse(ko.toJSON({
      content: contentEditor.getData()
    }));

    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onGetSensaiVaultDataReturn;
    XHRHdl.execute();

  }

  protected onGetSensaiVaultDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {

        if (req.request.status === 200) {
          let responseParsed = JSON.parse(req.request.response);
          obj.articlesEdit.getTemplateViewModel().sensaiVaultGeneratedHtml(responseParsed.articleCardsHtml)
        }

      });
    }
  }

  public getArticleId(){

    return this.articlesEdit.getId();
  }

  protected getAIKeyPoints(editor) {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }

    if (editor.name == "article_content") {
      document
        .getElementById("cke_article_content")
        .children[1].classList.add("is-generating");
    } else if (editor.name == "article_sandbox") {
      document
        .getElementById("cke_article_sandbox")
        .children[1].classList.add("is-generating");
    } else if (editor.name == "article_republish") {
      document
        .getElementById("cke_article_republish")
        .children[1].classList.add("is-generating");
    }

    editor.setReadOnly(true);

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();

    let data = {
      idArticle: idArticle,
      content: editor.getData(),
      editor: editor.name,
    };

    //let formReq_url: string = '/api/brand/' + idBrand + '/ai-tools/key-takeaways/get/';
    let formReq_url: string =
      "/api/brand/" + idBrand + "/ai-tools/key-points/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIKeyPointsReturn;
    this.keyPointsXHRHdl.execute();
  }

  protected onGetAIKeyPointsReturn(req, obj) {
    return function () {
      contentEditor.setReadOnly(false);
      sandboxEditor.setReadOnly(false);
      republishEditor.setReadOnly(false);
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.keyPoints) {
          let tag =
            '<div class="emaki-custom key-points"><ul class="key-points-list">';

          let keyPoints = responseParsed.keyPoints;
          for (let i = 0; i < keyPoints.length; i++) {
            tag = tag + '<li class="key-points-item">' + keyPoints[i] + "</li>";
          }

          tag = tag + "</ul></div>";

          if (responseParsed.editor == "article_content") {
            let tagElement = CKEDITOR.dom.element.createFromHtml(
              tag,
              contentEditor.document
            );
            contentEditor.insertHtml("&nbsp;");
            contentEditor.insertElement(tagElement);
          } else if (responseParsed.editor == "article_sandbox") {
            let tagElement = CKEDITOR.dom.element.createFromHtml(
              tag,
              sandboxEditor.document
            );
            sandboxEditor.insertHtml("&nbsp;");
            sandboxEditor.insertElement(tagElement);
          } else if (responseParsed.editor == "article_republish") {
            let tagElement = CKEDITOR.dom.element.createFromHtml(
              tag,
              republishEditor.document
            );
            republishEditor.insertHtml("&nbsp;");
            republishEditor.insertElement(tagElement);
          }

          //obj.updateKeyPointsButton(responseParsed.generationAttempts);
        }
      });
      document
        .getElementById("cke_article_content")
        .children[1].classList.remove("is-generating");
      document
        .getElementById("cke_article_sandbox")
        .children[1].classList.remove("is-generating");
      document
        .getElementById("cke_article_republish")
        .children[1].classList.remove("is-generating");
    };
  }

  protected updateKeyPointsButton(generationAttempts) {
    let idArticle = this.articlesEdit.getId();
    let remainingAttempts = 3;
    if (generationAttempts) {
      this.keyPointsAttempts = generationAttempts;
      remainingAttempts = remainingAttempts - generationAttempts;
      if (remainingAttempts <= 0) {
        remainingAttempts = 0;
      }
    }
    let buttonElements = document.getElementsByClassName(
      "cke_button__keypointsbtn"
    );
    if (remainingAttempts == 0 || !idArticle) {
      // Disable the button
      if (buttonElements.length !== 0) {
        for (let element of buttonElements) {
          element.classList.add("is-disable");
          element.setAttribute(
            "title",
            "Key Takeaways ; " + remainingAttempts + " credits left"
          );
        }
      }
    } else {
      //enable the button
      if (buttonElements.length !== 0) {
        for (let element of buttonElements) {
          element.classList.remove("is-disable");
          element.setAttribute(
            "title",
            "Key Takeaways ; " + remainingAttempts + " credits left"
          );
        }
      }
    }
    let labelElements = document.getElementsByClassName(
      "cke_button__keypointsbtn_label"
    );
    if (labelElements.length !== 0) {
      for (let element of labelElements) {
        element.textContent = "" + remainingAttempts + "";
      }
    }
  }

  protected getAutoCategorization(type) {
    if (this.autoCategorizeXHRHdl) {
      this.autoCategorizeXHRHdl.cancelAndReset();
    }

    document
      .getElementById("categorize-section")
      .classList.add("is-generating");
    document.getElementById("helper-button").classList.add("is-generated");

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();

    let data = {
      idArticle: idArticle,
      content: contentEditor.getData(),
      type: type,
    };

    let formReq_url: string =
      "/api/brand/" + idBrand + "/ai-tools/auto-categorization/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.autoCategorizeXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.autoCategorizeXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.autoCategorizeXHRHdl.onReadyStateFunction =
      this.onGetAutoCategorizationReturn;
    this.autoCategorizeXHRHdl.execute();
  }

  protected onGetAutoCategorizationReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.categories) {
          obj.articlesEdit.setAICategories(responseParsed.categories);
        }

        if (responseParsed.tags) {
          obj.articlesEdit.setAITags(responseParsed.tags);
        }

        if (responseParsed.generationAttempts) {
          obj.articlesEdit.setAutoCategorizationGenerationAttemptsRemaining(
            responseParsed.generationAttempts
          );
        }
      });
      document.getElementById("helper-button").classList.remove("is-generated");
      document
        .getElementById("categorize-section")
        .classList.remove("is-generating");
    };
  }

  protected initCkEditor(idElement) {
    let height, toolbarMA;
    let disallowedContent = "p";
    //contextmenu,tabletools,tableselection
    let removePlugins = "elementspath,liststyle,image,forms";
    if (
      idElement == "article_directory_item_description" ||
      idElement == "sandbox_directory_item_description"
    ) {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Source",
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "ImgBtn",
          "VideoBtn",
          "sensaiBtn",
          "Bold",
          "Italic",
          "Strike",
          "-",
          "LinkBtn",
          "Maximize",
        ],
      ];
      height = "500px";
    } else if (
      idElement == "image_description" ||
      idElement == "image_caption" ||
      idElement == "gallery_description" ||
      idElement == "gallery_credit_text"
    ) {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "Bold",
          "Italic",
          "Strike",
          "-",
          "LinkBtn",
          "Maximize",
        ],
      ];
      height = "125px";
    } else if (
      idElement == "bulk_image_description" ||
      idElement == "bulk_image_caption"
    ) {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "Bold",
          "Italic",
          "Strike",
          "-",
          "LinkBtn",
          "Maximize",
        ],
      ];
      height = "75px";
    }
    else if (idElement == "additional_credit") {
      disallowedContent = "*"; // Disallow everything by default
      removePlugins += ",list,table,image,forms,video,blockquote";

      toolbarMA = [
        [
          "Bold",
          "Italic",
          "Link",
          "Unlink"
        ],
      ];

      height = "75px";

      // override extraAllowedContent to allow only those tags
    }
    else {
      height = "500px";
      //height = '1500px';
      toolbarMA = [
        [
          "Source",
          "-",
          "Cut",
          "Copy",
          "Paste",
          "-",
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "Table",
          "TwoColumnsBtn",
          "HorizontalRule",
          "SpecialChar",
          "ImgBtn",
          "VideoBtn",
          "sensaiBtn",
          "TagBtn",
          "ArticleBtn",
          "TableOfContentsBtn",
          "EmbedBtn",
          "UpdateBtn",
          "KeyPointsBtn",
          "ContentBtn",
          "Styles"
        ],
        [
          "Bold",
          "Italic",
          "Strike",
          "NumberedList",
          "BulletedList",
          "-",
          "Blockquote",
          "LinkBtn",
          "Maximize",
        ],
      ];
    }
    var extraAllowedContent = "";
    if(idElement == "additional_credit"){
      extraAllowedContent = "a[href];strong;em;b;i";
    }else{
      extraAllowedContent ="span(*)[!data-*,contenteditable]{background-image};img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];source(*){*}[*];style[*]{*}";
    }

    CKEDITOR.replace(idElement, {
      height: height,
      toolbar: "MA",
      fillEmptyBlocks: false,
      extraAllowedContent: extraAllowedContent,
      disallowedContent: disallowedContent,
      removePlugins: removePlugins,
      stylesSet: "my_styles",
      format_tags: "p;h1;h2;h3",
      format_p: {
        element: "p",
      },
      toolbar_MA: toolbarMA,
    });

    //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
    //'Outdent','Indent'

    //CKEDITOR.config.toolbar_MA = toolbarMA;

    CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;
    CKEDITOR.config.fillEmptyBlocks = false;
    CKEDITOR.config.contentsCss = [
      CKEDITOR.getUrl("contents.css"),
      "/css/cke_style.css?v=8.1",
    ];

    //CKEDITOR.config.disallowedContent = 'p';

    CKEDITOR.config.skin = "n1theme";
    //CKEDITOR.config.skin ="kama";
    //CKEDITOR.config.skin ="moono";
    //CKEDITOR.config.skin ="moono-lisa";
    CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
    //CKEDITOR.config.extraPlugins ="justify";
    //CKEDITOR.config.extraPlugins ="colorbutton";

    CKEDITOR.config.forcePasteAsPlainText = false;
    contentEditor = CKEDITOR.instances.article_content;
    sandboxEditor = CKEDITOR.instances.article_sandbox;
    republishEditor = CKEDITOR.instances.article_republish;

    CKEDITOR.config.wordcount = {
      // Whether or not you want to show the Paragraphs Count
      showParagraphs: false,

      // Whether or not you want to show the Word Count
      showWordCount: true,

      // Whether or not you want to show the Char Count
      showCharCount: true,
    };

    CKEDITOR.on("instanceReady", function (event: any) {
      let editor = event.editor;
      let dataProcessor = editor.dataProcessor;

      if (dataProcessor != null) {
        let htmlFilter = dataProcessor.htmlFilter;
        htmlFilter.addRules({
          elements: {
            p: function (element: any) {
              let parent = element.parent;
              if (parent && parent.name.toLowerCase() == "blockquote") {
                element.name = "";
              }
              return element;
            },
          },
        });
      }
    });
  }  
  
  protected initCkEditorDisabled(idElement) {
    let height, toolbarMA;
   

    CKEDITOR.replace(idElement, {
      height: height,
      toolbar: [],
      readOnly: true,
     
      stylesSet: "my_styles",
      format_tags: "p;h1;h2;h3",
      format_p: {
        element: "p",
      }
    });

    

    CKEDITOR.config.skin = "n1theme";
   
    CKEDITOR.config.wordcount = {
      // Whether or not you want to show the Paragraphs Count
      showParagraphs: false,

      // Whether or not you want to show the Word Count
      showWordCount: true,

      // Whether or not you want to show the Char Count
      showCharCount: true,
    };

    CKEDITOR.on("instanceReady", function (event: any) {
      let editor = event.editor;
      let dataProcessor = editor.dataProcessor;

      if (dataProcessor != null) {
        let htmlFilter = dataProcessor.htmlFilter;
        htmlFilter.addRules({
          elements: {
            p: function (element: any) {
              let parent = element.parent;
              if (parent && parent.name.toLowerCase() == "blockquote") {
                element.name = "";
              }
              return element;
            },
          },
        });
      }
    });
  }

  protected showEditorImagePicker(editor, keyword = null) {
    if (editor.name == "article_faq") {
      this.articlesEdit.showImagePicker("single-select", editor.name);
    } else {
      this.articlesEdit.showImagePicker("multi-select", editor.name, keyword);
    }
  }

  protected showVideoPicker(editor) {
    this.articlesEdit.showVideoPicker(editor.name);
  }

  protected showTagPicker(editor) {
    this.articlesEdit.tagPicker.resetPagination();
    this.getTagData();
    if (editor !== null && editor == "featuredTag") {
      this.articlesEdit.showTagPicker("in-content", editor);
    } else {
      let selectedText = editor.getSelection().getNative().toString();
      this.articlesEdit.showTagPicker("in-content", editor.name, selectedText);
    }
  }

  protected showLinkTool() {
    let url =
      "https://datastudio.google.com/u/0/reporting/1JtF204Vz8MIa9DhToLzu4Ou2bIqTSuVt/page/4uYeB";
    //launch the link tool in new tab
    var element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected showEmbedPopUp(editor) {
    this.articlesEdit.setActiveCkEditorInstance(editor);
    this.articlesEdit.toggleEmbedPopUp(true);
    this.articlesEdit.setEmbedSourceFocused(true);
  }

  protected addUpdateBlock(editor) {
    let d = new Date();
    let dformat =
      [
        d.getFullYear(),
        ("0" + (d.getMonth() + 1)).slice(-2),
        ("0" + d.getDate()).slice(-2),
      ].join("/") +
      " " +
      [("0" + d.getHours()).slice(-2), ("0" + d.getMinutes()).slice(-2)].join(
        ":"
      ) +
      " EST";
    let authorName =
      this.getVnAppZone().app.loggedUser.user.valnet_user.fullName;
    let tag =
      '<div class="emaki-custom update"><h3>UPDATE: ' +
      dformat +
      " BY " +
      authorName.toUpperCase() +
      "</h3><strong><em>Title Here..</em></strong><br><br>Text Here..</div>";

    var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
    editor.insertElement(tagElement);
  }

  protected addTwoColumns(editor) {
    let tag = '<table border="1" cellpadding="1" cellspacing="1"><tbody><tr><td>&nbsp;</td><td>&nbsp;</td></tr></tbody></table>';

    var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
    editor.insertElement(tagElement);
  }

  protected addAIKeyPoints(editor) {
    this.getAIKeyPoints(editor);

    //lock button behind permissions
    //call api and return/replace
  }

  protected getAIScores() {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }
    this.articlesEdit.showSubjectCoverageLoading("ai-subject-coverage");
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();
    let content = this.articlesEdit.getArticleContent();

    let data = { idArticle: idArticle, content: content };

    let formReq_url: string =
      "/api/brand/" +
      idBrand +
      "/ai-tools/content-value-suggestions-embeddings/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIContentReturn;
    this.keyPointsXHRHdl.execute();
  }

  protected getSingleAIScore(data, target = "ai-subject-coverage") {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }

    this.articlesEdit.showScoreLoading(target);
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();
    let content = this.articlesEdit.getArticleContent();

    data = { idArticle: idArticle, content: content, idSuggestion: data.id };

    let formReq_url: string =
      "/api/brand/" +
      idBrand +
      "/ai-tools/content-value-suggestions-embeddings/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetSingleAIContentReturn;
    this.keyPointsXHRHdl.execute();
  }

  protected getAIContent(
    isGeneratePressed = false,
    isRequestFromPrompt = false
  ) {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }

    if (isRequestFromPrompt) {
      this.articlesEdit.sensaiPromptTemplate.showLoading();
    } else {
      this.articlesEdit.showSubjectCoverageLoading("ai-subject-coverage");
    }
    let idBrand = this.getVnAppZone().app.params.idBrand;

    let data = {
      articleData: ko.toJSON(this.getSavePostData()),
      isGeneratePressed: isGeneratePressed,
    };

    let formReq_url: string =
      "/api/brand/" + idBrand + "/ai-tools/content-value-suggestions/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    if (isRequestFromPrompt) {
      this.keyPointsXHRHdl.onReadyStateFunction =
        this.onGetAIContentReturnForPrompt;
    } else {
      this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIContentReturn;
    }
    this.keyPointsXHRHdl.execute();
  }
  protected onGetSingleAIContentReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let coverageResults = responseParsed.coverageResults;
        obj.articlesEdit.articleReviewHistory.setSingleSubjectCoverage(
          coverageResults
        );
      });

      obj.articlesEdit.hideScoreLoading();
    };
  }

  protected onGetAIContentReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let coverageResults = responseParsed.coverageResults;
        let sensaiCoverageScore = obj.calculateCoverageScore(coverageResults);
        obj.articlesEdit.setSensaiCoverageScore(sensaiCoverageScore);
        obj.articlesEdit.setTotalSensaiScore();
        // obj.articlesEdit.sensaiPromptTemplate.setSensaiCoverageScore(sensaiCoverageScore);

        // obj.articlesEdit.articleReviewHistory.setTotalSensaiScore(sensaiCoverageScore);
        // obj.articlesEdit.sensaiProgressBar.setScore(obj.articlesEdit.articleReviewHistory.getTotalSensaiScore(), obj.articlesEdit.getSensaiRulePointThreshold());
        obj.articlesEdit.articleReviewHistory.setSubjectCoverage(
          coverageResults
        );
      });

      obj.articlesEdit.hideSubjectCoverageLoading("ai-subject-coverage");
    };
  }

  protected onGetAIContentReturnForPrompt(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let coverageResults = responseParsed.coverageResults;
        let sensaiCoverageScore = obj.calculateCoverageScore(coverageResults);
        obj.articlesEdit.setSensaiCoverageScore(sensaiCoverageScore);
        obj.articlesEdit.setTotalSensaiScore();

        // obj.articlesEdit.articleReviewHistory.setSensaiCoverageScore(sensaiCoverageScore);
        // obj.articlesEdit.sensaiPromptTemplate.setSensaiCoverageScore(sensaiCoverageScore);
        // obj.articlesEdit.articleReviewHistory.setTotalSensaiScore(sensaiCoverageScore);
        obj.articlesEdit.sensaiPromptTemplate.setSubjectCoverage(
          coverageResults
        );
      });

      obj.articlesEdit.sensaiPromptTemplate.removeLoading();
    };
  }

  public calculateCoverageScore(coverageResults) {
    //let currentScore = this.articlesEdit.getTotalSensaiScore();
    let totalScore = 0;
    let reliableScore = 0;

    if (coverageResults && Array.isArray(coverageResults)) {
      coverageResults.forEach((element) => {
        totalScore += element.sensaiCoverageScore;
        if (element.reliabilityFeedback == "Reliable") {
          reliableScore++;
        }
      });
    }

    if (reliableScore != 0) {
      totalScore = 20 * (totalScore / (reliableScore * 2) / 0.8);

      if (totalScore > 20) {
        totalScore = 20;
      }
    }

    return totalScore;
  }

  public saveFeedback() {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }
    this.articlesEdit.showSubjectCoverageLoading("ai-subject-coverage");
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();
    let suggestions = this.articlesEdit.getSubjectCoverage();
    let data = { idArticle: idArticle, suggestions: suggestions };

    let formReq_url: string =
      "/api/brand/" +
      idBrand +
      "/ai-tools/content-value-suggestions-feedback/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIContentReturn;
    this.keyPointsXHRHdl.execute();
  }

  public getFaqAnswer() {
    return faqEditor.getData();
  }

  public setFaqAnswer(answer) {
    faqEditor.setData(answer, function () {
      this.resetUndo();
    });
  }

  public setDirectoryItemCkEditorData(data) {
    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "article") {
      articleDirectoryItemDescriptionEditor.setData(data, function () {
        this.resetUndo();
      });
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "sandbox") {
      sandboxDirectoryItemDescriptionEditor.setData(data, function () {
        this.resetUndo();
      });
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "republish") {
      republishDirectoryItemDescriptionEditor.setData(data, function () {
        this.resetUndo();
      });
    }
  }

  public getDirectoryItemCkEditorData() {
    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "article") {
      return articleDirectoryItemDescriptionEditor.getData();
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "sandbox") {
      return sandboxDirectoryItemDescriptionEditor.getData();
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "republish") {
      return republishDirectoryItemDescriptionEditor.getData();
    }
  }

  // public setArticleDirectoryItemCkEditorData(data) {
  //
  //     articleDirectoryItemDescriptionEditor.setData(data, function () {
  //         this.resetUndo();
  //     });
  // }
  //
  // public getArticleDirectoryItemCkEditorData() {
  //
  //     return articleDirectoryItemDescriptionEditor.getData();
  // }
  //
  //
  // public setSandboxDirectoryItemCkEditorData(data) {
  //
  //     sandboxDirectoryItemDescriptionEditor.setData(data, function () {
  //         this.resetUndo();
  //     });
  // }
  //
  // public getSandboxDirectoryItemCkEditorData() {
  //
  //     return sandboxDirectoryItemDescriptionEditor.getData();
  // }

  public setImageDescription(description) {
    imageDescriptionEditor.setData(description, function () {
      this.resetUndo();
    });
  }

  public setImageCaption(caption) {
    imageCaptionEditor.setData(caption, function () {
      this.resetUndo();
    });
  }

  public setGalleryDescription(description) {
    galleryDescriptionEditor.setData(description, function () {
      this.resetUndo();
    });
  }

  public setGalleryCreditText(creditText) {
    galleryCreditTextEditor.setData(creditText, function () { })
  }

  public getGalleryCreditText() {
    return galleryCreditTextEditor.getData();
  }

  public getImageDescription(description) {
    return imageDescriptionEditor.getData();
  }

  public getGalleryDescription(description) {
    return galleryDescriptionEditor.getData();
  }

  public getImageCaption(description) {
    return imageCaptionEditor.getData();
  }

  public clearFaqAnswer() {
    faqEditor.setData(null);
  }

  public getBulkImageDescription() {
    return bulkImageDescriptionEditor.getData();
  }

  public getBulkImageCaption() {
    return bulkImageCaptionEditor.getData();
  }

  protected getArticleReferences() {
    // LOADING : starts
    this.loadingIn(this.articlesEdit.builtTemplate);
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/references";
    let usrReq_params: Array<Array<string>> = [];
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onReferenceRequestReturn;
    this.XHRHdl.execute();
  }

  protected getArticleAnalytics() {
    // LOADING : starts
    if (this.XHRHdls["getArticleAnalytics"]) {
      this.XHRHdls["getArticleAnalytics"].cancelAndReset();
    }
    if (
      this.articlesEdit.getTopKeyWordAnalytics() == null ||
      this.articlesEdit.getTopKeyWordAnalytics().length < 1
    ) {
      this.loadingIn(this.articlesEdit.builtTemplate);

      let idBrand = this.getVnAppZone().getApp().params.idBrand;
      let idArticle = this.getVnAppZone().getApp().params.id;

      let usrReq_url: string =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/topKeywordAnalytics/get/" +
        this.getVnAppZone().app.params.id;
      let usrReq_params: Array<Array<string>> = [];

      this.XHRHdls["getArticleAnalytics"] = new XMLHttpRequestHandler(
        usrReq_url,
        usrReq_params,
        this
      );
      this.XHRHdls["getArticleAnalytics"].onReadyStateFunction =
        this.onGetKeywordAnalyticsReturn;
      this.XHRHdls["getArticleAnalytics"].execute();
    }
  }

  protected onGetKeywordAnalyticsReturn(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.setTopKeyWordAnalytics(responseParsed);
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected getShortTermReport() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    chartDiv = document.getElementById("shortTermReportChart");
    if (chartDiv) {
      this.loadingIn(chartDiv);
    }

    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let idArticle = this.getVnAppZone().getApp().params.id;

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/shortTermReport/get/" +
      this.getVnAppZone().app.params.id;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push([
      "data",
      this.articlesEdit
        .getArticleAnalytics()
        .getTemplateViewModel()
        .shortTermReportRange(),
    ]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetShortTermReportReturn;
    this.XHRHdl.execute();
  }

  protected onGetShortTermReportReturn(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(
          req.request.response,
          function (key, value) {
            if (
              key == "date" ||
              key == "publishDate" ||
              key == "republishDate"
            ) {
              return new Date(value);
            } else {
              return value;
            }
          }
        );
        obj.articlesEdit.setShortTermReport(responseParsed);
      });
      if (obj.getChartDiv()) {
        obj.loadingOut(obj.getChartDiv());
      }
    };
  }

  protected onReferenceRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        obj.publishStatuses = responseParsed.publishStatuses;
        obj.articlesEdit.setPublishStatuses(responseParsed.publishStatuses);
        obj.articlesEdit.setArticleStatusOptions(responseParsed.statuses);
        obj.articlesEdit.setPermissions(responseParsed.permissions);
        obj.articlesEdit.setBrand(responseParsed.brand);
        obj.articlesEdit.setListOrder(responseParsed.defaultListOrder);
        let networkCategories = responseParsed.networkCategories;
        networkCategories.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setNetworkCategoryOptions(networkCategories);
        let paymentCategories = responseParsed.postPaymentCategory;
        paymentCategories.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setPaymentCategoryOptions(paymentCategories);
        let intents = responseParsed.intent;
        intents.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setIntentOptions(intents);
        let contentTypes = [...responseParsed.contentType];
        contentTypes.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setContentTypeOptions(contentTypes);

        let segments = responseParsed.segments;
        obj.articlesEdit.setSegmentOptions(segments);

        const classification = responseParsed.classification;
        obj.articlesEdit.setClassificationOptions(classification);
        obj.articlesEdit.setClassificationAllOptions(classification);

        obj.articlesEdit.setCategoryFilterItems(responseParsed.categories);
        obj.articlesEdit.setContentPresets(responseParsed.contentPresets);
        //let productTypes = responseParsed.tagTypes;
        //productTypesobj.articlesEdit.setProductTypeOptions(productTypes);//TODO: Remove this along with any unnecessary related code
        let tagAwards = responseParsed.tagAwards;
        obj.articlesEdit.setReviewItemTagOptions(tagAwards);

        obj.articlesEdit.setPollOptions(responseParsed.polls);

        obj.articlesEdit.setAffiliateLinksOptions(responseParsed.affiliates);

        obj.articlesEdit.setAmazonOnsite(responseParsed.amazonOnsite);
        obj.articlesEdit.setNewsletterServiceType(
          responseParsed.newsletterServiceType
        );

        obj.articlesEdit.tagPicker.setTagViewBadgeOptions(
          responseParsed.badges
        );
        obj.articlesEdit.setDefaultFeaturedTags(
          responseParsed.defaultFeaturedTags
        );
        obj.articlesEdit.setDefaultFeaturedImage(
          responseParsed.defaultFeaturedImage
        );

        let validAutoPricingPartnerNames = [];
        if (responseParsed.validAutoPricingPartnerNames) {
          validAutoPricingPartnerNames =
            responseParsed.validAutoPricingPartnerNames;
          obj.articlesEdit.setValidAutoPricingPartnerNames(
            validAutoPricingPartnerNames
          );
        }
        obj.articlesEdit.setNewsletterTemplates(
          responseParsed.newsletterTemplates
        );
        obj.articlesEdit.setNewsletterMailingLists(responseParsed.mailingLists);

        obj.articlesEdit.setArticlePageSettings(
          responseParsed.articlePagesSettings
        );
        //obj.articlesEdit.setAuthorPrompts(responseParsed.authorAgreements);
        obj.articlesEdit.setSegments(responseParsed.segments);

        obj.articlesEdit.articlePicker.setNetworkCategoryFilterItems(
          responseParsed.groupCategory
        );
        let articlePickerContentTypes = [...responseParsed.contentType];
        articlePickerContentTypes.sort((a, b) => a.index - b.index);
        obj.articlesEdit.articlePicker.setContentTypeFilterItems(
          articlePickerContentTypes
        );
        obj.articlesEdit.articlePicker.setCategoryFilterItems(
          responseParsed.categories
        );
        obj.articlesEdit.articlePicker.setClassificationFilterItems(
          responseParsed.classification
        );
        obj.articlesEdit.articlePicker.setIntentFilterItems(
          responseParsed.intents || []
        );

        let videoPickerContentTypes = articlePickerContentTypes;
        videoPickerContentTypes.unshift({ id: null, name: "Select an Option" });

        obj
          .getVideoPickerTemplate()
          .setCategoryFilter(responseParsed.categories);
        let contentTypeNames = [
          "Trailer",
          "Guide",
          "Feature",
          "News",
          "List",
          "Interview",
          "Podcast",
          "Review",
        ];
        //loop through contentTypes and if name matches any of the content type names create new array
        let filteredContentTypes = [];
        for (let i = 0; i < contentTypeNames.length; i++) {
          let contentType = contentTypeNames[i];
          let option = videoPickerContentTypes.find(
            (x) => x.name == contentType
          );
          if (option) {
            filteredContentTypes.push(option);
          }
        }
        obj
          .getVideoPickerTemplate()
          .setContentTypeFilter(videoPickerContentTypes);
        obj.getVideoPickerEditTemplate().setContentTypes(filteredContentTypes);
        obj
          .getVideoPickerEditTemplate()
          .setCategories(responseParsed.categories);

        let subtitlesLanguages = responseParsed.languages;
        //subtitlesLanguages.unshift({ id: null, name: "Select an Option" });
        obj
          .getVideoPickerEditTemplate()
          .setSubtitlesLanguages(subtitlesLanguages);

        obj.articlesEdit.setTemplateLayouts(responseParsed.templateLayouts);

        obj.editArticleData();
      });
    };
  }

  protected setPublishStatusOptions(article_data) {
    let permissions = this.articlesEdit.getPermissions();
    let publishStatus_options = this.publishStatuses;

    //1=unpublished,2=scheduled,3=published,4=republished
    let allowedStatusIds = [1, 2, 3];
    //completed
    if (article_data["status"]["id"] == 6) {
      //unpublished
      if (
        article_data["publishStatus"]["id"] == 1 &&
        !permissions["article_edit_publishingControl"].write
      ) {
        allowedStatusIds = [1];
      } else if (
        article_data["publishStatus"]["id"] != 1 &&
        article_data["publishStatus"]["id"] != 4
      ) {
        allowedStatusIds = [1, 2, 3];
      } else if (article_data["publishStatus"]["id"] == 4) {
        allowedStatusIds = [1, 2, 3, 4];
      }
    } else {
      allowedStatusIds = [1];
    }

    let status_options = publishStatus_options.filter(function (item) {
      return allowedStatusIds.indexOf(item.id) != -1;
    });

    this.articlesEdit.setPublishStatuses(status_options);
  }

  protected setArticleStatusOptions(article_data) {
    let permissions = this.articlesEdit.getPermissions();
    let articleStatus_options = this.articlesEdit.getArticleStatusOptions();
    let articleRepublishStatus_options = articleStatus_options;

    //1=draft,2=submittedforapproval,3=changesrequired,6=completed,7=trashed
    let allowedStatusIds = [1, 2, 3, 6, 7];

    //unpublished
    if (
      article_data["publishStatus"]["id"] == 1 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedStatusIds = [1, 2, 3, 7];
    } else if (article_data["publishStatus"]["id"] != 1) {
      allowedStatusIds = [6, 7];
    }

    //if completed and user has publishing control, allow any status
    if (
      article_data["status"]["id"] == 6 &&
      permissions["article_edit_publishingControl"].write
    ) {
      allowedStatusIds = [1, 2, 3, 6, 7];
    } else if (
      article_data["status"]["id"] == 6 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedStatusIds = [6];
    }

    let status_options = articleStatus_options.filter(function (item) {
      return allowedStatusIds.indexOf(item.id) != -1;
    });

    this.articlesEdit.setArticleStatusOptions(status_options);

    //repeat for trashed
    //1=draft,2=submittedforapproval,3=changesrequired,6=completed,7=trashed
    let allowedRepublishStatusIds = [1, 2, 3, 6];

    let idRepublishStatus = null;
    article_data["jsonSaves"].forEach((save) => {
      if (save.type === "republish") {
        let content = JSON.parse(save.content);
        idRepublishStatus = content.status.id;
      }
    });

    //unpublished
    if (
      idRepublishStatus != 6 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedRepublishStatusIds = [1, 2, 3];
    } else if (
      idRepublishStatus == 6 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedRepublishStatusIds = [6];
    }

    let republish_status_options = articleRepublishStatus_options.filter(
      function (item) {
        return allowedRepublishStatusIds.indexOf(item.id) != -1;
      }
    );

    this.articlesEdit.setArticleRepublishStatusOptions(
      republish_status_options
    );
  }

  public filterMultipleSelectorOnChange(idElement) {
    if (
      idElement == "categoryFilter" ||
      idElement == "categoryVideoFilter" ||
      idElement == "contentTypeVideoFilter"
    ) {
      this.articlesEdit.videoPickerHelper.resetPagination();
      this.getVideosData();
    } else if (idElement == "filterVideoCategoryEdit") {
      this.getVideoPickerEditTemplate().updateSelectedCategories();
    } else {
      this.articlesEdit.updateSelectedCategories();
    }
  }

  protected getPaymentCategories() {
    let usrReq_url: string;

    usrReq_url =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/transaction/rate-categories/get";

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push();
    this.paymentCategoryXHR = new XMLHttpRequestHandler(
      usrReq_url,
      usrReq_params,
      this
    );
    this.paymentCategoryXHR.onReadyStateFunction =
      this.onGetPaymentCategoriesRequestReturn;
    this.paymentCategoryXHR.execute();
  }

  protected onGetPaymentCategoriesRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updatePaymentCategoryList(responseParsed.data);
      });
    };
  }

  protected updatePaymentCategoryList(responseParsed: any) {
    let paymentCategories = [];
    paymentCategories.push({ id: null, name: "Select an Option" });
    for (let item of responseParsed.paymentCategories) {
      paymentCategories.push(item);
    }

    this.viewModel.edit_template_new.paymentCategoryFilter.setOptions(
      paymentCategories
    );
    this.viewModel.edit_template_new.scheduledRepublishPaymentCategoryFilter.setOptions(
      paymentCategories
    );
  }

  protected editArticleData(takeover = false) {
    this.loadingIn(this.articlesEdit.builtTemplate);
    let id: number;

    if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
      this.articlesEdit.getTemplateViewModel().id(id);
    }

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/getForEdit/" +
      id +
      "?takeover=" +
      takeover;
    let usrReq_params: Array<Array<string>> = [];

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
    this.XHRHdl.execute();
  }

  protected onFilterRequestReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        if (
          req.request.status == 423 &&
          obj.articlesEdit.getPermissions()["article_edit_takeover"] &&
          obj.articlesEdit.getPermissions()["article_edit_takeover"].read
        ) {
          let responseParsed = JSON.parse(req.request.response);

          obj.articlesEdit.setLockMessage(responseParsed.message);
          obj.articlesEdit.setIsLockMessageVisible(true);

          // only show this if not taking over
          //obj.articlesEdit.enableAutosaveBox();

          // Set autosave notice since it could not autosave after a lock
          //obj.articlesEdit.showAutoSaveMessage("Post has been taken over, save changes manually");
        } else {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);

            const {
              article,
              displayAuthors,
              userPreferences,
              directory,
              plagiarismResults,
              defaultThreadsImage,
              permalinkHistory,
              permalinkRedirects,
            } = responseParsed.data;

            obj.articlesEdit.setPermalinkHistory(permalinkHistory);
            obj.articlesEdit.setPermalinkRedirect(permalinkRedirects);

            obj.setArticleStatusOptions(article);
            obj.setArticleData(article);
            obj.setDisplayAuthors(displayAuthors);
            obj.setUserPreferences(userPreferences);
            //Overriding the current request stack with this if statement
            //Params are not detected until the next request

            if (window.location.pathname.includes('/add')) {
              let queryParams = new URLSearchParams(window.location.search);
              if (queryParams.has('videoId')) {
                //Hard coded 15 (video template) but this will be overrided by the autofill anyways
                obj.articlesEdit.setIdTemplate(15);
                let idBrand = obj.getVnAppZone().app.params.idBrand;

                // show the segment selection popup for SR only.
                if (idBrand == 6) {
                  obj.articlesEdit.setShowSegmentTab(true);
                }
              }
              if (queryParams.has('idThreadSuggestion')) {
                let idThreadSuggestion = queryParams.get('idThreadSuggestion');

                obj.articlesEdit.setIdTemplate(16);
              }
            }

            if (responseParsed.data.directory) {
              obj.articlesEdit.setDirectoryArticle(directory);
            }

            //obj.articlesEdit.enableAutosaveBox();
            obj.setPublishStatusOptions(article);
            obj.setPinnedTags(article);
            obj.setPlagiarismResults(plagiarismResults);
            obj.setDefaultThreadsImage(defaultThreadsImage);
            if (responseParsed.data.isAdmin) {
              obj.articlesEdit.setIsAdmin(responseParsed.data.isAdmin);
            }

            obj.setReviewTag(article);

            const articleEditVM = {
              ...obj.articlesEdit.getTemplateViewModel(),
            };
            obj.articlesEdit.imageWidgetForFeaturedImage.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.imageWidgetForThumbnailImage.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.imageWidgetForAlternateImage.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.articlePinnedTags.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.articlePinnedTags.filterTagType.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.filterCategory.setIsDisabled(
              articleEditVM.isPublishingControl()
            );
          });
        }
        //obj.filterByUrl();
        obj.updateViewModelFromPath();
        obj.loadingOut(obj.articlesEdit.builtTemplate);

        obj.toggleAllCloseFilterUserButton(obj.articlesEdit);
      }
    };
  }
  protected filterByUrl() {
    this.updateViewModelFromPath();
  }
  private toggleAllCloseFilterUserButton(articlesEdit) {
    const {
      filterUser_author,
      filterUser_SrEditor,
      filterUser_JrEditor,
      filterUser_ideator,
      filterUser_republish_author,
      filterUser_republish_SrEditor,
      filterUser_republish_JrEditor,
      filterUser_scheduled_republish_author,
      filterUser_scheduled_republish_SrEditor,
      filterUser_scheduled_republish_JrEditor,
      filterUser_display_author,
    } = articlesEdit;

    filterUser_author.toggleCloseButton();
    filterUser_SrEditor.toggleCloseButton();
    filterUser_JrEditor.toggleCloseButton();
    filterUser_ideator.toggleCloseButton();
    filterUser_republish_author.toggleCloseButton();
    filterUser_republish_SrEditor.toggleCloseButton();
    filterUser_republish_JrEditor.toggleCloseButton();
    filterUser_scheduled_republish_author.toggleCloseButton();
    filterUser_scheduled_republish_SrEditor.toggleCloseButton();
    filterUser_scheduled_republish_JrEditor.toggleCloseButton();
    filterUser_display_author.toggleCloseButton();
  }

  public setPlagiarismResults(plagiarismResults) {
    this.articlesEdit.setPlagiarismResults(
      plagiarismResults ? plagiarismResults : []
    );
  }

  public setDefaultThreadsImage(defaultThreadsImage) {
    this.articlesEdit.setDefaultThreadsImage(defaultThreadsImage);
  }

  public setPinnedTags(article_data) {
    this.articlesEdit.articlePinnedTags.setTitle(article_data.pinnedTagsTitle);
    this.articlesEdit.articlePinnedTags.setPosition(
      article_data.pinnedTagsPosition
    );
    this.articlesEdit.articlePinnedTags.setSelectedStyle(
      article_data.pinnedTagsStyle
    );

    if (article_data.pinnedTagType) {
      article_data.pinnedTagType.name += ` ${article_data.pinnedTagType.formattedDataset}`;
      this.articlesEdit.articlePinnedTags.filterTagType.setOption(
        article_data.pinnedTagType
      );

      //set option for specs
      let filters = article_data.pinnedTagType.fields.filter(
        (v) => v.dataType != "tags"
      );
      let filterOptions = filters.map((v) => ({ name: v.label, id: v.id }));
      filterOptions.unshift({ name: "Select an option", id: null });
      this.articlesEdit.articlePinnedTags.setTagSpecs(filterOptions);
      this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .selectedTagSpec(article_data.pinnedTagsSpecs[0]);

      this.articlesEdit.articlePinnedTags.setIsShownTagTypeSpec(true);
    }

    if (article_data.pinnedTags) {
      let tags = [];

      article_data.pinnedTags.forEach((tag) => {
        tag.tag.name += `  ${tag.tag.formattedTagTypeAndDataset}`;
        tags.push(tag.tag);
      });

      this.articlesEdit.articlePinnedTags.setTags(tags);

      const showPinnedTags = tags.length > 0;
      this.articlesEdit.setShowPinnedTags(showPinnedTags);
    }
  }

  public setReviewTag(article_data) {
    if (article_data.reviewTag) {
      this.articlesEdit.filterReviewTag.setOption(article_data.reviewTag);
    }
  }

  public setJsonSaves(article_data) {
    //Managing recovery & sandbox & revisions
    if (article_data["jsonSaves"] && article_data["jsonSaves"].length > 0) {
      let revisions = [];

      article_data["jsonSaves"].forEach((save) => {
        save.content = JSON.parse(save.content);
        save.content.reviewItems =
          typeof save.content.reviewItems === "string"
            ? JSON.parse(save.content.reviewItems)
            : save.content.reviewItems;
        save.content.directoryItems =
          typeof save.content.directoryItems === "string"
            ? JSON.parse(save.content.directoryItems)
            : save.content.directoryItems;

        if (save.type === "sandbox") {
          this.articlesEdit.getTemplateViewModel().isSandboxActive(true);
          this.setSandboxContent(save.content.content);
          this.setSandboxIntroText(save.content.introText);
          this.articlesEdit.setSandboxReviewItems(save.content.reviewItems);
          this.articlesEdit.sandboxDirectory.setSandboxDirectoryItems(
            save.content.directoryItems
          );
        } else if (save.type === "republish") {
          this.articlesEdit.getTemplateViewModel().isRepublishActive(true);
          this.setRepublishContent(save.content.content);
          this.setRepublishIntroText(save.content.introText);
          this.articlesEdit.productReviewRepublish.setReviewItems(
            save.content.reviewItems
          );
          this.articlesEdit.republishDirectory.setSandboxDirectoryItems(
            save.content.directoryItems
          );
          this.articlesEdit
            .getTemplateViewModel()
            .idRepublishStatus(save.content.status.id);

          let republishes = save.content.republishes;
          if (republishes && republishes.length > 0) {
            let republish = republishes[0];
            this.articlesEdit.republishDatePicker.setDate(
              republish.dateRepublished
            );
            if (republish.author) {
              this.articlesEdit.filterUser_republish_author
                .getTemplateViewModel()
                .user(republish.author.valnet_user.fullNameAndLogin);
              this.articlesEdit.filterUser_republish_author
                .getTemplateViewModel()
                .idUser(republish.author.id);
            }
            if (republish.editor) {
              this.articlesEdit.filterUser_republish_SrEditor
                .getTemplateViewModel()
                .user(republish.editor.valnet_user.fullNameAndLogin);
              this.articlesEdit.filterUser_republish_SrEditor
                .getTemplateViewModel()
                .idUser(republish.editor.id);
            }
            if (republish.juniorEditor) {
              this.articlesEdit.filterUser_republish_JrEditor
                .getTemplateViewModel()
                .user(
                  republish.juniorEditor
                    ? republish.juniorEditor.valnet_user.fullNameAndLogin
                    : ""
                );
              this.articlesEdit.filterUser_republish_JrEditor
                .getTemplateViewModel()
                .idUser(
                  republish.juniorEditor ? republish.juniorEditor.id : ""
                );
            }
            if (republish.postPaymentCategory) {
              this.articlesEdit.paymentCategoryFilter.setSelectedOption(
                republish.postPaymentCategory.id
              );
            }
            if (republish.percentageAuthor) {
              this.articlesEdit
                .getTemplateViewModel()
                .choosenPaymentTypeRepublish("Percentage");
              this.articlesEdit
                .getTemplateViewModel()
                .percentageAuthor(republish.percentageAuthor);
            }
            if (republish.amountAuthor) {
              this.articlesEdit
                .getTemplateViewModel()
                .choosenPaymentTypeRepublish("Amount");
              this.articlesEdit
                .getTemplateViewModel()
                .amountAuthor(republish.amountAuthor);
            }
            this.articlesEdit
              .getTemplateViewModel()
              .percentageEditor(republish.percentageEditor);

            this.articlesEdit.getTemplateViewModel().republishIsUnderEmbargo(!!republish.isUnderEmbargo);
          }
        } else if (save.type === "recovery") {
          this.articlesEdit.setRecoveryContent(save.content.content);
          this.articlesEdit.setRecoveryIntroText(save.content.introText);
          this.articlesEdit.setRecoveryReviewItems(save.content.reviewItems);
          this.articlesEdit.setDateRecovery(save.dateUpdated);
          this.articlesEdit.setRecoveryUser(
            save.content.author.valnet_user.fullName
          );
          this.articlesEdit.setRecovery(save.content);
          this.articlesEdit.recoveryDirectory.setDirectoryItems(
            save.content.directoryItems
          );
        } else if (save.type === "sandboxRecovery") {
          this.articlesEdit.setSandboxRecoveryContent(save.content.content);
          this.articlesEdit.setSandboxRecoveryIntroText(save.content.introText);
          this.articlesEdit.setRecoverySandboxReviewItems(
            save.content.reviewItems
          );
          this.articlesEdit.setSandboxRecovery(save.content);
          this.articlesEdit.recoverySandboxDirectory.setDirectoryItems(
            save.content.directoryItems
          );
        } else if (save.type === "republishRecovery") {
          this.articlesEdit.setRepublishRecoveryContent(save.content.content);
          this.articlesEdit.setRepublishRecoveryIntroText(
            save.content.introText
          );
          this.articlesEdit.setRecoveryRepublishReviewItems(
            save.content.reviewItems
          );
          this.articlesEdit.recoveryRepublishDirectory.setDirectoryItems(
            save.content.directoryItems
          );
          this.articlesEdit.setRepublishRecovery(save.content);
          this.articlesEdit.setRecoveryRepublishData(
            save.content.republishes ? save.content.republishes[0] : []
          );
        } else if (save.type === "revision") {
          //revisions.push(save.content)
          revisions.push(save);
        }
      });

      this.articlesEdit.setRevisions(revisions);
      if (revisions.length > 0) {
        this.articlesEdit.setIdRevisionSelected(revisions[0].content.id);
        this.articlesEdit.setRevisionContent(revisions[0].content.content);
        this.articlesEdit.setRevisionIntroText(revisions[0].content.introText);
        this.articlesEdit.setRevisionReviewItems(
          revisions[0].content.reviewItems
        );
        this.articlesEdit.revisionDirectory.setDirectoryItems(
          revisions[0].content.directoryItems
        );
      }
    }
  }

  public setArticleData(article_data: Object, type = "set"): void {
    // @TODO: these constants should not be hard-coded!

    if (type == "set") {
      //init ck editors
      this.initializeCkEditors();
      this.initializePromptResponseCKEditor();
    }

    if (article_data["contentKeyPointsGenerationAttempts"]) {
      this.keyPointsAttempts =
        article_data["contentKeyPointsGenerationAttempts"];
    }

    const templates = {
      Regular: 2,
      List: 3,
      "Product Review": 5,
      "Buyer's Guide": 6,
      Directory: 7,
      "Buyer's Guide Light": 9,
      Deals: 10,
      Versus: 11,
      Collection: 12,
      Video: ID_TEMPLATE_VIDEO,
      Thread: ID_TEMPLATE_THREAD,
    };
    const defaultTemplate = "Regular";
    const defaultTemplateId = 2;

    let url = new URL(window.location.href);
    let title = article_data["title"] ? article_data["title"] : "";
    let template_id = article_data["template"]
      ? article_data["template"]["id"]
      : "";
    let template = article_data["template"]
      ? article_data["template"]["name"]
      : "";
    let permalink = article_data["permalink"];

    if (url.searchParams.has("title") && !article_data["title"]) {
      title = url.searchParams.get("title");
      // check if the value is URL encoded
      if (title !== decodeURIComponent(title)) {
        // decode the value if it's URL encoded
        title = decodeURIComponent(title);
      }
    }

    if (url.searchParams.has("template") && !article_data["template"]) {
      let template_param = url.searchParams.get("template");
      // check if the value is URL encoded
      if (template_param !== decodeURIComponent(template_param)) {
        // decode the value if it's URL encoded
        template_param = decodeURIComponent(template_param);
      }
      if (template_param in templates) {
        template_id = templates[template_param];
        template = template_param;
      } else {
        // default to regular template..
        template_id = defaultTemplateId;
        template = defaultTemplate;
      }
      //this.initializeCkEditors();
      this.articlesEdit.onClickTemplateTab(template_id, null);
    }

    if (url.searchParams.has("permalink") && !article_data["permalink"]) {
      permalink = url.searchParams.get("permalink");
      // check if the value is URL encoded
      if (permalink !== decodeURIComponent(permalink)) {
        // decode the value if it's URL encoded
        permalink = decodeURIComponent(permalink);
      }
      // ensure the permalink has a leading and trailing slash
      if (permalink !== "") {
        permalink =
          (permalink.charAt(0) === "/" ? "" : "/") +
          permalink.trim() +
          (permalink.charAt(permalink.length - 1) === "/" ? "" : "/");
      }
    }

    this.articlesEdit.setId(article_data["id"]);
    this.articlesEdit.setIdTemplate(template_id);
    let idTemplateLayoutDefault = article_data["templateLayout"]
      ? article_data["templateLayout"]["id"]
      : null;
    this.articlesEdit.setTemplateLayoutsFiltered(
      template_id,
      idTemplateLayoutDefault
    );

    if (template_id == ID_TEMPLATE_VIDEO) {
      this.articlesEdit.setVideoTemplateDefaults();
    } else if (template_id == ID_TEMPLATE_THREAD) {
      this.articlesEdit.setThreadTemplateDefaults();
    }

    this.articlesEdit.setTitle(title);
    this.articlesEdit.setDateUpdated(
      article_data["dateUpdated"] ? article_data["dateUpdated"] : ""
    );
    this.articlesEdit.setDateCreated(
      article_data["dateCreated"] ? article_data["dateCreated"] : ""
    );
    this.articlesEdit.setExcerpt(article_data["excerpt"]);
    this.articlesEdit.setReference(article_data["reference"]);
    this.articlesEdit.setListOrder(article_data["listOrder"]);
    this.articlesEdit.setSeoTitle(article_data["seoMetaTitle"]);
    this.articlesEdit.setSeoDescription(article_data["seoMetaDescription"]);
    this.articlesEdit.setSmoTitle(article_data["socialMediaTitle"]);
    this.articlesEdit.setSmoDescription(article_data["socialMediaExcerpt"]);
    this.articlesEdit.setSocialTagLine(article_data["socialTagLine"]);
    this.articlesEdit.setFileUrl(article_data["pdf"]);
    this.articlesEdit.setTableOfContents(article_data["tableOfContents"]);
    this.articlesEdit.setFaqs(article_data["faq"]);
    this.articlesEdit.setIsSponsored(article_data["isSponsored"]);
    this.articlesEdit.setIdIntent(
      article_data["intent"] ? article_data["intent"]["id"] : ""
    );
    this.articlesEdit.setIdNetworkCategory(
      article_data["networkCategory"]
        ? article_data["networkCategory"]["id"]
        : ""
    );
    this.articlesEdit.setIdContentType(
      article_data["contentType"] ? article_data["contentType"]["id"] : ""
    );
    this.articlesEdit.setIdSegment(
      article_data["segment"] ? article_data["segment"]["id"] : "",
      article_data["segment"] ? article_data["segment"] : null,
    );
    this.articlesEdit.setIdPaymentCategory(
      article_data["postPaymentCategory"]
        ? article_data["postPaymentCategory"]["id"]
        : ""
    );
    this.articlesEdit.setReviewCategory(
      article_data["reviewCategory"] ? article_data["reviewCategory"] : ""
    );
    this.articlesEdit.setIsAdHidden(article_data["isAdHidden"]);
    this.articlesEdit.setIsUnderEmbargo(article_data["isUnderEmbargo"]);
    this.articlesEdit.setIsAmpDisabled(
      article_data["isAmpEnabled"] ? false : true
    );
    this.articlesEdit.setIsDevelopingStory(article_data["isDevelopingStory"]);
    this.articlesEdit.setPinnedTag(article_data["pinnedTag"]);
    this.articlesEdit.setTemplate(template);
    this.articlesEdit.setIsFeaturedImageHidden(
      article_data["isFeaturedImageHidden"]
        ? article_data["isFeaturedImageHidden"]
        : false
    );
    this.articlesEdit.setIsCommentsDisabled(
      article_data["isCommentsDisabled"]
        ? article_data["isCommentsDisabled"]
        : false
    );
    this.articlesEdit.setIsCommentsPaused(
      article_data["isCommentsPaused"]
        ? article_data["isCommentsPaused"]
        : false
    );
    this.articlesEdit.setIsRatingEnabled(
      article_data["isRatingEnabled"] ? article_data["isRatingEnabled"] : false
    );
    this.articlesEdit.setIsReadNextDisabled(
      article_data["isReadNextDisabled"]
        ? article_data["isReadNextDisabled"]
        : false
    );
    this.articlesEdit.setIsDisplayCardQuickLinksShown(
      article_data["isDisplayCardQuickLinksShown"]
        ? article_data["isDisplayCardQuickLinksShown"]
        : false
    );
    this.articlesEdit.setIsDisplayCardQuickLinksMobileShown(
      article_data["isDisplayCardQuickLinksMobileShown"]
        ? article_data["isDisplayCardQuickLinksMobileShown"]
        : false
    );
    this.articlesEdit.setIsSidebarHidden(article_data["isSidebarHidden"]);
    this.articlesEdit.setIsAffiliateLinkerEnabled(
      article_data["isAffiliateLinkerEnabled"]
    );
    this.articlesEdit.setFeaturedTags(article_data["featuredTagGroup"]);
    this.articlesEdit.setSensaiRulePointThreshold(
      article_data["contentType"] &&
        article_data["contentType"]["sensaiRulePointThreshold"]
        ? article_data["contentType"]["sensaiRulePointThreshold"]
        : 35
    );
    this.articlesEdit.setSensaiCoverageScore(
      article_data["sensaiCoverageScore"]
    );
    this.articlesEdit.setSensaiRuleScore(article_data["sensaiRuleScore"]);
    this.articlesEdit.setTotalSensaiScore();
    if (
      article_data["featuredTagGroup"] !== null &&
      article_data["featuredTagGroup"]["tagObject"] !== null &&
      article_data["featuredTagGroup"]["tagObject"].length > 1
    ) {
      if (article_data["featuredTagGroup"].block.style == "versus") {
        this.articlesEdit.setIsVersusStyle(true);
      }
    } else {
      this.articlesEdit.setIsVersusStyle(false);
    }
    //this.updateKeyPointsButton(article_data['contentKeyPointsGenerationAttempts']);

    this.articlesEdit.setAutoCategorizationGenerationAttemptsRemaining(
      article_data["autoCategorizationGenerationAttempts"]
    );

    if (
      article_data["pinnedTag"] ||
      (article_data["featuredTagGroup"] &&
        article_data["featuredTagGroup"]["tagObject"])
    ) {
      this.articlesEdit.imageWidgetForFeaturedImage.setIsFeaturedTagActive(
        true
      );
      this.articlesEdit.setIsFeaturedTagActive(true);
      this.articlesEdit
        .getTemplateViewModel()
        .featuredSectionValue("featuredTag");
      this.articlesEdit
        .getTemplateViewModel()
        .chosenFeaturedSectionValue("featuredTag");
    }

    if (article_data["isHiddenFromAllSite"]) {
      this.articlesEdit.setDisplayConfiguration(3);
    } else if (
      article_data["isHiddenFromTrending"] &&
      article_data["isHiddenFromHomePage"]
    ) {
      this.articlesEdit.setDisplayConfiguration(24);
    } else if (article_data["isHiddenFromHomePage"]) {
      this.articlesEdit.setDisplayConfiguration(2);
    } else if (article_data["isHiddenFromTrending"]) {
      this.articlesEdit.setDisplayConfiguration(4);
    }

    this.articlesEdit.disableContributorFields();

    if (article_data["author"]) {
      this.articlesEdit.setAuthor(article_data["author"]);
    }

    if (article_data["editor"]) {
      this.articlesEdit.setEditor(article_data["editor"]);
    }

    if (article_data["juniorEditor"]) {
      this.articlesEdit.setJrEditor(article_data["juniorEditor"]);
    }

    if (article_data["ideator"]) {
      this.articlesEdit.setIdeator(article_data["ideator"]);
    }

    //featuredImage
    if (article_data["featuredImage"]) {
      let featuredImage = article_data["featuredImage"];
      featuredImage.isMobileOptimized = Boolean(
        article_data["isFeaturedImageOptimized"]
      );
      this.articlesEdit.setImage(featuredImage, "featured_image");
    }

    //thumbnailImage
    if (article_data["alternateImage"]) {
      this.articlesEdit.setImage(
        article_data["alternateImage"],
        "alternate_image"
      );
    }

    //thumbnailImage
    if (article_data["thumbnail"]) {
      this.articlesEdit.setImage(article_data["thumbnail"], "thumbnail_image");
    }

    //Featured video
    if (article_data["featuredVideo"]) {
      this.articlesEdit.setFeaturedVideo(article_data["featuredVideo"]);
      this.articlesEdit
        .getTemplateViewModel()
        .featuredSectionValue("featuredVideo");
      this.articlesEdit
        .getTemplateViewModel()
        .chosenFeaturedSectionValue("featuredVideo");
      this.articlesEdit.getTemplateViewModel().isFeaturedVideoActive(true);
      this.articlesEdit.getTemplateViewModel().isFeaturedImageActive(false);
      this.articlesEdit.imageWidgetForFeaturedImage
        .getTemplateViewModel()
        .isFeaturedVideoActive(true);

      this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoTitle(article_data["featuredVideo"]["title"]);
      this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoDescription(article_data["featuredVideo"]["description"]);
    }

    if (article_data["featuredEmbed"]) {
      this.articlesEdit.setFeaturedEmbed(
        article_data["featuredEmbed"]["embed"]
      );
      this.articlesEdit
        .getTemplateViewModel()
        .featuredSectionValue("featuredVideo");
      this.articlesEdit
        .getTemplateViewModel()
        .chosenFeaturedSectionValue("featuredVideo");
      this.articlesEdit.getTemplateViewModel().isFeaturedVideoActive(true);
      if (!article_data["featuredVideo"]) {
        this.articlesEdit.getTemplateViewModel().isFeaturedEmbedActive(true);
        this.articlesEdit.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(
          true
        );
        this.articlesEdit.getTemplateViewModel().isFeaturedImageActive(true);
      }
      if (article_data["featuredImage"]) {
        this.articlesEdit.setImage(
          article_data["featuredImage"],
          "featured_image_embed"
        );
      }
    }

    //pinned article
    if (article_data["pinnedArticle"]) {
      this.articlesEdit.setNextArticle(article_data["pinnedArticle"]);
    }

    if (article_data["poll"]) {
      this.articlesEdit.setPoll(article_data["poll"]);
    }

    //this.articlesEdit.setEditor(article_data['editor'] ? article_data['editor']['valnet_user']['fullName']: "");
    //this.articlesEdit.setJrEditor(article_data['juniorEditor'] ? article_data['juniorEditor']['valnet_user']['fullName']: "");

    this.articlesEdit.setDateLastPreview(article_data["dateLastPreview"]);
    this.articlesEdit.setDatePublished(article_data["dateOriginalPublish"]);
    this.articlesEdit.setDateLastPublishStatus(
      article_data["dateLastPublishStatus"]
    );
    this.articlesEdit.setDateMostRecentPublishStatus(
      article_data["dateMostRecentPublishedStatus"]
        ? article_data["dateMostRecentPublishedStatus"].date.substring(0, 19)
        : ""
    );
    this.articlesEdit.setDateLastStatus(article_data["dateLastStatus"]);
    this.articlesEdit.setDateLastSyncStatus(article_data["dateLastSyncStatus"]);
    this.articlesEdit.setTargetAudience(
      article_data["targetAudience"]
        ? article_data["targetAudience"]["name"]
        : ""
    );
    this.articlesEdit.setIntent(
      article_data["intent"] ? article_data["intent"]["name"] : ""
    );
    this.articlesEdit.setContentType(
      article_data["contentType"] ? article_data["contentType"]["name"] : ""
    );
    this.articlesEdit.setSegment(
      article_data["segment"] ? article_data["segment"]["name"] : ""
    );
    this.articlesEdit.setNetworkCategory(
      article_data["networkCategory"]
        ? article_data["networkCategory"]["name"]
        : ""
    );
    this.articlesEdit.setPostPaymentCategory(
      article_data["postPaymentCategory"]
        ? article_data["postPaymentCategory"]["name"]
        : ""
    );
    this.articlesEdit
      .getTemplateViewModel()
      .newRepublishDate(new Date().toISOString().slice(0, 10));
    this.articlesEdit.setArticleRepublishData(article_data["republishes"]);
    this.articlesEdit.setPermalink(permalink);
    this.articlesEdit.setIdPublishStatus(
      article_data["publishStatus"] ? article_data["publishStatus"]["id"] : ""
    );
    this.articlesEdit.setArticleCurrentIdArticleStatus(
      article_data["status"] ? article_data["status"]["id"] : ""
    );
    this.articlesEdit.setSyncStatus(
      article_data["syncStatus"] ? article_data["syncStatus"]["name"] : ""
    );
    this.articlesEdit.setAmazonsiteArticleTitle(
      article_data["amazonsiteArticleTitle"]
    );
    this.articlesEdit.setNewsNowArticleTitle(article_data["newsNowTitle"]);
    this.articlesEdit.setIsNewsNowArticle(article_data["isNewsNowArticle"]);
    this.articlesEdit.setIsUpdateTime(false);
    this.articlesEdit.setContentKeyPoints(article_data["contentKeyPoints"]);
    this.articlesEdit.setIsSubContent(article_data["isSubContent"]);

    this.articlesEdit.setArticleHistoricalReviewComments(
      article_data["reviewComments"]
    );

    if (article_data["dateScheduled"]) {
      this.articlesEdit.setDateScheduled(article_data["dateScheduled"]);
    } else {
      this.articlesEdit.setEasternTimeOnScheduled();
    }

    if (article_data["dateDevelopingStoryCoverageStart"] && article_data["dateDevelopingStoryCoverageEnd"]) {
      this.articlesEdit.setDateDevelopingStoryCoverageStartAndEnd(article_data["dateDevelopingStoryCoverageStart"], article_data["dateDevelopingStoryCoverageEnd"]);
    }

    //directory
    if (article_data["template"] && article_data["template"]["id"] == 7) {
      this.articlesEdit.articleDirectory.setDirectoryItemsObservable(
        article_data["directoryItems"]
      );
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems([]);
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .isUndoAllChangesEnabled(false);
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .isUndoLastDeleteEnabled(false);
    }

    if (
      article_data["template"] &&
      article_data["template"]["id"] == ID_TEMPLATE_VIDEO
    ) {
      this.articlesEdit.setVideoTemplateDefaults();
    }

    if (
      (type == "set" || type == "refreshAfterKeyPointsAdded") &&
      article_data["content"]
    ) {
      let content = article_data["content"];
      contentEditor.setData(content, function () {
        this.resetUndo();
      });
    }

    if (type == "set" && article_data["introText"]) {
      let introText = article_data["introText"];
      introTextEditor.setData(introText, function () {
        this.resetUndo();
      });
    }

    this.articlesEdit.setIdArticleStatus(
      article_data["status"] ? article_data["status"]["id"] : ""
    );

    this.articlesEdit.setPreviousIdArticleStatus(
      article_data["status"] ? article_data["status"]["id"] : ""
    );

    //set amazon on site date
    if (article_data["amazonsitePublishDate"]) {
      this.articlesEdit.setAmazonOnSiteDate(
        article_data["amazonsitePublishDate"]
      );
    } else {
      this.articlesEdit.setAmazonOnSiteDate("Set when published");
    }

    this.articlesEdit.setReviewItems(article_data["reviewItems"]);

    if (article_data["idPrimaryCategory"]) {
      this.articlesEdit.setIdPrimaryCategory(
        article_data["idPrimaryCategory"].toString()
      );
    }

    if (article_data["idPrimaryTag"]) {
      this.articlesEdit.setIdPrimaryTag(
        article_data["idPrimaryTag"].toString()
      );
    }

    //if clause inside
    this.setJsonSaves(article_data);

    if (article_data["categories"]) {
      this.articlesEdit.setSelectedCategories(article_data["categories"]);
      this.articlesEdit.setSelectedFilterCategories(article_data["categories"]);
    }

    if (article_data["tags"]) {
      this.articlesEdit.setSelectedTags(article_data["tags"]);
    }

    if (article_data["classification"]) {
      this.articlesEdit.setIdClassification(
        article_data["classification"]
          ? article_data["classification"]["id"]
          : ""
      );
      this.articlesEdit.setClassificationName(
        article_data["classification"]
          ? article_data["classification"]["name"]
          : ""
      );
    }

    /*if (article_data['revisions']) {
            this.articlesEdit.setIdRevisionSelected(article_data['revisions'][0]['id']);
            this.articlesEdit.setRevisionContent(article_data['revisions'][0]['content']);
            this.articlesEdit.setRevisionIntroText(article_data['revisions'][0]['introText']);
            this.articlesEdit.setRevisionReviewItems(article_data['revisions'][0]['reviewItems']);
            this.articlesEdit.setRevisions(article_data['revisions']);
        }*/

    this.articlesEdit.setPlagiarismStatus(article_data["plagiarismStatus"]);

    this.articlesEdit
      .getTemplateViewModel()
      .isPublishingControl(
        this.articlesEdit.getTemplateViewModel().idStatus() == 6 &&
        !this.articlesEdit.getTemplateViewModel().permissions()[
          "article_edit_publishingControl"
        ].write
      );

    if (this.articlesEdit.getTemplateViewModel().isPublishingControl()) {
      contentEditor.on("contentDom", function () {
        contentEditor.editable().attachListener(
          contentEditor.editable(),
          "click",
          function (evt) {
            evt.stop();
            evt.data.preventDefault();
          },
          null,
          null,
          0
        );
      });
    }

    this.articlesEdit.setPrompt(
      article_data["prompt"] ? article_data["prompt"] : ""
    );
    this.setRichTextForPromptResponseEditor(
      article_data["promptResponse"] ? article_data["promptResponse"] : ""
    );
    this.articlesEdit.setPromptResponse(
      article_data["promptResponse"] ? article_data["promptResponse"] : ""
    );
    if (article_data["promptAuthor"]) {
      this.articlesEdit.setPromptAuthor(article_data["promptAuthor"]);
    }
    this.articlesEdit.setPromptLink(
      article_data["promptLink"] ? article_data["promptLink"] : ""
    );

    if (article_data["channel"]) {
      this.articlesEdit.setChannel(article_data["channel"]);
      if (article_data["playlists"]) {
        this.articlesEdit.setPlaylists(article_data["playlists"]);
      }
    }

    if (article_data["republishesCount"]) {
      this.articlesEdit.setRepublishesCount(article_data["republishesCount"]);
    }

    if(additionalCreditEditor){

      let additionalCredit = article_data["additionalCredit"];
         additionalCreditEditor.setData(additionalCredit);
    }
    const sourceTime = article_data["sourceTime"] ?  article_data["sourceTime"] : null
    this.articlesEdit.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(sourceTime);

    this.articlesEdit.getTemplateViewModel().sourceUrl(article_data["sourceUrl"] ? article_data["sourceUrl"] : null);

    this.fetchArticleAiSummaries();

  }

  public setDisplayAuthors(displayAuthors): void {
    this.articlesEdit.setDisplayAuthors(displayAuthors);
  }

  // public setAuthorPrompts(authorAgreements): void{

  //     this.articlesEdit.setAuthorPrompts(authorAgreements);
  // }

  protected cancelEditArticle() {
    // minimize CKEditors
    this.minimizeAllEditors();
    // disable buttons while loading next page
    // this.articlesEdit.disableSaveButtons();
    // clear recovery save
    this.clearRecoverySave();
    this.clearRecoveryWarning();

    //release lock
    this.releaseLock();
    this.stopWatchScroll();
    this.getVnAppZone().app.removeWarningEventListeners();
    // redirect to articles list
    this.redirectToArticlesList();
  }

  protected onKickout() {
    this.clearRecoverySave();
    this.clearRecoveryWarning();

    this.articlesEdit.disableSaveButtons();
  }

  protected closeNotice() {
    this.articlesEdit.setIsNoticeVisible(false);
    let myThis = this;
    // delay to avoid ui wierdness due to fadeout
    //setTimeout(function () {
    //    myThis.articlesEdit.setNoticeMessage("");
    //}, 1000);
  }

  protected releaseLock() {
    // request a lock release
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/release/lock_edit/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", this.articlesEdit.getTemplateViewModel().id()]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.execute();
  }

  protected deleteRecovery() {
    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/recovery/delete/" +
      this.articlesEdit.getTemplateViewModel().id();

    let formReq_params: Array<Array<string>> = [];

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onDeleteRecoveryReturn;
    XHRHdl.execute();
  }

  protected onDeleteRecoveryReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        obj.redirectToArticlesList();
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  public redirectToArticlesList(): void {
    this.maximizeSideNav();

    let previousUrl = this.loadPreviousPage(window.location.href);
    if (previousUrl) {
      page.redirect(previousUrl);
    } else {
      page.redirect(
        "/brand/" + this.getVnAppZone().app.params.idBrand + "/articles/"
      );
    }
  }

  protected syncEditArticle() {
    // redirect to articles list
    this.sync();
  }

  protected saveEditArticle(type) {
    this.save(type);
  }

  protected previewNoSaveArticle(type) {
    this.previewArticle(type);
  }

  protected getUsersSuggestion(keyword, idElement) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel: any = {
      list: { keyword: keyword },
      idElement: idElement,
    };
    let usrReq_url: string = null;

    switch (idElement) {
      case "filterWebsiteUser_prompt_author":
        usrReq_url = "/api/search/website-users/";
        subViewModel.idBrand = this.getVnAppZone().app.params.idBrand;
        break;
      default:
        usrReq_url =
          "/api/brand/" +
          this.getVnAppZone().app.params.idBrand +
          "/search/user/";
        break;
    }

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
    this.XHRHdl.execute();
  }

  protected onGetUsersSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.data.idElement == "filterUser_author") {
          obj.articlesEdit.setFilterUserAuthor(responseParsed.data.users);
        } else if (responseParsed.data.idElement == "filterUser_SrEditor") {
          obj.articlesEdit.setFilterUserSrEditor(responseParsed.data.users);
        } else if (responseParsed.data.idElement == "filterUser_JrEditor") {
          obj.articlesEdit.setFilterUserJrEditor(responseParsed.data.users);
        } else if (responseParsed.data.idElement == "filterUser_ideator") {
          obj.articlesEdit.setFilterUserIdeator(responseParsed.data.users);
        } else if (
          responseParsed.data.idElement == "filterUser_republish_author"
        ) {
          obj.articlesEdit.setFilterUserRepublishAuthor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement == "filterUser_republish_SrEditor"
        ) {
          obj.articlesEdit.setFilterUserRepublishSrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement == "filterUser_republish_JrEditor"
        ) {
          obj.articlesEdit.setFilterUserRepublishJrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement ==
          "filterUser_scheduled_republish_author"
        ) {
          obj.articlesEdit.setFilterUserScheduledRepublishAuthor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement ==
          "filterUser_scheduled_republish_SrEditor"
        ) {
          obj.articlesEdit.setFilterUserScheduledRepublishSrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement ==
          "filterUser_scheduled_republish_JrEditor"
        ) {
          obj.articlesEdit.setFilterUserScheduledRepublishJrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement == "filterUser_display_author"
        ) {
          obj.articlesEdit.setFilterUserDisplayAuthor(
            responseParsed.data.users
          );
        } else if (responseParsed.data.idElement == "filterUser_producer") {
          obj
            .getVideoPickerEditTemplate()
            .setProducer(responseParsed.data.users);
        } else if (
          responseParsed.data.idElement == "filterWebsiteUser_prompt_author"
        ) {
          obj.articlesEdit.setFilterUserPromptAuthor(responseParsed.data.users);
        }
      });
    };
  }

  public getVideoPickerHelper() {
    return this.articlesEdit.videoPickerHelper;
  }

  public getVideoPickerEditTemplate() {
    return this.articlesEdit.videoPickerHelper.getVideoPickerEditTemplate();
  }

  public getVideoPickerTemplate() {
    return this.articlesEdit.videoPickerHelper.getVideoPickerTemplate();
  }

  public getImagePickerEditTemplate() {
    return this.articlesEdit.imagePicker.imageEdit;
  }

  public sendToArticleContent(content) {
    contentEditor.setData(content);
  }

  public sendToArticleIntroText(introText) {
    introTextEditor.setData(introText);
  }

  public revertSandboxRecovery(sandboxRecoveryContent) {
    sandboxEditor.setData(sandboxRecoveryContent);
  }

  public revertRepublishRecovery(sandboxRecoveryContent) {
    republishEditor.setData(sandboxRecoveryContent);
  }

  public revertSandboxIntroTextRecovery(sandboxIntroTextRecovery) {
    sandboxIntroTextEditor.setData(sandboxIntroTextRecovery);
  }

  public revertRepublishIntroTextRecovery(sandboxIntroTextRecovery) {
    republishIntroTextEditor.setData(sandboxIntroTextRecovery);
  }

  public filterDropdownOnChange(idElement) {
    switch (idElement) {
      case "videoRatioFilter":
      case "videoOrientationFilter":
        this.getVideosData();
        break;
      case "savedRulesHistory":
        let id = this.articlesEdit.getTemplateViewModel().id();
        let uuid = this.articlesEdit.getFeedbackHistoryOption();
        if (id && uuid != 0) {
          this.filterFeedBackHistory(id, uuid);
        } else {
          let idContentType = this.articlesEdit
            .getTemplateViewModel()
            .idContentType();
          this.getSensaiResults("article_content", idContentType);
        }
        break;
      default:
        this.getImageData();
        break;
    }
  }

  protected filterList() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }

  protected sync() {
    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/sync/" +
      this.articlesEdit.getTemplateViewModel().id();

    let formReq_params: Array<Array<string>> = [];

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onSyncReturn;
    XHRHdl.execute();
  }

  protected getSavePostData() {
    let idAuthor =
      this.articlesEdit.getTemplateViewModel().filterUser_author.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_author.idUser()
        : null;
    let idSeniorEditor =
      this.articlesEdit.getTemplateViewModel().filterUser_SrEditor.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_SrEditor.idUser()
        : null;
    let idJuniorEditor =
      this.articlesEdit.getTemplateViewModel().filterUser_JrEditor.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_JrEditor.idUser()
        : null;
    let idIdeator =
      this.articlesEdit.getTemplateViewModel().filterUser_ideator.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_ideator.idUser()
        : null;

    const isReviewOrProductReviewContentType = this.articlesEdit.getTemplateViewModel().idContentType() == 5 ||
      this.articlesEdit.getTemplateViewModel().idContentType() == 24;
    let additionalCreditData = "";
    if(additionalCreditEditor){
      additionalCreditData = additionalCreditEditor.getData();
    }
    let postData = {
      idArticle: this.articlesEdit.getTemplateViewModel().id(),
      isSubContent: this.articlesEdit.getTemplateViewModel().isSubContent(),
      idNextArticle:
        this.articlesEdit.getTemplateViewModel().filterArticle.idArticle,
      idPublishStatus: this.articlesEdit
        .getTemplateViewModel()
        .idPublishStatus(),
      idPoll: this.articlesEdit.getTemplateViewModel().idPoll(),
      idNetworkCategory: this.articlesEdit
        .getTemplateViewModel()
        .idNetworkCategory(),
      idContentType: this.articlesEdit.getTemplateViewModel().idContentType(),
      idSegment: this.articlesEdit.getTemplateViewModel().idSegment(),
      idIntent: this.articlesEdit.getTemplateViewModel().idIntent(),
      idPaymentCategory: this.articlesEdit
        .getTemplateViewModel()
        .idPaymentCategory(),
      permalink: this.articlesEdit.getTemplateViewModel().permalink(),
      amazonsiteArticleTitle: this.articlesEdit
        .getTemplateViewModel()
        .amazonsiteArticleTitle(),
      newsNowArticleTitle: this.articlesEdit
        .getTemplateViewModel()
        .newsNowArticleTitle(),
      amazonsitePublishDate: this.articlesEdit
        .getTemplateViewModel()
        .filterDate.singleDatePicker(),
      updateAmazonsitePublishDate: this.articlesEdit
        .getTemplateViewModel()
        .updateAmazonsitePublishDate(),
      idDisplayAuthor: this.articlesEdit
        .getTemplateViewModel()
        .filterUser_display_author.idUser(),
      idDisplayAuthors: this.articlesEdit
        .getTemplateViewModel()
        .display_authors.userIds(),
      dateScheduled: this.articlesEdit
        .getTemplateViewModel()
        .filterScheduleDate.singleDatePicker(),
      idDeleteRepublish: this.articlesEdit
        .getTemplateViewModel()
        .idDeleteRepublish(),
      createRepublish: this.articlesEdit
        .getTemplateViewModel()
        .showNewRepublish(),
      republishArticle: {
        idRepublish: this.articlesEdit.getTemplateViewModel().idRepublish(),
        republishDate: this.articlesEdit
          .getTemplateViewModel()
          .filterRepublishDate.singleDatePicker(),
        idRepublishStatus: this.articlesEdit
          .getTemplateViewModel()
          .idRepublishStatus(),
        idAuthor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_republish_author.idUser(),
        idSeniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_republish_SrEditor.idUser(),
        idJuniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_republish_JrEditor.idUser(),
        idPostPaymentCategory: this.articlesEdit
          .getTemplateViewModel()
          .paymentCategoryFilter.selectedOption(),
        amount: this.articlesEdit.getTemplateViewModel().amountAuthor(),
        percentage: this.articlesEdit.getTemplateViewModel().percentageAuthor(),
        percentageEditor: this.articlesEdit
          .getTemplateViewModel()
          .percentageEditor(),
        republishIsUnderEmbargo: this.articlesEdit
          .getTemplateViewModel()
          .republishIsUnderEmbargo(),
      },
      scheduledRepublish: this.articlesEdit
        .getTemplateViewModel()
        .showScheduledRepublish(),
      scheduledRepublishArticle: {
        idRepublish: this.articlesEdit.getTemplateViewModel().idRepublish(),
        republishDate: this.articlesEdit
          .getTemplateViewModel()
          .filterScheduledRepublishDate.singleDatePicker(),
        idAuthor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_scheduled_republish_author.idUser(),
        idSeniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_scheduled_republish_SrEditor.idUser(),
        idJuniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_scheduled_republish_JrEditor.idUser(),
        idPostPaymentCategory: this.articlesEdit
          .getTemplateViewModel()
          .scheduledRepublishPaymentCategoryFilter.selectedOption(),
        amount: this.articlesEdit
          .getTemplateViewModel()
          .scheduledAmountAuthor(),
        percentage: this.articlesEdit
          .getTemplateViewModel()
          .scheduledPercentageAuthor(),
        percentageEditor: this.articlesEdit
          .getTemplateViewModel()
          .scheduledPercentageEditor(),
      },
      title: this.articlesEdit.getTemplateViewModel().title(),
      excerpt: this.articlesEdit.getTemplateViewModel().excerpt(),
      idFeaturedImage: this.articlesEdit.imageWidgetForFeaturedImage
        .getTemplateViewModel()
        .imageId(),
      isFeaturedImageOptimized: this.articlesEdit.imageWidgetForFeaturedImage
        .getTemplateViewModel()
        .imageIsMobileOptimized(),
      idAlternateImage: this.articlesEdit.imageWidgetForAlternateImage
        .getTemplateViewModel()
        .imageId(),
      idThumbnailImage: this.articlesEdit.imageWidgetForThumbnailImage
        .getTemplateViewModel()
        .imageId(),
      // idFeaturedVideoImage : this.articlesEdit.imageWidgetForFeaturedVideo.getTemplateViewModel().imageId(),
      idTemplate: this.articlesEdit.getTemplateViewModel().idTemplate(),
      idTemplateLayout: this.articlesEdit
        .getTemplateViewModel()
        .idTemplateLayout(),
      idClassification: this.articlesEdit
        .getTemplateViewModel()
        .idClassification(),
      idStatus: this.articlesEdit.getTemplateViewModel().idStatus(),
      idAuthor: idAuthor,
      idSeniorEditor: idSeniorEditor,
      idJuniorEditor: idJuniorEditor,
      idIdeator: idIdeator,
      content: contentEditor.getData(),
      additionalCredit: additionalCreditData,
      introText: introTextEditor.getData(),
      sandboxIntroText: sandboxIntroTextEditor.getData(),
      republishIntroText: republishIntroTextEditor.getData(),
      sandboxContent: sandboxEditor.getData(),
      republishContent: republishEditor.getData(),
      smoTitle: this.articlesEdit.getTemplateViewModel().smoTitle(),
      smoDescription: this.articlesEdit.getTemplateViewModel().smoDescription(),
      socialTagLine: this.articlesEdit.getTemplateViewModel().socialTagLine(),
      listOrder: this.articlesEdit.getTemplateViewModel().listOrder(),
      seoTitle: this.articlesEdit.getTemplateViewModel().seoTitle(),
      seoDescription: this.articlesEdit.getTemplateViewModel().seoDescription(),
      fileUrl: this.articlesEdit.getTemplateViewModel().fileUrl(),
      tableOfContents: this.articlesEdit
        .getTemplateViewModel()
        .tableOfContents(),
      isNewsNowArticle: this.articlesEdit
        .getTemplateViewModel()
        .isNewsNowArticle(),
      isSponsored: this.articlesEdit.getTemplateViewModel().isSponsored(),
      isUnderEmbargo: this.articlesEdit.getTemplateViewModel().isUnderEmbargo(),
      displayConfiguration: this.articlesEdit
        .getTemplateViewModel()
        .displayConfiguration(),
      isAdHidden: this.articlesEdit.getTemplateViewModel().isAdHidden(),
      isAmpDisabled: this.articlesEdit.getTemplateViewModel().isAmpDisabled(),
      featuredTags: this.articlesEdit.getTemplateViewModel().featuredTags(),
      isVersusStyle: this.articlesEdit.getTemplateViewModel().isVersusStyle(),
      isAffiliateLinkerEnabled: this.articlesEdit
        .getTemplateViewModel()
        .isAffiliateLinkerEnabled(),
      isDevelopingStory: this.articlesEdit
        .getTemplateViewModel()
        .isDevelopingStory(),
      dateDevelopingStoryCoverageStart: this.articlesEdit
        .getTemplateViewModel()
        .filterDateDevelopingStoryCoverageStart.singleDatePicker(),
      dateDevelopingStoryCoverageEnd: this.articlesEdit
        .getTemplateViewModel()
        .filterDateDevelopingStoryCoverageEnd.singleDatePicker(),
      faqs: this.articlesEdit.getTemplateViewModel().faqs(),
      directoryItems: this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .directoryItems(),
      deletedDirectoryItems: this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems(),
      sandboxDirectoryItems: this.articlesEdit.sandboxDirectory
        .getTemplateViewModel()
        .directoryItems(),
      sandboxDeletedDirectoryItems: this.articlesEdit.sandboxDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems(),
      republishDirectoryItems: this.articlesEdit.republishDirectory
        .getTemplateViewModel()
        .directoryItems(),
      republishDeletedDirectoryItems: this.articlesEdit.republishDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems(),
      idPrimaryCategory: this.articlesEdit
        .getTemplateViewModel()
        .idPrimaryCategory(),
      idPrimaryTag: this.articlesEdit.getTemplateViewModel().idPrimaryTag(),
      selectedCategories: this.articlesEdit
        .getTemplateViewModel()
        .selectedCategories(),
      selectedTags: this.articlesEdit.getTemplateViewModel().selectedTags(),
      reviewItems: this.articlesEdit.getReviewItems(),
      sandboxReviewItems: this.articlesEdit.getSandboxReviewItems(),
      reviewItemsToDelete: this.articlesEdit.getReviewItemsToDelete(),
      sandboxReviewItemsToDelete:
        this.articlesEdit.getSandboxReviewItemsToDelete(),
      republishReviewItems: this.articlesEdit.getRepublishReviewItems(),
      republishReviewItemsToDelete:
        this.articlesEdit.getRepublishReviewItemsToDelete(),
      idDirectoryArticle:
        this.articlesEdit.getTemplateViewModel().filterArticleDirectory
          .idArticle,
      isFeaturedTagActive: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedTagActive(),
      pinnedTag: this.articlesEdit.getPinnedTag(),
      pinnedTags: {
        title: this.articlesEdit.articlePinnedTags
          .getTemplateViewModel()
          .title(),
        position: this.articlesEdit.articlePinnedTags
          .getTemplateViewModel()
          .position(),
        style: this.articlesEdit.articlePinnedTags
          .getTemplateViewModel()
          .selectedStyle(),
        tagTypeSpec:
          this.articlesEdit.articlePinnedTags.getTemplateViewModel()
            .selectedTagSpec,
        tags: this.articlesEdit.articlePinnedTags.getTemplateViewModel().tags(),
      },
      reviewTag: isReviewOrProductReviewContentType ? this.articlesEdit.filterReviewTag.getOptionObj() : null,
      updateLatestRepublishDateIsChecked: this.articlesEdit
        .getTemplateViewModel()
        .updateLatestRepublishDateIsChecked(),
      latestRepublishId: this.articlesEdit
        .getTemplateViewModel()
        .latestRepublishId(),
      template: this.articlesEdit.getTemplateViewModel().template(),
      isFeaturedImageHidden: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedImageHidden(),
      isCommentsDisabled: this.articlesEdit
        .getTemplateViewModel()
        .isCommentsDisabled(),
      isCommentsPaused: this.articlesEdit
        .getTemplateViewModel()
        .isCommentsPaused(),
      isRatingEnabled: this.articlesEdit
        .getTemplateViewModel()
        .isRatingEnabled(),
      isReadNextDisabled: this.articlesEdit
        .getTemplateViewModel()
        .isReadNextDisabled(),
      isDisplayCardQuickLinksShown: this.articlesEdit
        .getTemplateViewModel()
        .isDisplayCardQuickLinksShown(),

      isDisplayCardQuickLinksMobileShown: this.articlesEdit
        .getTemplateViewModel()
        .isDisplayCardQuickLinksMobileShown(),
      isSidebarHidden: this.articlesEdit
        .getTemplateViewModel()
        .isSidebarHidden(),
      featuredVideo: this.articlesEdit.getTemplateViewModel().featuredVideo(),
      isFeaturedVideoActive: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedVideoActive(),
      featuredEmbed: this.articlesEdit.getTemplateViewModel().featuredEmbed(),
      isFeaturedEmbedActive: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedEmbedActive(),
      isUpdateTime: this.articlesEdit.getTemplateViewModel().isUpdateTime(),
      newsletterSendToSelf: this.articlesEdit
        .getTemplateViewModel()
        .newsletterSendToSelf(),
      newsletterSubject: this.articlesEdit
        .getTemplateViewModel()
        .newsletterSubject(),
      newsletterPreviewText: this.articlesEdit
        .getTemplateViewModel()
        .newsletterPreviewText(),
      newsletterRecipientsEmails: this.articlesEdit
        .getTemplateViewModel()
        .newsletterRecipientsEmails(),
      newsletterSelectedMailingLists: this.articlesEdit
        .getTemplateViewModel()
        .selectedMailingLists(),
      newsletterTemplate:
        this.articlesEdit.getTemplateViewModel().newsletterTemplateSelector
          .selectedOption,
      newsletterDateScheduled: this.articlesEdit
        .getTemplateViewModel()
        .newsletterDateScheduledSelector.singleDatePicker(),
      articleReviewComments: this.articlesEdit
        .getTemplateViewModel()
        .articleReviewComments(),
      featuredVideoTitle: this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoTitle(),
      featuredVideoDescription: this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoDescription(),
      dateLastPreview: this.articlesEdit
        .getTemplateViewModel()
        .dateLastPreview(),
      prompt: this.articlesEdit.getTemplateViewModel().prompt(),
      promptResponse: this.getRichTextForPromptResponseEditor(),
      idPromptAuthor: this.articlesEdit
        .getTemplateViewModel()
        .filterWebsiteUser_prompt_author.idUser(),
      promptLink: this.articlesEdit.getTemplateViewModel().promptLink(),
      sensaiCoverageScore: this.articlesEdit.getSensaiCoverageScore(),
      contentGuidelineScore: this.articlesEdit.getContentGuidelineScore()
        ? this.articlesEdit.getContentGuidelineScore()
        : this.articlesEdit.sensaiPromptTemplate.getContentGuidelineScore(),
      sourceUrl: this.articlesEdit.getTemplateViewModel().sourceUrl(),
      sourceTime: this.articlesEdit.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker()
    };

    return postData;
  }

  public sendNewsletter() {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/newsletter/send/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = this.getSavePostData();
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onSendNewsletterReturn;
    XHRHdl.execute();
  }

  public onSendNewsletterReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        obj.getVnAppZone().notification = new vn_app_zone_notification(
          vn_app_zone_notification.TYPE_SUCCESS,
          "Newsletter Delivery Scheduled !"
        );
        obj.getVnAppZone().showNotificationToModule();
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected save(type) {
    console.log("Save: " + new Date(+Date.now()).toLocaleTimeString());

    this.loadingIn(this.articlesEdit.builtTemplate);

    let queryParams = new URLSearchParams(window.location.search);
    let formReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/article/save/`;
    let formReq_params: Array<Array<string>> = [];
    let subViewModel = this.getSavePostData();
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    if (queryParams.has("idThreadSuggestion")) {
      formReq_params.push(["idThreadSuggestion", queryParams.get("idThreadSuggestion")]);
    }

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    //XHRHdl.onReadyStateFunction = this.onSaveReturn;
    if (type == "stay") {
      this.clearRecoverySave();
      this.clearRecoveryWarning();
      this.loadingIn(this.articlesEdit.builtTemplate);
      XHRHdl.onReadyStateFunction = this.onStayReturn;
    } else if (type == "save") {
      this.clearRecoverySave();
      this.clearRecoveryWarning();
      // minimize editor on save
      this.minimizeAllEditors();
      this.loadingIn(this.articlesEdit.builtTemplate);
      XHRHdl.onReadyStateFunction = this.onSaveReturn;
    } else if (type == "preview") {
      XHRHdl.onReadyStateFunction = this.onPreviewReturn;
    } else if (type == "republish") {
      this.clearRecoverySave();
      this.clearRecoveryWarning();
      this.loadingIn(this.articlesEdit.builtTemplate);
      XHRHdl.onReadyStateFunction = this.onRepublishSaveReturn;
    } else {
      XHRHdl.onReadyStateFunction = this.onAMPPreviewReturn;
    }

    XHRHdl.execute();

    this.saveArticleAiSummaries();
  }

  protected previewArticle(type) {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/previewNoSave/0";

    if (type == "preview-email") {
      formReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/article/previewEmail/0";
    }

    let formReq_params: Array<Array<string>> = [];
    let subViewModel = this.getSavePostData();

    //push article data and content type to pass to article and emakiArticle creators
    formReq_params.push(["data", ko.toJSON(subViewModel)]);
    formReq_params.push([
      "content",
      this.articlesEdit.getContentTypeToPreview(),
    ]);
    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    //using post to avoid data size limitation of GET
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    if (type == "preview") {
      XHRHdl.onReadyStateFunction = this.onPreviewReturn;
    } else if (type == "preview") {
      XHRHdl.onReadyStateFunction = this.onPreviewEmailReturn;
    } else {
      XHRHdl.onReadyStateFunction = this.onAMPPreviewReturn;
    }

    XHRHdl.execute();
  }

  protected onSaveReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.setArticleReviewComments("");
        obj.clearRecoverySave();
        //release lock
        obj.releaseLock();

        obj.stopWatchScroll();
        obj.getVnAppZone().app.removeWarningEventListeners();
        obj.redirectToArticlesList();
        if (
          responseParsed.data &&
          responseParsed.data.prependAIkeyPointsToContent
        ) {
          obj.showKeyTakeawayAddedNotification();
        }
      });

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onRepublishSaveReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.isSaveAndStay = true;
        obj.articlesEdit.setIsNoticeVisible(false);
        obj.articlesEdit.setArticleLockedStatus(false);
        obj.handleArticleEditionAfterSaveAndStay(responseParsed, "stay");
        obj.articlesEdit.updateArticleOnRepublish();
        obj.articlesEdit.clearRepublishSection();
        if (
          responseParsed.data &&
          responseParsed.data.prependAIkeyPointsToContent
        ) {
          obj.showKeyTakeawayAddedNotification();
        }
      });

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected clearRecoverySave() {
    if (this.recoveryTimeout) {
      clearTimeout(this.recoveryTimeout);
      this.recoveryTimeout = null;
    }
    if (this.lastUpdatedTimer) {
      clearInterval(this.lastUpdatedTimer);
      this.lastUpdatedTimer = null;
    }
  }

  protected clearRecoveryWarning() {
    if (this.recoveryWarning) {
      clearInterval(this.recoveryWarning);
      this.recoveryWarning = null;
    }
  }

  protected setContentFocusHandlers() {
    contentEditor = CKEDITOR.instances.article_content;
    introTextEditor = CKEDITOR.instances.productReview_intro_text;
    sandboxEditor = CKEDITOR.instances.article_sandbox;
    sandboxIntroTextEditor = CKEDITOR.instances.productReviewSandbox_intro_text;
    this.addFocusHandler([
      contentEditor,
      introTextEditor,
      sandboxIntroTextEditor,
      sandboxEditor,
    ]);
  }

  protected onStayReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        obj.isSaveAndStay = true;
        obj.articlesEdit.setIsNoticeVisible(false);
        obj.articlesEdit.setArticleLockedStatus(false);
        obj.articlesEdit.setArticleReviewComments("");
        obj.handleArticleEditionAfterSaveAndStay(responseParsed, "stay");
        obj.articlesEdit.handleInDirectoryState();

        //PME-3186: reflect updated permalink and redirect history on save&stay action
        if (responseParsed.data.permalinkHistory) {
          obj.articlesEdit.setPermalinkHistory(
            responseParsed.data.permalinkHistory
          );
        }
        if (responseParsed.data.permalinkRedirects) {
          obj.articlesEdit.setPermalinkRedirect(
            responseParsed.data.permalinkRedirects
          );
        }

        if (
          responseParsed.data &&
          responseParsed.data.prependAIkeyPointsToContent
        ) {
          obj.showKeyTakeawayAddedNotification();
        }
      });

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onPreviewReturn(req, obj) {
    return function () {
      if (req.request.status == 423) {
        let responseParsed = JSON.parse(req.request.response);
        obj.handleArticleEditionWhenLocked(responseParsed);
      } else {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.handleArticleEditionAfterSaveAndStay(responseParsed, "preview");
        });
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onPreviewEmailReturn(req, obj) {
    return function () {
      if (req.request.status == 423) {
        let responseParsed = JSON.parse(req.request.response);
        obj.handleArticleEditionWhenLocked(responseParsed);
      } else {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_SUCCESS,
            "Preview sent to your email."
          );
          obj.getVnAppZone().showNotificationToModule();
        });
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onAMPPreviewReturn(req, obj) {
    return function () {
      if (req.request.status == 423) {
        let responseParsed = JSON.parse(req.request.response);
        obj.handleArticleEditionWhenLocked(responseParsed);
      } else {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.handleArticleEditionAfterSaveAndStay(
            responseParsed,
            "preview-amp"
          );
        });
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  public handleArticleEditionWhenLocked(response): void {
    this.clearRecoverySave();

    this.articlesEdit.setKickoutkMessage(response.message);
    this.articlesEdit.setIsKickoutMessageVisible(true);
    this.articlesEdit.setArticleLockedStatus(true);
    this.articlesEdit.enableSaveButtons();
  }

  public clearRecoveryData() {
    this.articlesEdit.setRecoveryContent(null);
    this.articlesEdit.setRecoveryIntroText(null);
    this.articlesEdit.setRecoveryReviewItems([]);
    this.articlesEdit.setDateRecovery(null);
    this.articlesEdit.setRecoveryUser(null);
    this.articlesEdit.setRecovery(null);
    this.articlesEdit.setSandboxRecoveryContent(null);
    this.articlesEdit.setSandboxRecoveryIntroText(null);
    this.articlesEdit.setRecoverySandboxReviewItems([]);
  }

  private displayLastSavedTime() {
    let curDate = new Date(Date.now());
    this.articlesEdit
      .getTemplateViewModel()
      .lastSaveRecoveryAttempt(
        `${curDate.toDateString()} ${curDate.toLocaleTimeString()}`
      );
    if (this.hasLastSuccessfulAutosave) {
      let minutesAgo = Math.floor(
        (curDate.getTime() - this.lastSaved.getTime()) / 60000
      );
      if (minutesAgo < 1) {
        this.articlesEdit.setLastSaved("moments ago");
      } else if (minutesAgo === 1) {
        this.articlesEdit.setLastSaved("a minute ago");
      } else if (minutesAgo < 60) {
        this.articlesEdit.setLastSaved(minutesAgo + " minutes ago");
        if (minutesAgo > 6) {
          this.articlesEdit.setArticleAutoSaveError(true);
        }
      } else {
        this.articlesEdit.setLastSaved(
          Math.floor(minutesAgo / 60) + " hour(s) ago"
        );
        this.articlesEdit.setArticleAutoSaveError(true);
      }
    }
  }

  public handleArticleEditionAfterSaveAndStay(response, type): void {
    //If type is save and stay, then set article and sandbox data from passed, and go to /edit/ in case of first save.
    if (type == "stay") {
      this.clearRecoveryData();
      this.clearRecoverySave();
      this.lastSaved = new Date(Date.now());

      //this.articlesEdit.showAutoSaveMessage("Article saved manually - not autosaving until changes made.");
      this.articlesEdit.setArticleAutoSaveError(false);
      this.articlesEdit.disableAutosaveBox();

      // start autosave timer
      this.startAutosave("SaveAndStay");

      let value =
        response.data && response.data.prependAIkeyPointsToContent
          ? "refreshAfterKeyPointsAdded"
          : "refresh";
      this.setArticleData(response.data.article, value);
      this.setDisplayAuthors(response.data.displayAuthors);
      this.setPublishStatusOptions(response.data.article);
      if (this.articlesEdit.isArticleActiveTab("reviews")) {
        this.getSensaiArticleReferences(
          "article_content",
          response.data.article.id
        );
      }
      this.setContentFocusHandlers();
      window.history.pushState(
        "page2",
        "Emaki CMS",
        "/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/edit/" +
        response.data.article.id
      );
    }
    if (type == "preview") {
      if (response.data.dateLastPreview) {
        this.articlesEdit.setDateLastPreview(response.data.dateLastPreview);
      }
      this.openArticlePreview(response.data);
    }
    if (type == "preview-amp") {
      this.openArticlePreview(response.data, true);
    }
  }

  protected viewArticleOnSite(brand, permalink) {
    let origin = document.location.origin;
    let brandDomain = brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    let url = origin.replace("emakicms.com", brandDomain) + permalink;

    if (url.includes("mig1")) {
      url = url.replace("mig1", "qa2");
    }

    if (url.includes("mig2")) {
      url = url.replace("mig2", "qa1");
    }

    if (url.includes("mig3")) {
      url = url.replace("mig3", "qa3");
    }

    if (url.includes("mig4")) {
      url = url.replace("mig4", "qa2");
    }

    let element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected viewArticleOnSiteAMP(brand, permalink) {
    let origin = document.location.origin;
    let brandDomain = brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    let url = origin.replace("emakicms.com", brandDomain) + permalink + "amp";

    let element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected openArticlePreview(data, isAmp = false) {
    let origin = document.location.origin;
    let brandDomain = data.brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    //let url = '';
    //REMOVE THIS GOING LIVE
    // if(brandDomain.includes("topspeed.com") && !brandDomain.includes("ads.topspeed.com")){
    //     brandDomain = brandDomain.replace("topspeed.com","ads.topspeed.com");
    // }

    let url =
      origin.replace("emakicms.com", brandDomain) +
      "/preview/" +
      data.emakiPreview.id +
      "/";

    if (url.includes("mig1")) {
      const location = () => {
        switch (data.brand.shortName) {
          case "SR":
            return "qa2";
          case "HG":
            return "qa3";
          case "GR":
            return "qa2";
          case "SF":
            return "qa5";
          default:
            return "qa1";
        }
      };

      url = url.replace("mig1", location());
    } else if (url.includes("mig3")) {
      url = url.replace("mig3", "qa3");
    } else if (url.includes("mig2")) {
      url = url.replace("mig2", "qa1");
    } else if (url.includes("mig4")) {
      if (data.brand.id == 33) {
        url = url.replace("mig4", "qa2");
      } else if (data.brand.id == 34) {
        url = url.replace("mig4", "qa3");
      } else {
        url = url.replace("mig4", "qa2");
      }
    }

    if (isAmp) {
      url = url + "amp/";
    }

    var f = document.createElement("form");
    f.action = url;
    f.method = "POST";
    f.target = "_blank";

    var i = document.createElement("input");
    i.type = "hidden";
    i.name = "token";
    i.value = "PWjvmuQqaq`;33}4";
    f.appendChild(i);

    var c = document.createElement("input");
    c.type = "hidden";
    c.name = "content";
    c.value = this.articlesEdit.getContentTypeToPreview();
    f.appendChild(c);

    //if an emakiPreview was created, then add it so the brand site can read it. Otherwise add nothing so the brand site can read from DB instead.
    if (data.emakiPreview) {
      var c = document.createElement("input");
      c.type = "hidden";
      c.name = "article";
      c.value = JSON.stringify(data.emakiPreview);
      f.appendChild(c);
    }

    document.body.appendChild(f);
    f.submit();
    document.body.removeChild(f);
  }

  protected onSyncReturn(req, obj) {
    // this.clearRecoveryData();
    this.clearRecoverySave();

    return function () {
      obj.manageResponse(req, obj, function () {
        obj.redirectToArticlesList();
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected getAffiliatesSuggestion(keyword, limit) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { filter: { keyword: keyword, limit: limit } };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/search/affiliate/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetAffiliatesSuggestionReturn;
    this.XHRHdl.execute();
  }
  protected onGetAffiliatesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteAffiliate_template"
        ) {
          obj.articlesEdit.filterAffiliates
            .getTemplateViewModel()
            .suggestedObj(responseParsed.affiliates[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteAffiliate_template"
        ) {
          obj.articlesEdit.filterAffiliates.setOptions(
            responseParsed.affiliates
          );
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteTagViewAffiliate_template"
        ) {
          obj.articlesEdit.tagPicker.setTagViewAffiliateFilterOptions(
            responseParsed.affiliates
          );
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteTagEditAffiliate_template"
        ) {
          obj.articlesEdit.tagPicker.setTagEditAffiliateFilterOptions(
            responseParsed.affiliates
          );
        }
      });
    };
  }

  public getLocaleSuggestion(keyword) {
    const locales = this.articlesEdit.tagPicker.getTagEditLocales();

    if (typeof locales != "undefined") {
      let matches = locales.filter((l) => (
        l.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
        l.countryCode.toLowerCase() === keyword.toLowerCase()
      ));

      this.articlesEdit.tagPicker.setTagEditLocaleFilterOptions(matches);
      return matches;
    }

    return null;
  }

  protected getTagsTypeSuggestion(
    keyword,
    limit,
    restrictOwnedTagTypes = false
  ) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = {
      filter: {
        keyword: keyword,
        limit: limit,
        restrictOwnedTagTypes: restrictOwnedTagTypes,
      },
    };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/search/tag/type/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
    this.XHRHdl.execute();
  }


  public getTagsSuggestion(keyword, idSourceElement) {
    this.getSuggestions(keyword, idSourceElement);
  }

  protected getTagsSuggestionOnInput(
    keyword,
    limit,
    tagType,
    getSelectable,
    getNonSelectable,
    imageAndSpecSelectable,
    specFields = false
  ) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = {
      filter: {
        keyword: keyword,
        limit: limit,
        idTagType: tagType ? tagType.id : null,
        getSelectable: getSelectable,
        getNonSelectable: getNonSelectable,
        imageAndSpecSelectable: imageAndSpecSelectable,
        specFields: specFields,
      },
    };

    let usrReq_url: string =
      "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagTypesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let tagTypes = responseParsed.data.tagTypes;

        if (Array.isArray(tagTypes) && tagTypes.length > 0) {
          tagTypes.forEach((tagType) => {
            if (tagType.dataset !== null) {
              tagType.name += `   ${tagType.formattedDataset}`;
            }
          });
        }

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteProductType_template"
        ) {
          obj.articlesEdit.filterProductTypes
            .getTemplateViewModel()
            .suggestedObj(tagTypes[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteProductType_template"
        ) {
          obj.articlesEdit.filterProductTypes.setOptions(tagTypes);
        } else if (obj.XHRHdlCaller == "getSuggestions_filterTagType") {
          obj.articlesEdit.tagPicker.setTagTypeOptions(tagTypes);
        } else if (obj.XHRHdlCaller == "getSuggestions_filterAddNewTagType") {
          //const idBrand = obj.getVnAppZone().app.params.idBrand;
          // filter out owned tag types that aren't owned by this brand.
          //tagTypes = tagTypes.filter((tagType: emaki_tag_type) => tagType.brandOwner? tagType.brandOwner.id == idBrand : true);

          obj.articlesEdit.tagPicker.setAddNewTagTypeOptions(tagTypes);
        } else if (obj.XHRHdlCaller == "getSuggestions_filterEditTagType") {
          obj.articlesEdit.tagPicker.setEditTagTypeOptions(tagTypes);
        } else if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteTagTypeArticlePinnedTags_template"
        ) {
          obj.articlesEdit.articlePinnedTags.filterTagType
            .getTemplateViewModel()
            .suggestedObj(tagTypes[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteTagTypeArticlePinnedTags_template"
        ) {
          obj.articlesEdit.articlePinnedTags.filterTagType.setOptions(tagTypes);
        } else if (
          obj.XHRHdlCaller == "getSuggestions_tagPickerSourceFilterTagType"
        ) {
          obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.tagPickerSourceFilterTagType.setOptions(
            tagTypes
          );
        }
      });
    };
  }

  protected onGetTagsSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        if (responseParsed.data.tags) {
          if (
            obj.XHRHdlCaller ==
            "getSuggestions_filterAutocompletePinnedTags_template"
          ) {
            let tags = responseParsed.data.tags;
            for (let i = 0; i < tags.length; i++) {
              if (tags[i].tagType !== null) {
                tags[i].name = tags[i].name + "   (" + tags[i].tagType + ")";
              }
            }
            obj.articlesEdit.filterPinnedTag.setOptions(tags);
          } else if (
            obj.XHRHdlCaller ==
            "getSuggestions_filterAutocompleteTagArticlePinnedTags_template"
          ) {
            let tags = responseParsed.data.tags;
            for (let i = 0; i < tags.length; i++) {
              if (tags[i].tagType !== null) {
                tags[i].name =
                  tags[i].name + "  " + tags[i].formattedTagTypeAndDataset;
              }
            }
            obj.articlesEdit.articlePinnedTags.filterTags.setOptions(tags);
          } else if (
            obj.XHRHdlCaller ==
            "getSuggestions_filterAutocompleteReviewTag_template"
          ) {
            let tags = responseParsed.data.tags;
            for (let i = 0; i < tags.length; i++) {
              if (tags[i].tagType !== null) {
                tags[i].name =
                  tags[i].name + "  " + tags[i].formattedTagTypeAndDataset;
              }
            }
            obj.articlesEdit.filterReviewTag.setOptions(tags);
          } else if (obj.XHRHdlCaller == "getSuggestions_filterVideoTag") {
            obj
              .getVideoPickerTemplate()
              .tagFilter.getTemplateViewModel()
              .tags(responseParsed.data.tags);
          } else if (obj.XHRHdlCaller == "getSuggestions_filterVideoTagEdit") {
            obj
              .getVideoPickerEditTemplate()
              .setTagFilterAutocomplete(responseParsed.data.tags);
          } else if (
            obj.XHRHdlCaller == "getSuggestions_filterTagImagePickerEdit"
          ) {
            obj
              .getImagePickerEditTemplate()
              .filterTag.getTemplateViewModel()
              .tags(responseParsed.data.tags);
          } else {
            obj.articlesEdit.setTagFilterAutocomplete(responseParsed.data.tags);
          }
        }
      });
    };
  }

  public save_recovery(saveMode = "") {
    this.clearRecoverySave(); // clears existing timer

    console.log(
      "Autosaving (" +
      saveMode +
      ") : " +
      new Date(+Date.now()).toLocaleTimeString()
    );
    this.articlesEdit.setIsAutosaving(true);

    this.recoverySaveMode = saveMode;

    //if we are not in the edit page anymore, clear the recovery save
    let len = this.getVnAppZone().app.routeHistory.length;
    let lastRoute = this.getVnAppZone().app.routeHistory[len - 1];

    //clear the auto-save if we are no longer on the articles edit page
    if (
      !lastRoute.includes("/articles/edit") &&
      !lastRoute.includes("/articles/add")
    ) {
      this.clearRecoveryData();
      //this.clearRecoverySave();
    }

    let idArticle = this.articlesEdit.getId();
    let content = contentEditor.getData();
    let sandboxContent = sandboxEditor.getData();
    let republishContent = republishEditor.getData();
    let articleIntroText = introTextEditor.getData();
    let sandboxIntroText = sandboxIntroTextEditor.getData();
    let republishIntroText = republishIntroTextEditor.getData();

    let isContentAvailable =
      (content != null && content != "") ||
      (sandboxContent != null && sandboxContent != "") ||
      (republishContent != null && republishContent != "") ||
      (articleIntroText != null && articleIntroText != "") ||
      (sandboxIntroText != null && sandboxIntroText != "") ||
      (republishIntroText != null && republishIntroText != "");
    let isReviewItemAvailable = this.articlesEdit.getReviewItems().length > 0;
    let isDirectoryItemAvailable =
      this.articlesEdit.articleDirectory.getDirectoryItems().length > 0;
    let isSandboxReviewItemAvailable =
      this.articlesEdit.getSandboxReviewItems().length > 0;
    let isRepublishReviewItemAvailable =
      this.articlesEdit.getRepublishReviewItems().length > 0;
    let isSandboxDirectoryItemAvailable =
      this.articlesEdit.sandboxDirectory.getDirectoryItems().length > 0;
    let isRepublishDirectoryItemAvailable =
      this.articlesEdit.republishDirectory.getDirectoryItems().length > 0;

    if (
      isContentAvailable ||
      isReviewItemAvailable ||
      isSandboxReviewItemAvailable ||
      isRepublishReviewItemAvailable ||
      isDirectoryItemAvailable ||
      isSandboxDirectoryItemAvailable ||
      isRepublishDirectoryItemAvailable
    ) {
      this.articlesEdit.disableSaveButtons();
      let formReq_url: string =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/article/recovery/save/";
      let formReq_params: Array<Array<string>> = [];

      let subViewModel = this.getSavePostData();

      //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
      formReq_params.push(["data", ko.toJSON(subViewModel)]);

      let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
        formReq_url,
        formReq_params,
        this
      );
      XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      XHRHdl.onReadyStateFunction = this.onSaveRecoveryReturn;
      XHRHdl.execute();
    }
  }

  protected onSaveRecoveryReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        // whatever our save state, autosaving is no longer happening.
        obj.articlesEdit.setIsAutosaving(false);

        if (req.request.status == 401) {
          const lastSaveRecoveryAttempt = obj.articlesEdit
            .getTemplateViewModel()
            .lastSaveRecoveryAttempt();
          const message = `Your session expired. You will not be able to use save actions and any changes since ${lastSaveRecoveryAttempt} will be lost. Please backup any changes you may need.`;

          obj.lastSaved = "Not saved";
          obj.articlesEdit
            .getTemplateViewModel()
            .sessionExpiredOnSaveRecovery(true);
          obj.articlesEdit.showAutoSaveMessage(
            "Session expired. Autosave disable"
          );

          obj.articlesEdit.warningDialog_WhenLogOut.hideCancelBtn();
          obj.articlesEdit.warningDialog_WhenLogOut.setIsVisible(true);
          obj.articlesEdit.warningDialog_WhenLogOut.setTitle(
            "Session Expired!"
          );
          obj.articlesEdit.warningDialog_WhenLogOut.setMessage(message);

          obj.articlesEdit.setNoticeMessage(message);
          obj.articlesEdit.setIsNoticeVisible(true);
          obj.articlesEdit.setArticleLockedStatus(true);

          obj.articlesEdit.setLastSaved("Session Expired");
          obj.articlesEdit.setArticleAutoSaveError(true);

          obj.clearRecoverySave();
          obj.clearRecoveryWarning();
          obj.startAutosave(null);
        } else if (req.request.status == 423) {
          obj.manageResponse(req, obj, function () {
            let response = JSON.parse(req.request.response);
            const { message } = response;

            if (message) {
              obj.articlesEdit.showAutoSaveMessage(
                "Locked out of post. Could not autosave."
              );

              obj.clearRecoverySave();
              obj.articlesEdit.warningDialog_WhenArticleLock.hideCancelBtn();
              obj.articlesEdit.warningDialog_WhenArticleLock.setIsVisible(true);
              obj.articlesEdit.warningDialog_WhenArticleLock.setTitle(
                "Article Locked"
              );
              obj.articlesEdit.warningDialog_WhenArticleLock.setMessage(
                message
              );

              obj.articlesEdit.setNoticeMessage(message);
              obj.articlesEdit.setIsNoticeVisible(true);
              obj.articlesEdit.setArticleLockedStatus(true);

              obj.articlesEdit.setLastSaved("Article Locked");
              obj.articlesEdit.setArticleAutoSaveError(true);

              obj.clearRecoverySave();
              obj.clearRecoveryWarning();
              obj.startAutosave(null);
            }
          });
        } else if (req.request.status == 200) {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);

            if (responseParsed.data) {
              if (responseParsed.data.id && obj.articlesEdit.getId() == null) {
                obj.articlesEdit.setId(responseParsed.data.id);
                window.history.pushState(
                  "page2",
                  "Emaki CMS",
                  "/brand/" +
                  obj.getVnAppZone().app.params.idBrand +
                  "/articles/edit/" +
                  responseParsed.data.id
                );
              }

              if (responseParsed.data.title) {
                obj.articlesEdit.setTitle(responseParsed.data.title);
              }
              obj.hasLastSuccessfulAutosave = true;
            }
          });
          //Enabling save buttons that were disabled in saveRecoveryReturn call
          obj.articlesEdit.enableSaveButtons();

          // track last saved here, upon successful return from api
          obj.lastSaved = new Date(Date.now());
          obj.displayLastSavedTime();
          obj.articlesEdit.showAutoSaveMessage("Saved");
          obj.articlesEdit.setArticleAutoSaveError(false);
          obj.articlesEdit.enableAutosaveBox();

          obj.articlesEdit.setIsNoticeVisible(false);
          obj.articlesEdit.setNoticeMessage("");

          // start new autosave process
          obj.startAutosave("onSaveRecoveryReturn");
        } else {
          // catch all other status codes

          obj.articlesEdit.showAutoSaveMessage("Not-Autosaved");
          obj.articlesEdit.setArticleAutoSaveError(true);
          obj.articlesEdit.enableAutosaveBox();

          // set new save attempt
          if (obj.recoverySaveMode != "manual") {
            obj.startAutosave("manualRecoveryAfterFail");
          }

          obj.articlesEdit.enableSaveButtons();
        }
      }
    };
  }

  //image picker functions
  protected getImageData(keyword = null) {
    if (this.imageXHRHdl) {
      this.imageXHRHdl.cancelAndReset();
    }

    this.articlesEdit.imagePicker.showLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/images/get/";
    let formReq_params: Array<Array<string>> = [];

    //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
    let viewModel = this.articlesEdit.imagePicker.getViewModelForRequest();
    /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
    formReq_params.push(["data", ko.toJSON(viewModel)]);

    this.imageXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
    this.imageXHRHdl.execute();
  }

  protected onGetImageDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        obj.articlesEdit.imagePicker.hideLoading();
        if (
          obj.articlesEdit.imagePicker.getSelectedTab() == "images" ||
          obj.isSaveImage
        ) {
          obj.isSaveImage = false;
        }
      });
    };
  }

  protected updateImagePickerForm(responseParsed) {
    let selectedImages = this.articlesEdit.imagePicker.getSelectedImages();

    if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
      for (let image of responseParsed.paginatedImages.data) {
        image.selected = false;
        let imageSelected = selectedImages.find((i) => i.id == image.id);
        if (imageSelected) {
          image.selected = true;
        }
        image.fileSize = this.bytesToSize(image.fileSize);
      }
      this.articlesEdit.imagePicker.setImagesPagination(
        responseParsed.paginatedImages
      );
      this.articlesEdit.imagePicker.setImageResults(
        responseParsed.paginatedImages.data
      );
    }

    if (responseParsed.imagesInContent) {
      for (let image of responseParsed.imagesInContent) {
        image.selected = false;
        let imageSelected = selectedImages.find((i) => i.id == image.id);
        if (imageSelected) {
          image.selected = true;
        }
        image.fileSize = this.bytesToSize(image.fileSize);
      }
      this.articlesEdit.imagePicker.setImagesInContent(
        responseParsed.imagesInContent
      );
    }

    let selectedGallery = this.articlesEdit.imagePicker.getSelectedGallery();

    if (
      responseParsed.paginatedGalleries &&
      responseParsed.paginatedGalleries.data
    ) {
      for (let gallery of responseParsed.paginatedGalleries.data) {
        gallery.selected = false;
        if (selectedGallery != null) {
          if (selectedGallery.id == gallery.id) {
            gallery.selected = true;
          }
        }
      }
      this.articlesEdit.imagePicker.setGalleryPagination(
        responseParsed.paginatedGalleries
      );
      this.articlesEdit.imagePicker.setGalleryResults(
        responseParsed.paginatedGalleries.data
      );
    }

    if (responseParsed.ratios) {
      this.articlesEdit.imagePicker.setRatios(responseParsed.ratios);
    }

    if (responseParsed.orientations) {
      this.articlesEdit.imagePicker.setOrientations(
        responseParsed.orientations
      );
    }

    if (responseParsed.uploadSources) {
      this.articlesEdit.imagePicker.setUploadSources(
        responseParsed.uploadSources,
        responseParsed.selectedUploadSource
      );
    }

    if (responseParsed.idBrand) {
      this.articlesEdit.imagePicker.setIdBrand(responseParsed.idBrand);
    }
  }

  protected bytesToSize(bytes) {
    var sizes = ["KB", "MB", "GB", "TB"];
    if (bytes == 0) return "n/a";
    var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
    if (i == 0) return bytes + " " + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
  }

  protected saveImages(images, insert, param, insertType = "image") {
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/images/save/";
    let formReq_params: Array<Array<string>> = [];

    formReq_params.push(["data", ko.toJSON(images)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let response = JSON.parse(req.request.response);

          let target = obj.articlesEdit.getImagePickerTarget();

          if (target == "featured_image") {
            obj.articlesEdit.imageWidgetForFeaturedImage.setImage(
              response.images[0].image
            );
          }

          if (target == "alternate_image") {
            obj.articlesEdit.imageWidgetForAlternateImage.setImage(
              response.images[0].image
            );
          }

          if (target === "thumbnail_image") {
            obj.articlesEdit.imageWidgetForThumbnailImage.setImage(
              response.images[0].image
            );
          }

          // if(target === 'featured_video_image'){
          //     obj.articlesEdit.imageWidgetForFeaturedVideo.setImage(response.images[0].image)
          // }

          obj.articlesEdit.setImagePickerTarget(null);

          obj.articlesEdit.imagePicker.onImageSaveReturn(
            response.images,
            insert,
            param,
            insertType
          );

          obj.getImageData();
        });
      };
    };
    XHRHdl.execute();
  }

  protected saveGallery(gallery, insert, param) {
    this.isSaveGallery = true;
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/galleries/save/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", ko.toJSON(gallery)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.articlesEdit.imagePicker.onGallerySaveReturn(
            responseParsed.gallery,
            insert,
            param
          );
          obj.getGalleryData();
        });
      };
    };
    XHRHdl.execute();
  }

  protected deleteImage(image) {
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/images/delete/" + image.id;
    let formReq_params: Array<Array<string>> = [];

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.articlesEdit.imagePicker.showLoading();
    XHRHdl.onReadyStateFunction = (req, obj) => () => {
      if (req.request.status == 400) {
        obj.articlesEdit.imagePicker.hideLoading();
        obj.articlesEdit.imagePicker.hide();
      }

      obj.manageResponse(req, obj, function () {
        // let responseParsed = JSON.parse(req.request.response);
        obj.getImageData();
      });
    };
    XHRHdl.execute();
  }

  protected handleFiles(files) {
    this.uploadImages(files);
  }

  protected initializeProgress(numFiles) {
    this.progressBar = <HTMLProgressElement>(
      document.getElementById("progress-bar")
    );
    this.progressBar.value = 0;
    this.uploadProgress = [];

    for (let i = numFiles; i > 0; i--) {
      this.uploadProgress.push(0);
    }
  }

  protected resetProgress() {
    this.progressBar = <HTMLProgressElement>(
      document.getElementById("progress-bar")
    );
    this.progressBar.value = 0;
  }

  protected updateProgress(fileNumber, percent): void {
    this.progressBar.value = percent;
  }

  protected uploadImages(files) {
    console.log("trial  - " + this.uploadStatus.currentTrial);

    let parent = this;
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/images/upload/";

    var formData = new FormData();

    this.initializeProgress(files.length);

    if (files.length > 1) {
      this.articlesEdit.imagePicker.showLoading();
    }

    this.articlesEdit.imagePicker.clearFilters();

    // upload status vars.
    this.uploadStatus.nextTrial();

    for (let i = 0; i < files.length; i++) {
      formData.append("file_" + i, files[i]);
    }
    formData.append("idBrand", idBrand);

    let request = [];
    var xhttp = new XMLHttpRequest();
    request["request"] = xhttp;

    // Set POST method and ajax file path
    xhttp.open("POST", formReq_url, true);

    let onReadyStateFunction = function (req, obj) {
      return function () {
        if (req.request.readyState == 4) {
          if (req.request.status == 200) {
            // reset the upload status when successful operation is complete.
            obj.uploadStatus.reset();
            let fileElement: any = document.getElementById("fileElem");
            fileElement.value = "";
            let response = JSON.parse(req.request.response);

            obj.updateProgress(response.images.length, 100); // <- Add this

            if (response.images.length == 1 && response.errors.length == 0) {
              obj.articlesEdit.imagePicker.editImage(response.images[0]);
              obj.articlesEdit.imagePicker.hideLoading();
            }

            if (
              (response.images.length == 1 && response.errors.length == 1) ||
              response.images.length > 1
            ) {
              obj.articlesEdit.imagePicker.hideImageAdd();
              obj.articlesEdit.imagePicker.handleBulkImages(response.images);
              obj.articlesEdit.imagePicker.hideLoading();

              if (response.errors.length == 1) {
                obj.articlesEdit.imagePicker.imagesBulkEdit.validationsList.setMessages(
                  response.errors
                );
              }
            }

            obj.resetProgress();
            obj.validationTemplate.clearMessages();
          } else if (req.request.status == 400) {
            let responseParsed = JSON.parse(req.request.response);
            obj.articlesEdit.imagePicker.imageAdd.validationsList.setMessages(
              responseParsed.validations
            );
            obj.articlesEdit.imagePicker.hideLoading();
            window.scrollTo(0, 0);
          } else {
            obj.uploadStatus.isInProgress = false;
            obj.articlesEdit.imagePicker.showUploadError();
          }
        }
      };
    };

    // call on request changes state
    xhttp.onreadystatechange = onReadyStateFunction(request, this);

    let firstTime = new Date().getTime();
    xhttp.upload.addEventListener("progress", function (e) {
      parent.uploadStatus.progress = e.loaded;
      let progressTime = new Date().getTime();
      let diff = progressTime - firstTime;
      firstTime = progressTime;
      console.log(
        "Upload Image progress: ",
        e.loaded,
        e.total,
        parent.uploadStatus.progress,
        diff
      );
    });

    xhttp.upload.addEventListener("loadend", (e) => {
      if (
        !parent.uploadStatus.isInProgress &&
        parent.uploadStatus.trialsReached()
      ) {
        xhttp.abort();
        parent.articlesEdit.imagePicker.showPickerUploadError();
        parent.articlesEdit.imagePicker.hideLoading();
      }
      console.log(
        "Upload Image Loadend: ",
        parent.uploadStatus.progress,
        e.loaded,
        e.total
      );
    });

    xhttp.upload.addEventListener("loadstart", (e) => {
      console.log("timeout started");
      setTimeout(() => {
        // check after one second if the progress is blocked then trigger another try.
        if (
          !parent.uploadStatus.isInProgress &&
          !parent.uploadStatus.trialsReached()
        ) {
          xhttp.abort();
          parent.uploadImages(files);
        }
      }, 1000);
    });

    // Send request with data
    xhttp.send(formData);
  }

  public reset() {
    this.uploadStatus.reset();
    this.articlesEdit.imagePicker.hidePickerUploadError();
  }

  protected getGalleryData() {
    if (this.galleryXHRHdl) {
      this.galleryXHRHdl.cancelAndReset();
    }
    this.articlesEdit.imagePicker.showLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/galleries/get/";
    let formReq_params: Array<Array<string>> = [];

    formReq_params.push([
      "data",
      ko.toJSON(this.articlesEdit.imagePicker.getViewModelForRequest()),
    ]);

    this.galleryXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.galleryXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;

    this.galleryXHRHdl.onReadyStateFunction = this.onGetGalleryDataReturn;
    this.galleryXHRHdl.execute();
  }

  protected onGetGalleryDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        if (
          obj.articlesEdit.imagePicker.getSelectedTab() == "galleries" ||
          obj.isSaveGallery
        ) {
          obj.articlesEdit.imagePicker.hideLoading();
          obj.isSaveGallery = false;
        }
      });
    };
  }

  public getImagesInContent(target) {
    if (this.ImagePickerXHRHdl) {
      this.ImagePickerXHRHdl.cancelAndReset();
    }

    this.articlesEdit.imagePicker.showInContentLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/images/get-in-content/";
    let formReq_params: Array<Array<string>> = [];

    let content;

    switch (target) {
      case "article_content":
        content = contentEditor.getData();
        break;
      case "article_intro":
        content = introTextEditor.getData();
        break;
      case "article_sandbox":
        content = sandboxEditor.getData();
        break;
      case "article_faq":
        content = faqEditor.getData();
        break;
      case "article_republish":
        content = republishEditor.getData();
        break;
      default:
        content = contentEditor.getData();
    }

    formReq_params.push(["content", content]);

    this.ImagePickerXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.ImagePickerXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    this.ImagePickerXHRHdl.onReadyStateFunction =
      this.onGetIncontentImageReturn;
    this.ImagePickerXHRHdl.execute();
  }

  public getEditorContent(target){

    let content;

    switch (target) {
      case "article_content":
        content = contentEditor.getData();
        break;
      case "article_intro":
        content = introTextEditor.getData();
        break;
      case "article_sandbox":
        content = sandboxEditor.getData();
        break;
      case "article_faq":
        content = faqEditor.getData();
        break;
      case "article_republish":
        content = republishEditor.getData();
        break;
      default:
        content = contentEditor.getData();
    }

    return content;
  }


  public onGetIncontentImageReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        obj.articlesEdit.imagePicker.hideInContentLoading();
        //TODO after save
      });
    };
  }

  public getSensaiResults(target, idContentType) {
    if (this.SensaiXHRHdl) {
      this.SensaiXHRHdl.cancelAndReset();
    }
    if (target == "sensai_prompt") {
      this.articlesEdit.sensaiPromptTemplate.showLoading();
    } else {
      this.articlesEdit.showFeedbackTabLoading();
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/sensai/get-results/";
    let formReq_params: Array<Array<string>> = [];

    let content;

    switch (target) {
      case "article_content" || "sensai_prompt":
        content = contentEditor.getData();
        break;
      case "article_intro":
        content = introTextEditor.getData();
        break;
      case "article_sandbox":
        content = sandboxEditor.getData();
        break;
      case "article_faq":
        content = faqEditor.getData();
        break;
      case "article_republish":
        content = republishEditor.getData();
        break;
      default:
        content = contentEditor.getData();
    }

    let articleViewModel = this.getSavePostData();
    formReq_params.push(["article", ko.toJSON(articleViewModel)]);

    formReq_params.push(["content", content]);
    formReq_params.push(["idContentType", idContentType]);
    //formReq_params.push(["article", idContentType]);

    this.SensaiXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    if (target == "sensai_prompt") {
      this.SensaiXHRHdl.onReadyStateFunction =
        this.onGetSensaiResultsReturnPrompt;
    } else {
      this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiResultsReturn;
    }
    this.SensaiXHRHdl.execute();
    //return this.SensaiXHRHdl.onReadyStateFunction;
  }

  public onGetSensaiResultsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let guidelines = obj.organizeSensaiResults(responseParsed);
        obj.articlesEdit.articleReviewHistory.setGuidelines(guidelines);
        obj.articlesEdit.setSensaiRuleScore(
          responseParsed.feedback.totalRuleScore
        );
        //obj.articlesEdit.articleReviewHistory.setTotalSensaiScore(responseParsed.feedback.totalRuleScore);
        //obj.articlesEdit.sensaiProgressBar.setScore(responseParsed.feedback.totalRuleScore, obj.articlesEdit.getSensaiRulePointThreshold());
        obj.getAIContent();
        obj.articlesEdit.hideFeedbackTabLoading();
      });

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  public organizeSensaiResults(responseParsed) {
    return Object.keys(responseParsed.feedback)
      .map(function (section) {
        if (section != "totalRuleScore") {
          return {
            sectionName: section,
            rules: Object.keys(responseParsed.feedback[section]).map(function (
              rule
            ) {
              return {
                ruleName: rule,
                ruleStatus:
                  responseParsed.feedback[section][rule]["ruleStatus"],
                isMandatory:
                  responseParsed.feedback[section][rule]["isMandatory"],
              };
            }),
          };
        }
      })
      .filter((item) => item !== undefined);
  }

  public onGetSensaiResultsReturnPrompt(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let content = obj.organizeSensaiResults(responseParsed);
        obj.articlesEdit.sensaiPromptTemplate.setContent(content);
        obj.articlesEdit.sensaiPromptTemplate.setPromptType("sensaiPrompt");

        obj.articlesEdit.setSensaiRuleScore(
          responseParsed.feedback.totalRuleScore
        );
        //obj.articlesEdit.sensaiPromptTemplate.setSensaiCoverageScore(obj.articlesEdit.getTemplateViewModel().sensaiCoverageScore())
        obj.articlesEdit.setTotalSensaiScore();
        obj.articlesEdit.setSensaiPrompt(content);
      });

      obj.articlesEdit.sensaiPromptTemplate.removeLoading();
    };
  }

  protected getTagsByType(
    idType,
    keyword = null,
    limit = null,
    typeIsNotNull = false
  ) {
    // LOADING : starts

    let subViewModel = {
      filter: { keyword: keyword, limit: limit },
      typeIsNotNull: typeIsNotNull,
    };

    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
    //this.loadingIn(this.articlesEdit.builtTemplate);

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/tags/get_by_type_for_review_item/" +
      idType;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetTagsRequestReturn;
    this.XHRHdl.execute();
  }

  protected getSuggestions(keyword, idSourceElement) {
    this.XHRHdlCaller = "getSuggestions_" + idSourceElement;
    if (idSourceElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      let idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

      if (!filterTypes.addNewSelected()) {
        this.getTagsByType(
          idType,
          this.articlesEdit.filterProducts.getTemplateViewModel().inputText(),
          5,
          true
        );
      } else {
        this.articlesEdit.filterProducts
          .getTemplateViewModel()
          .optionsLoading(false);
      }
    } else if (idSourceElement == "filterAutocompleteProductType_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      this.getTagsTypeSuggestion(filterTypes.inputText(), 5);
    } else if (idSourceElement == "filterAutocompleteAffiliate_template") {
      let filterAffiliates =
        this.articlesEdit.filterAffiliates.getTemplateViewModel();
      this.getAffiliatesSuggestion(filterAffiliates.inputText(), 5);
    }
    //TODO here for  idSource Element use getTagSuggestions (already made)
    else if (idSourceElement == "filterAutocompletePinnedTags_template") {
      let pinnedTag = this.articlesEdit.filterPinnedTag.getTemplateViewModel();
      this.getTagsSuggestionOnInput(
        pinnedTag.inputText(),
        5,
        null,
        false,
        false,
        true
      );
    } else if (
      idSourceElement == "filterTagType" ||
      idSourceElement == "tagPickerSourceFilterTagType"
    ) {
      this.getTagsTypeSuggestion(keyword, 5);
    } else if (
      idSourceElement == "filterAddNewTagType" ||
      idSourceElement == "filterEditTagType"
    ) {
      this.getTagsTypeSuggestion(keyword, 5, true);
    } else if (
      idSourceElement == "filterAutocompleteTagViewAffiliate_template" ||
      idSourceElement == "filterAutocompleteTagEditAffiliate_template"
    ) {
      this.getAffiliatesSuggestion(keyword, 5);
    } else if (idSourceElement == "filterAutocompleteLocales_template") {
      this.getLocaleSuggestion(keyword);
    } else if (
      [
        "filterTag",
        "filterVideoTag",
        "filterVideoTagEdit",
        "filterTagImagePickerEdit",
        "filterAutocompleteReviewTag_template",
      ].indexOf(idSourceElement) >= 0
    ) {
      this.getTagsSuggestionOnInput(keyword, 5, null, true, false, false);
    } else if (
      idSourceElement == "filterAutocompleteTagTypeArticlePinnedTags_template"
    ) {
      let filterTypes =
        this.articlesEdit.articlePinnedTags.filterTagType.getTemplateViewModel();
      this.getTagsTypeSuggestion(filterTypes.inputText(), 5);
    } else if (
      idSourceElement == "filterDataset"
    ) {
      this.getDatasetSuggestion(keyword);
    } else if (
      idSourceElement == "filterAutocompleteTagArticlePinnedTags_template"
    ) {
      let filterTags =
        this.articlesEdit.articlePinnedTags.filterTags.getTemplateViewModel();
      let tagType =
        this.articlesEdit.articlePinnedTags.filterTagType.getOptionObj();

      this.getTagsSuggestionOnInput(
        filterTags.inputText(),
        5,
        tagType,
        true,
        true,
        false,
        true
      );
    } else if (idSourceElement == "tagSourcePickerTagFilter") {
      this.getTagPickerSpecificationTagSuggestions(keyword);
    } else if (idSourceElement == "vignetteFilter") {
      this.getVignettesSuggestion(keyword, this.onGetVignettesSuggestionReturn);
    } else if (idSourceElement == "defaultVignetteFilter") {
      this.getVignettesSuggestion(
        keyword,
        this.onGetDefaultVignettesSuggestionReturn
      );
    }
  }

  private getTagPickerSpecificationTagSuggestions(keyword) {
    let tagTypeFieldParams =
      this.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.getViewModelForRequest();
    let typeRestrictions = tagTypeFieldParams.typeRestrictions;
    this.getTagsByTypes(keyword, typeRestrictions);
  }

  public getVignettesSuggestion(keyword, onReadyStateFunction: Function) {
    const idBrand = this.getVnAppZone().app.params.idBrand;

    this.XHRHdl.cancelAndReset();

    let subViewModel = {
      pagination: { itemPerPage: 25 },
      filter: { keyword: keyword },
    };
    let usrReq_url: string = `/api/brand/${idBrand}/search/tags/vignettes/`;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = onReadyStateFunction;
    this.XHRHdl.execute();
  }

  protected onGetVignettesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          let vignettes = response.data;
          vignettes.forEach((vignette) => {
            vignette.name += ` (${vignette.id})`;
          });
          obj.articlesEdit.tagPicker.tagEdit.vignetteFilter.setOptions(
            vignettes
          );
        }
      });
    };
  }

  protected onGetDefaultVignettesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          let vignettes = response.data;
          vignettes.forEach((vignette) => {
            vignette.name += ` (${vignette.id})`;
          });
          obj.articlesEdit.tagPicker.tagEdit.defaultVignetteFilter.setOptions(
            vignettes
          );
        }
      });
    };
  }

  protected getArticlesSuggestion(keyword, idElement) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { list: { keyword: keyword, sourceId: idElement } };

    let usrReq_url: string;

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);

    if (idElement == "filterArticleDirectory") {
      usrReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/directories/get/";
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.onReadyStateFunction =
        this.onGetDirectoryArticlesSuggestionsReturn;
    } else {
      usrReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/next/get/";
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
    }

    this.XHRHdl.execute();
  }

  protected onGetDirectoryArticlesSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.data.articles) {
          obj.articlesEdit.setDirectoryArticlesFilter(
            responseParsed.data.articles
          );
        }
      });
    };
  }

  protected onGetArticlesSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let sourceId = JSON.parse(req._parameters[0][1])["list"]["sourceId"];

        if (responseParsed.data.articles) {
          if (
            sourceId == "article_directory" ||
            sourceId == "sandbox_directory" ||
            sourceId == "republish_directory"
          ) {
            obj.articlesEdit.setDirectoryItemFilter(
              responseParsed.data.articles,
              sourceId
            );
          } else {
            obj.articlesEdit.setArticlesFilter(responseParsed.data.articles);
          }
        }
      });
    };
  }

  protected insertImages(
    images,
    target,
    extra_option,
    isMobileOptimized = false
  ) {
    let imgGroupTag = this.buildImageGroupTag(images, extra_option);
    if (target == "article_content") {
      this.insertElement(imgGroupTag, contentEditor);
    } else if (target == "article_intro") {
      this.insertElement(imgGroupTag, introTextEditor);
    } else if (target == "article_sandbox") {
      this.insertElement(imgGroupTag, sandboxEditor);
    } else if (target == "article_faq") {
      this.insertElement(imgGroupTag, faqEditor);
    } else if (target == "productImages") {
      this.articlesEdit.setProductImages(images);
    } else if (target == "article_directory_item_description") {
      this.insertElement(imgGroupTag, articleDirectoryItemDescriptionEditor);
    } else if (target == "sandbox_directory_item_description") {
      this.insertElement(imgGroupTag, sandboxDirectoryItemDescriptionEditor);
    } else if (target == "article_republish") {
      this.insertElement(imgGroupTag, republishEditor);
    } else if (target == "republish_directory_item_description") {
      this.insertElement(imgGroupTag, republishDirectoryItemDescriptionEditor);
    }

    if (this.articlesEdit.getTemplateViewModel().idPublishStatus() != 3) {
      let setArticleToEmbargo = false;
      for (let image of images) {
        if (image.isUnderEmbargo) {
          setArticleToEmbargo = true;
          break;
        }
      }
      if (setArticleToEmbargo) {
        this.articlesEdit.setIsUnderEmbargo(true);
      }
    }
  }

  protected insertImage(image, target, extra_option) {
    if (target.element) {
      let element = target.element;
      element.parentElement.removeChild(element);
      target = target.editor;
    }
    let isImageInsertionSectionOptimizable =
      this.articlesEdit.isImageInsertionSectionOptimizable(target);
    if (isImageInsertionSectionOptimizable == false) {
      image.isMobileOptimized = false;
    }

    let imgTag = this.buildImageTag(image, false, extra_option);
    if (target == "article_content") {
      this.insertTag(imgTag, contentEditor);
    } else if (target == "article_intro") {
      this.insertTag(imgTag, introTextEditor);
    } else if (target == "article_sandbox") {
      this.insertTag(imgTag, sandboxEditor);
    } else if (target == "article_faq") {
      this.insertTag(imgTag, faqEditor);
    } else if (target == "article_directory_item_description") {
      this.insertTag(imgTag, articleDirectoryItemDescriptionEditor);
    } else if (
      target == "articleImageOverride" ||
      target == "articleImageOverrideEdit"
    ) {
      this.articlesEdit.articlePicker.articlePickerView.setArticleImageOverride(
        image
      );
    } else if (target == "sandbox_directory_item_description") {
      this.insertTag(imgTag, sandboxDirectoryItemDescriptionEditor);
    } else if (target == "article_republish") {
      this.insertTag(imgTag, republishEditor);
    } else if (target == "republish_directory_item_description") {
      this.insertTag(imgTag, republishDirectoryItemDescriptionEditor);
    } else if (target == "tagImage") {
      this.articlesEdit.setTagImage(image);
    } else if (target == "productImages") {
      this.articlesEdit.addProductImage(image);
    } else if (
      target == "tagImageOverride" ||
      target == "tagImageOverrideEdit"
    ) {
      this.articlesEdit.tagPicker.setTagImageOverride(image);
    } else if (target == "tagImageEdit") {
      this.articlesEdit.tagPicker.setTagImage(image);
    } else if (target == "tagIconImageEdit") {
      this.articlesEdit.tagPicker.setTagIconImage(image);
    } else if (target == "tagBannerImageEdit") {
      this.articlesEdit.tagPicker.setTagBannerImage(image);
    } else if (target == "tagIconOverride") {
      this.articlesEdit.tagPicker.setTagIconOverride(image);
    } else if (target == "tagImageBadge") {
      this.articlesEdit.tagPicker.setTagImageBadge(image);
    } else if (target == "video_thumbnail") {
      this.articlesEdit.videoPickerHelper.setThumbnailImage(image);
    } else {
      this.articlesEdit.setImage(image, target);
    }

    if (this.articlesEdit.getTemplateViewModel().idPublishStatus() != 3) {
      let setArticleToEmbargo = false;
      if (image.isUnderEmbargo) {
        setArticleToEmbargo = true;
      }
      if (setArticleToEmbargo) {
        this.articlesEdit.setIsUnderEmbargo(true);
      }
    }
  }

  public revertSandbox() {
    let sandboxData = sandboxEditor.getData();
    contentEditor.setData(sandboxData);
  }

  public revertSandboxIntroText() {
    let sandboxIntroData = sandboxIntroTextEditor.getData();
    introTextEditor.setData(sandboxIntroData);
  }

  public revertSandboxDirectory() {
    //to delete exiting ones
    let items = this.articlesEdit.articleDirectory.getDirectoryItems();
    items.forEach((item) =>
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems()
        .push(item)
    );
    this.articlesEdit.articleDirectory.setDirectoryItems([]);

    //set new ones
    let directoryItems = this.articlesEdit.sandboxDirectory.getDirectoryItems();
    directoryItems = ko.toJS(directoryItems); //convert observable array ot simple array
    this.articlesEdit.articleDirectory.setSandboxDirectoryItems(directoryItems);
  }

  public copyContent(tab) {
    let contentData = contentEditor.getData();

    if (tab == "sandbox") {
      sandboxEditor.setData(contentData);
    }

    if (tab == "republish") {
      let contentKeyPoints = this.articlesEdit
        .getTemplateViewModel()
        .contentKeyPoints();

      if (contentKeyPoints) {
        contentData = contentData.replaceAll("\t", ""); //to remove tab shift before elements
        contentKeyPoints = contentKeyPoints.split("\n");
        contentKeyPoints = contentKeyPoints.filter((item) => item);

        let html =
          '<div class="emaki-custom key-points">\n<ul class="key-points-list">\n';
        for (let i = 0; i < contentKeyPoints.length; i++) {
          let match = i + 1;
          let value = contentKeyPoints[i]
            .replace("" + match + ". ", "")
            .replace("" + match + ") ", "")
            .replace("" + match + " ", "")
            .replace("" + match + "/ ", "")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#39;");
          html = html + '<li class="key-points-item">' + value + "</li>\n";
        }
        html = html + "</ul>\n</div>";

        if (contentData.indexOf(html) > -1) {
          contentData = contentData.replace(html, "");
        }
      }

      republishEditor.setData(contentData);
    }
  }

  public copyIntroText(tab) {
    let introData = introTextEditor.getData();

    if (tab == "sandbox") {
      sandboxIntroTextEditor.setData(introData);
    }

    if (tab == "republish") {
      republishIntroTextEditor.setData(introData);
    }
  }

  protected insertGallery(gallery, target, extra_option) {
    let galleryTag = this.buildGalleryTag(gallery, extra_option);
    if (target == "article_content") {
      this.insertElement(galleryTag, contentEditor);
    } else if (target == "article_intro") {
      this.insertElement(galleryTag, introTextEditor);
    } else if (target == "article_sandbox") {
      this.insertElement(galleryTag, sandboxEditor);
    } else if (target == "article_faq") {
      this.insertElement(galleryTag, faqEditor);
    } else if (target == "article_directory_item_description") {
      this.insertElement(galleryTag, articleDirectoryItemDescriptionEditor);
    } else if (target == "sandbox_directory_item_description") {
      this.insertElement(galleryTag, sandboxDirectoryItemDescriptionEditor);
    } else if (target == "article_republish") {
      this.insertElement(galleryTag, republishEditor);
    } else if (target == "republish_directory_item_description") {
      this.insertElement(galleryTag, republishDirectoryItemDescriptionEditor);
    }
  }

  protected insertTag(tag, editor) {
    editor.insertHtml(tag);
  }

  protected insertElement(tag, editor) {
    var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
    editor.insertElement(tagElement);
  }

  protected onAutocompleteInputClear(idElement) {
    if (idElement == "filterAutocompleteProductType_template") {
      this.articlesEdit.filterProducts.setOptions([]);

      if (this.articlesEdit.filterProducts.getTemplateViewModel().optionObj()) {
        this.articlesEdit.filterProducts.clearInput();
      }

      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompleteProduct_template") {
      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "onAutocompleteOptionChange") {
      this.articlesEdit.filterPinnedTag.setOptions([]);
    } else if (idElement == "filterAutocompletePinnedTags_template") {
      this.articlesEdit.imageWidgetForFeaturedImage.clearImage();
    } else if (
      idElement == "filterAutocompleteTagTypeArticlePinnedTags_template"
    ) {
      this.articlesEdit.articlePinnedTags.setIsShownTagTypeSpec(false);
      this.articlesEdit.articlePinnedTags.setTags([]);
    } else if (idElement == "vignetteFilter") {
      this.articlesEdit.tagPicker.tagEdit.setSelectedVignette(null);
    } else if (idElement == "defaultVignetteFilter") {
      this.articlesEdit.tagPicker.tagEdit.setSelectedDefaultVignette(null);
    }
    /*else if(idElement == 'filterEditTagType'){

            this.articlesEdit.tagPicker.onEditTagTypeFilter();
        }*/
  }

  protected onAutocompleteInputClick(idElement) {
    if (idElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();

      if (filterTypes.addNewSelected()) {
        this.articlesEdit.filterProducts.setOptions([]);
      }
    }
    if (idElement == "filterAutocompleteProductType_template") {
      //this.articlesEdit.onChangeSelectTag(); //May be unnecessary
    }
  }

  protected onAutocompleteAddNewSelected(idElement) {
    if (idElement == "filterAutocompleteProduct_template") {
      this.articlesEdit
        .getTemplateViewModel()
        .addedReviewItemTagSpecifications([]);
      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompleteProductType_template") {
      //Clearing product when a new type is selected
      this.articlesEdit
        .getTemplateViewModel()
        .addedReviewItemTagSpecifications([]);
      if (
        this.articlesEdit.filterProductTypes
          .getTemplateViewModel()
          .addNewSelected() &&
        !this.articlesEdit.filterProducts
          .getTemplateViewModel()
          .addNewSelected()
      ) {
        this.articlesEdit.filterProducts.clearEverything();
      }
      this.articlesEdit.onChangeSelectTag();
    }
  }

  protected onAutocompleteAddNewInputClick(idElement) {
    //TODO: May be useless

    if (idElement == "filterAutocompleteProduct_template") {
    } else if (idElement == "filterAutocompleteProductType_template") {
    }
  }

  protected onAutocompleteAcceptSuggestion(idElement) {
    if (idElement == "filterAutocompleteProduct_template") {
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();
      // let filterTypes = this.articlesEdit.filterProductTypes.getTemplateViewModel();

      if (filterProducts.optionObj().type) {
        this.articlesEdit.filterProductTypes
          .getTemplateViewModel()
          .addNewSelected(false);
        this.articlesEdit.filterProductTypes.setOption(
          filterProducts.optionObj().type
        );
      }
    }
  }

  protected onAutocompleteAddNewInputChange(idElement: string) {
    this.XHRHdlCaller = "onAutocompleteAddNewInputChange_" + idElement;

    if (idElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();
      let idType;
      if (!filterTypes.addNewSelected()) {
        idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

        if (filterTypes.optionObj()) {
          idType = filterTypes.optionObj().id;
        } else {
          idType = 0;
        }
      } else {
        idType = 0;
      }
      this.getTagsByType(idType, filterProducts.newOptionName(), 1, true);
    } else if (idElement == "filterAutocompleteProductType_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      this.articlesEdit.filterProductTypes
        .getTemplateViewModel()
        .suggestedObj(""); //TODO: Investigate why this is needed
      this.getTagsTypeSuggestion(filterTypes.newOptionName(), 1);
    } else if (idElement == "filterAutocompleteAffiliate_template") {
      this.getAffiliatesSuggestion(
        this.articlesEdit.filterAffiliates
          .getTemplateViewModel()
          .newOptionName(),
        1
      );
    }
  }

  protected onPromptInputChangeClear(idElement) {
    this.clearValidationErrors();

    if (idElement === "filterAutocompleteTagEditAffiliate_template") {
      this.articlesEdit.tagPicker.clearTagEditAutomaticPricingOptions();
    } else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
      this.articlesEdit.tagPicker.clearTagViewAutomaticPricingOptions();
    }
  }

  protected onAutocompleteOptionChange(idElement) {
    this.clearValidationErrors();

    if (idElement === "filterAutocompleteTagEditAffiliate_template") {
      this.articlesEdit.tagPicker.updateTagEditAutomaticPricingOptions();
    } else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
      this.articlesEdit.tagPicker.updateTagViewAutomaticPricingOptions();
    } else if (idElement == "filterAutocompleteProductType_template") {
      this.articlesEdit.filterProducts.getTemplateViewModel().options([]);
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();
      let product = filterProducts.optionObj();

      if (product) {
        if (product.type) {
          this.articlesEdit.filterProducts.clearSelectedOption();
        }
      }

      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();

      if (!filterTypes.addNewSelected()) {
        let tag = filterProducts.optionObj();
        if (filterTypes.optionObj() === null) {
          if (tag && tag.type) {
            filterTypes.optionObj(tag.type);
            filterTypes.inputText(tag.type.name);
          }
        } else if (tag.type.id === filterTypes.optionObj().id) {
          //Added after the anna struggle BEGIN

          if (tag.type.fields) {
            if (
              tag.type.fields.length > filterTypes.optionObj().fields.length
            ) {
              filterTypes.optionObj(tag.type);
            }
          }
        } //Added after the anna struggle END
      }
      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompletePinnedTags_template") {
      let featuredTag = this.articlesEdit.filterPinnedTag.getOptionObj();
      if (featuredTag) {
        this.articlesEdit.imageWidgetForFeaturedImage
          .getTemplateViewModel()
          .imageURL(featuredTag.imageUrl);
        this.articlesEdit.imageWidgetForFeaturedImage
          .getTemplateViewModel()
          .imageId(featuredTag.idImage);
      }
    } else if (idElement == "filterAutocompleteAffiliate_template") {
      if (
        this.articlesEdit.filterAffiliates.getTemplateViewModel().optionObj()
      ) {
        this.articlesEdit.filterAffiliates
          .getTemplateViewModel()
          .placeholder("Affiliate Partner");
      }
    } else if (idElement == "filterTagType") {
      this.articlesEdit.tagPicker.onAddTagTypeFilter();
    } else if (idElement == "filterEditTagType") {
      this.articlesEdit.tagPicker.onEditTagTypeFilter();
    } else if (
      idElement == "filterAutocompleteTagTypeArticlePinnedTags_template"
    ) {
      let tagType =
        this.articlesEdit.articlePinnedTags.filterTagType.getOptionObj();
      let filters = tagType.fields.filter((v) => v.dataType != "tags");
      let filterOptions = filters.map((v) => ({ name: v.label, id: v.id }));
      filterOptions.unshift({ name: "Select an option", id: null });
      this.articlesEdit.articlePinnedTags.setTagSpecs(filterOptions);
      this.articlesEdit.articlePinnedTags.setIsShownTagTypeSpec(true);
      this.articlesEdit.articlePinnedTags.setTags([]);
    } else if (idElement == "filterAutocompleteTagArticlePinnedTags_template") {
      let tag = this.articlesEdit.articlePinnedTags.filterTags.getOptionObj();
      let selectedSpecId = this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .selectedTagSpec();
      let allSpec = this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .tagSpecs();
      let selectedSpec = allSpec.filter((v) => v.id == selectedSpecId);
      let style = this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .selectedStyle();
      let specFields = JSON.parse(tag.specificationFieldIds);

      if (
        style == "single-spec" &&
        selectedSpecId &&
        (!specFields || !specFields.includes(selectedSpecId))
      ) {
        this.articlesEdit.articlePinnedTags.missingSpecDialog.setIsVisible(
          true
        );
        let message =
          "<p>" +
          tag.name +
          " does not have a specification value for  " +
          selectedSpec[0].name +
          ".It can remain pinned but will not be displayed on the website until a specification value is added.</p>";
        this.articlesEdit.articlePinnedTags.missingSpecDialog.setMessage(
          message
        );
      } else {
        this.articlesEdit.articlePinnedTags.addTag();
      }
    } else if (idElement === "tagPickerSourceFilterTagType") {
      this.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.addTagTypeRestriction();
    } else if (idElement == "vignetteFilter") {
      this.clearValidationErrors();
      this.articlesEdit.tagPicker.tagEdit.setSelectedVignette(
        this.articlesEdit.tagPicker.tagEdit.vignetteFilter.getOptionObj()
      );
    } else if (idElement == "defaultVignetteFilter") {
      this.clearValidationErrors();
      this.articlesEdit.tagPicker.tagEdit.setSelectedDefaultVignette(
        this.articlesEdit.tagPicker.tagEdit.defaultVignetteFilter.getOptionObj()
      );
    }
  }

  protected filterSimpleOnChange(idElement) {
    switch (idElement) {
      case "filterTag":
        this.articlesEdit.updateSelectedTags();
        break;
      case "filterArticle":
        break;
      case "filterDirectoryItem":
        this.clearValidationErrors();
        break;
      case "filterUser_display_author":
        this.articlesEdit.addDisplayAuthor();
        break;
      case "filterTagSearch":
        this.articlesEdit.tagPicker.resetPagination();
        this.getTagData();
        break;
      case "filterDataset":
        this.articlesEdit.tagPicker.resetPagination();
        this.getTagData();
        break;
      case "videoKeywordFilter":
        this.articlesEdit.videoPickerHelper.resetPagination();
        this.getVideosData();
        break;
      case "videoOrientationFilter":
        this.articlesEdit.videoPickerHelper.resetPagination();
        this.getVideosData();
        break;
      case "filterVideoTag":
        this.articlesEdit.videoPickerHelper.resetPagination();
        this.getVideosData();
        break;
      case "filterVideoTagEdit":
        this.getVideoPickerEditTemplate().updateSelectedTags();
        break;
      case "filterTagImagePickerEdit":
        this.getImagePickerEditTemplate().updateSelectedTags();
        break;
      case "tagSourcePickerTagFilter":
        this.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.addSelectedTag();
        break;
      case "filterUser_producer":
        break;
      case "filterUser_prompt_author":
        break;
      default:
        this.getImageData();
        this.getGalleryData();
        break;
    }
  }

  protected filterSimpleCancel() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }

  protected buildImageGroupTag(images, extra_option): string {
    let css = `emaki-imgGroup ${extra_option}`.trim();
    let imageGroupTag = `<div class="${css}">`;

    for (let image of images) {
      let imgTag = this.buildImageTag(image, false, "");
      imageGroupTag = imageGroupTag + imgTag;
    }

    imageGroupTag = imageGroupTag + "</div>";

    return imageGroupTag;
  }

  protected buildGalleryTag(gallery, extra_option): string {
    let css = `emaki-imgGroup emaki-group ${extra_option}`.trim();
    let galleryTag = `<div class="${css}" gallery-id="${gallery.id}">`;

    for (let image of gallery.images.slice(0, 5)) {
      let imgTag = this.buildImageTag(image, false, "");
      galleryTag = galleryTag + imgTag;
    }

    galleryTag = galleryTag + "</div>";

    return galleryTag;
  }

  protected buildImageTag(image, addCaption, extra_option): string {
    let imgTag = `<img `;

    imgTag += `data-image-id="${image.id}"`;

    imgTag += `src="${image.url}" `;
    if (image.altText != null) {
      let escapedAltText = image.altText.replace(/"/g, "&quot;");
      imgTag += `alt="${escapedAltText}" `;
    } else {
      imgTag += `alt="" `;
    }

    if (image.isMobileOptimized) {
      imgTag += ` data-mobile-optimized="true"`;
    }

    imgTag += ` width="${image.width}" height="${image.height}" />`;

    //add caption
    if (addCaption && image.caption != null && image.caption.trim() != "") {
      imgTag = `[caption]${imgTag} ${image.caption}[/caption]`;
    }

    if (extra_option) {
      imgTag = `<div class="emaki-imgGroup emaki-imgSingle grid_view">${imgTag}</div>`;
    }

    return imgTag;
  }

  protected cancelTakeOver() {
    this.clearRecoverySave();
    this.clearRecoveryWarning();

    this.maximizeSideNav();

    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_WARNING,
      "Article action canceled !"
    );

    let lastRoute = this.getVnAppZone().app.getLastRoute();

    page.redirect(lastRoute);
  }

  public setReviewText(text) {
    prodRevReviewText.setData(text, function () {
      this.resetUndo();
    });
  }

  protected onGetTagsRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let tags = responseParsed.data;

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteProduct_template"
        ) {
          if (tags) {
            obj.articlesEdit.filterProducts
              .getTemplateViewModel()
              .suggestedObj(tags[0]);
          }
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteProduct_template"
        ) {
          tags.forEach((tag) => {
            if (tag.type != null) {
              tag.displayNameComplement =
                tag.name + " ( " + tag.type.name + " ) ";
            } else {
              tag.displayNameComplement = tag.name + " ( * No type * )";
            }

            if (tag.details != null) {
              tag.isSelectable = tag.details.isSelectable;
            } else {
              tag.isSelectable = false;
            }
          });

          obj.articlesEdit.filterProducts.setOptions(tags);
          obj.articlesEdit.filterProducts.setIsLoading(false);
        }
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected checkForReviewItemsUpdate(sourceOfReversal) {
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/reviewItem/checkForUpdate/";

    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let saveData = {
      reviewItems: this.articlesEdit.getTemplateViewModel().backupReviewItems(),
      sourceOfReversal: sourceOfReversal,
    };

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(saveData)]);
    //Pass article status to know if an article is completed to choose proper validation of user
    usrReq_params.push([
      "idStatus",
      this.articlesEdit.getTemplateViewModel().idStatus(),
    ]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction =
      this.onCheckForReviewItemsUpdateRequestReturn;
    this.XHRHdl.execute();
  }

  protected onCheckForReviewItemsUpdateRequestReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        if (req.request.status == 200) {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response); //TODO: Remove this

            obj.articlesEdit.revertReviewItems(
              responseParsed.reviewItems,
              responseParsed.fieldUpdates
            );
          });

          obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
      }
    };
  }

  protected validateArticleSaveFrontEnd() {
    let selectedStatus = this.articlesEdit.getTemplateViewModel().idStatus();
    let idContentType = this.articlesEdit
      .getTemplateViewModel()
      .idContentType();

    // before putting into the "Submit for approval" status, the content type must be set..
    if (
      (selectedStatus == 2 || selectedStatus == 3 || selectedStatus == 6) &&
      !idContentType
    ) {
      let message = {
        field: "Content Type",
        label: "Content Type",
        message: "Please select a Content Type.",
      };
      this.validationTemplate.setSingleMessage(message);
      return false;
    }

    return true;
  }

  protected validateReviewItem() {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let viewModel = this.articlesEdit.getTemplateViewModel();
    let productViewModel =
      this.articlesEdit.filterProducts.getTemplateViewModel();
    let productTypesViewModel =
      this.articlesEdit.filterProductTypes.getTemplateViewModel();
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/reviewItem/validate/";

    let tagTypeName, tagName, idTag, idTagType;

    if (productTypesViewModel.addNewSelected()) {
      idTagType = 0;
      tagTypeName = productTypesViewModel.newOptionName();
    } else {
      if (productTypesViewModel.optionObj()) {
        idTagType = productTypesViewModel.optionObj().id;
        tagTypeName = productTypesViewModel.optionObj().name;
      } else {
        idTagType = 0;
        tagTypeName = "";
      }
    }

    if (productViewModel.addNewSelected()) {
      idTag = 0;
      tagName = productViewModel.newOptionName();
    } else {
      if (productViewModel.optionObj()) {
        idTag = productViewModel.optionObj().id;
        tagName = productViewModel.optionObj().name;
      } else {
        idTag = 0;
        tagName = "";
      }
    }

    let saveData = {
      amazonSummary: viewModel.reviewItemAmazonSummary(),
      amazonHeadline: viewModel.reviewItemAmazonHeadline(),
      amazonAward: viewModel.reviewItemAmazonAward(),
      amazonRating: viewModel.reviewItemAmazonRating(),
      extraVideos: viewModel
        .reviewItemExtraVideos()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      extraImages: viewModel.reviewItemImages(),
      rating: viewModel.reviewItemRating(),
      idTagType: idTagType,
      tagTypeName: tagTypeName,
      tagName: tagName,
      idTag: idTag,
      tagSpecifications: viewModel
        .reviewItemTagSpecifications()
        .filter((e) => e.label.trim() || e.data.trim()),
      addedSpecifications: viewModel
        .addedReviewItemTagSpecifications()
        .filter((e) => e.label.trim() || e.data.trim()),
      pros: viewModel
        .reviewItemPros()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      cons: viewModel
        .reviewItemCons()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      keyFeatures: viewModel
        .reviewItemKeyFeatures()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      seoDescription: viewModel.reviewItemSeoDescription(),
      tagImage: viewModel.tagImage(),
      reviewText: prodRevReviewText.getData(),
      giveawayUrl: viewModel.reviewItemGiveawayUrl(),
      giveawayExpiryDate: viewModel.giveawayDatePicker.singleDatePicker(),
      idAwardType: viewModel.reviewItemIdAwardType(),
      affiliateLinks: viewModel
        .reviewItemAffiliateLinks()
        .filter((e) => e.value.trim()),
      id: viewModel.idReviewItem(),
      idArticle: this.articlesEdit.getId(),
      idTemplate: this.articlesEdit.getIdTemplate(),
    };

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(saveData)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onGetSaveReviewItemRequestReturn;
    this.XHRHdl.execute();
  }

  protected validateDirectoryItem(addNext, id) {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let saveData = {};
    if (id == "sandbox_directory") {
      saveData = {
        sectionTitle: this.articlesEdit.sandboxDirectory
          .getTemplateViewModel()
          .sectionTitle(),
        description: sandboxDirectoryItemDescriptionEditor.getData(),
        idItem: this.articlesEdit.sandboxDirectory
          .getTemplateViewModel()
          .selectedDirectoryItemIdArticle(),
        idArticle: this.articlesEdit.getId(),
        addNext: addNext,
      };
    } else if (id == "republish_directory") {
      saveData = {
        sectionTitle: this.articlesEdit.republishDirectory
          .getTemplateViewModel()
          .sectionTitle(),
        description: republishDirectoryItemDescriptionEditor.getData(),
        idItem: this.articlesEdit.republishDirectory
          .getTemplateViewModel()
          .selectedDirectoryItemIdArticle(),
        idArticle: this.articlesEdit.getId(),
        addNext: addNext,
      };
    } else {
      saveData = {
        sectionTitle: this.articlesEdit.articleDirectory
          .getTemplateViewModel()
          .sectionTitle(),
        description: articleDirectoryItemDescriptionEditor.getData(),
        idItem: this.articlesEdit.articleDirectory
          .getTemplateViewModel()
          .selectedDirectoryItemIdArticle(),
        idArticle: this.articlesEdit.getId(),
        addNext: addNext,
      };
    }

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/directoryItem/validate/";

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(saveData)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction =
      this.onValidateDirectoryItemRequestReturn;
    this.XHRHdl.execute();
  }

  protected onValidateDirectoryItemRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed["valid"])
          if (
            obj.articlesEdit.getTemplateViewModel().selectedTab() == "sandbox"
          ) {
            obj.articlesEdit.sandboxDirectory.addDirectoryItem(
              responseParsed["addNext"],
              obj.articlesEdit.getTemplateViewModel().selectedTab()
            );
          } else if (
            obj.articlesEdit.getTemplateViewModel().selectedTab() == "republish"
          ) {
            obj.articlesEdit.republishDirectory.addDirectoryItem(
              responseParsed["addNext"],
              obj.articlesEdit.getTemplateViewModel().selectedTab()
            );
          } else {
            obj.articlesEdit.articleDirectory.addDirectoryItem(
              responseParsed["addNext"],
              obj.articlesEdit.getTemplateViewModel().selectedTab()
            );
          }
      });

      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeValidationClass();
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onGetSaveReviewItemRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.addReviewItem(responseParsed);
      });

      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeValidationClass();
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected generateEmbed(source, embedContext = null) {
    this.loadingIn(this.articlesEdit.builtTemplate);

    this.embedHelper.generateEmbed(
      source,
      this.articlesEdit.getTemplateViewModel().embedType(),
      embedContext
    );
  }

  public onGenerateEmbedRequestReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        let responseParsed = JSON.parse(req.request.response);

        if (req.request.status == 200) {
          obj.articlesEdit.setEmbedData(responseParsed.data);
        } else {
          obj.articlesEdit.setEmbedErrors(responseParsed);
        }
      }

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected addEmbedCodeToCkEditor(value) {
    this.articlesEdit
      .getActiveCkEditorInstance()
      .insertHtml("<br />" + value + "<br /> &nbsp;");
    this.articlesEdit.toggleEmbedPopUp(false);
    this.articlesEdit.resetEmbedPopUp();
  }

  protected addEmbedCodeToFeaturedEmbed(value) {
    this.articlesEdit.setFeaturedEmbed(value);
    this.articlesEdit.getTemplateViewModel().isFeaturedEmbedActive(true);
    this.articlesEdit.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(
      true
    );
    this.articlesEdit.setFeaturedVideo(null);
    this.articlesEdit.setContentEmbedContext();
    this.articlesEdit.toggleEmbedPopUp(false);
    this.articlesEdit.resetEmbedPopUp();
  }

  public setSandboxIntroText(introText) {
    sandboxIntroTextEditor.setData(introText);
  }

  public setSandboxContent(introText) {
    sandboxEditor.setData(introText);
  }

  public setRepublishIntroText(introText) {
    republishIntroTextEditor.setData(introText);
  }

  public setRepublishContent(introText) {
    republishEditor.setData(introText);
  }

  public clearValidationErrors() {
    this.validationTemplate.clearMessages();
    this.articlesEdit.removeValidationClass();
  }

  public setContentEditorStatus(value) {
    if (CKEDITOR.instances.article_content) {
      CKEDITOR.instances["article_content"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );
      CKEDITOR.instances["article_content"].on("paste", function (evt) {
        var unescapeString = unescape(evt.data.dataValue);
        if (unescapeString.includes("<script")) {
          var openingRegex = new RegExp("<!--{cke_protected}", "g");
          unescapeString = unescapeString.replace(openingRegex, "");
          var openingRegex = new RegExp("<!--<script", "g");

          unescapeString = unescapeString.replace(openingRegex, "<script");
          var closingRegex = new RegExp("</script>-->", "g");
          unescapeString = unescapeString.replace(closingRegex, "</script>");

          evt.data.dataValue = unescapeString;
        }
      });
    }
  }

  public setSandboxEditorStatus(value) {
    if (CKEDITOR.instances.article_sandbox) {
      CKEDITOR.instances["article_sandbox"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );
      CKEDITOR.instances["article_sandbox"].on("paste", function (evt) {
        var unescapeString = unescape(evt.data.dataValue);

        if (unescapeString.includes("<script")) {
          unescapeString = unescapeString.replace("<!--{cke_protected}", "");
          unescapeString = unescapeString.replace("-->", "");

          evt.data.dataValue = unescapeString;
          console.log(unescapeString);
        }
      });
    }
  }

  public setRepublishEditorStatus(value) {
    if (CKEDITOR.instances.article_republish) {
      CKEDITOR.instances["article_republish"].on(
        "instanceReady",
        function (event) {
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );
      CKEDITOR.instances["article_republish"].on("paste", function (evt) {
        var unescapeString = unescape(evt.data.dataValue);

        if (unescapeString.includes("<script")) {
          unescapeString = unescapeString.replace("<!--{cke_protected}", "");
          unescapeString = unescapeString.replace("-->", "");

          evt.data.dataValue = unescapeString;
          console.log(unescapeString);
        }
      });
    }
  }

  public setIntroTextEditorStatus(value) {
    if (CKEDITOR.instances.productReview_intro_text) {
      CKEDITOR.instances["productReview_intro_text"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );

      CKEDITOR.instances["productReview_intro_text"].on(
        "paste",
        function (evt) {
          var unescapeString = unescape(evt.data.dataValue);

          if (unescapeString.includes("<script")) {
            unescapeString = unescapeString.replace("<!--{cke_protected}", "");
            unescapeString = unescapeString.replace("-->", "");

            evt.data.dataValue = unescapeString;
            console.log(unescapeString);
          }
        }
      );
    }
  }

  public setSandboxIntroTextEditorStatus(value) {
    if (CKEDITOR.instances.productReviewSandbox_intro_text) {
      CKEDITOR.instances["productReviewSandbox_intro_text"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );

      CKEDITOR.instances["productReviewSandbox_intro_text"].on(
        "paste",
        function (evt) {
          var unescapeString = unescape(evt.data.dataValue);

          if (unescapeString.includes("<script")) {
            unescapeString = unescapeString.replace("<!--{cke_protected}", "");
            unescapeString = unescapeString.replace("-->", "");

            evt.data.dataValue = unescapeString;
            console.log(unescapeString);
          }
        }
      );
    }
  }

  public setIsSandboxContentAvailable(data) {
    this.articlesEdit.setIsSandboxContent(data);
  }

  public getArticleContent() {
    return contentEditor.getData();
  }

  public getArticleIntroText() {
    return introTextEditor.getData();
  }

  public getSandboxInViewContent() {
    return sandboxEditor.getData();
  }

  public getSandboxIntroText() {
    return sandboxIntroTextEditor.getData();
  }

  public getRepublishInViewContent() {
    return republishEditor.getData();
  }

  public getRepublishIntroText() {
    return republishIntroTextEditor.getData();
  }

  public diffVersionText(oldText, newText) {
    // get the unified diff patch
    const oldHeader = "";
    const newHeader = "";
    const options = {
      context: "10000",
    };
    const result = diff.createPatch(
      "file",
      oldText,
      newText,
      oldHeader,
      newHeader,
      options
    );
    const html = Diff2Html.html(result, {
      drawFileList: false,
      matching: "words",
      outputFormat: "line-by-line",
    });

    this.articlesEdit.setVersionDiffResult(html);
  }

  public setUserPreferences(data) {
    //set the user preferences
    this.articlesEdit.setUserPreferences(data);
  }

  //tag picker functions
  protected getTagData() {
    if (this.tagSearchXHRHdl) {
      this.tagSearchXHRHdl.cancelAndReset();
    }

    this.articlesEdit.tagPicker.showLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/tags/get/";
    let formReq_params: Array<Array<string>> = [];

    //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
    let viewModel = this.articlesEdit.tagPicker.getViewModelForRequest();
    /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
    formReq_params.push(["data", ko.toJSON(viewModel)]);

    this.tagSearchXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
    this.tagSearchXHRHdl.execute();
  }

  protected onGetTagDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateTagPickerForm(responseParsed);
        obj.articlesEdit.tagPicker.hideLoading();
        /*if(obj.articlesEdit.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }*/
      });
    };
  }

  public getTag(tag, select = false) {
    this.getTags([tag], select);
  }

  protected getTags(idTags, select = false) {
    if (this.tagXHRHdl) {
      this.tagXHRHdl.cancelAndReset();
    }

    if (idTags.length > 1) {
      this.XHRHdlCaller = "tag_picker_group";
      this.articlesEdit.tagPicker.showLoading();
    } else {
      if (select) {
        this.XHRHdlCaller = "tag_picker_select";
        this.articlesEdit.tagPicker.showLoading();
      } else {
        this.XHRHdlCaller = "tag_picker_view";
        this.articlesEdit.tagPicker.showViewLoading();
      }
    }

    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url = "/api/brand/" + idBrand + "/tag-picker/tags/get/";

    let usrReq_params: Array<Array<string>> = [];

    //let vm:any = this.articlesEdit.getViewModelForRequest();
    //vm.lockItem = true;

    usrReq_params.push(["data", ko.toJSON({ idTags: idTags })]);

    this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
    this.tagXHRHdl.execute();
  }

  protected onGetTagRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.tags && responseParsed.tags.length > 0) {
          if (obj.XHRHdlCaller == "tag_picker_group") {
            let tagsResponse = responseParsed.tags;
            let tags = [];
            for (let response of tagsResponse) {
              let tag = response.tag;
              tag.specsValues = response.specsValues;
              tag.specDefaults = response.specDefaults;
              tag.communityRating = response.communityRating
                ? response.communityRating
                : { average: null, count: 0 };
              tag.includeCommunityRating = response.includeCommunityRating
                ? response.includeCommunityRating
                : false;
              tags.push(tag);
            }
            obj.articlesEdit.tagPicker.selectTags(tags);
          } else {
            let tag = responseParsed.tags[0].tag;
            tag.specsValues = responseParsed.tags[0].specsValues;
            tag.specDefaults = responseParsed.tags[0].specDefaults;
            tag.communityRating = responseParsed.tags[0].communityRating
              ? responseParsed.tags[0].communityRating
              : { average: null, count: 0 };
            tag.includeCommunityRating = responseParsed.tags[0]
              .includeCommunityRating
              ? responseParsed.tags[0].includeCommunityRating
              : false;
            if (obj.XHRHdlCaller == "tag_picker_select") {
              obj.articlesEdit.tagPicker.selectTag(
                { ...tag, pros: [], cons: [] },
                true
              );
              if (
                obj.articlesEdit.tagPicker.tagView
                  .getTemplateViewModel()
                  .isShown()
              ) {
                obj.articlesEdit.tagPicker.tagView.onClickSave();
              }
            } else if (obj.XHRHdlCaller == "tag_picker_view") {
              obj.articlesEdit.tagPicker.setTag({ ...tag, pros: [], cons: [] });
              obj.articlesEdit.tagPicker.setGroupings(
                responseParsed.tags[0].groupings
              );
            }
          }
        }
        //obj.editForm.setPermissions(responseParsed.permissions);
      });

      obj.articlesEdit.tagPicker.hideViewLoading();
      obj.articlesEdit.tagPicker.hideLoading();
      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addTagPickerValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeTagPickerValidationClass();
      }
    };
  }

  protected updateTagPickerForm(responseParsed) {
    let selectedTags = this.articlesEdit.tagPicker.getSelectedTags();

    if (responseParsed.data) {
      for (let tag of responseParsed.data) {
        tag.selected = false;
        let tagSelected = selectedTags.find((i) => i.id == tag.id);
        if (tagSelected) {
          tag.selected = true;
        }
      }
      this.articlesEdit.tagPicker.setTagsPagination(
        responseParsed.totalPage,
        responseParsed.currentPage
      );
      this.articlesEdit.tagPicker.setTagResults(responseParsed.data);
    }
  }

  protected saveTag(saveData) {
    this.articlesEdit.tagPicker.showEditLoading();

    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    let formReq_url = "/api/brand/" + idBrand + "/tag-picker/tags/save/";

    let formReq_params: Array<Array<string>> = [];

    formReq_params.push(["data", ko.toJSON(saveData)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onSaveTagReturn;
    XHRHdl.execute();
  }

  protected onSaveTagReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let showPickerIfTagNew = false;
        if (responseParsed.tag) {
          obj.articlesEdit.tagPicker.hideEdit();

          const { tempTagItemPros, tempTagItemCons } =
            obj.articlesEdit.tagPicker.tagEdit.getTemplateViewModel();

          let tag = responseParsed.tag;

          tag.specsValues = responseParsed.specsValues;
          tag.specDefaults = responseParsed.specDefaults;
          tag.includeCommunityRating = responseParsed.includeCommunityRating;
          tag.communityRating = responseParsed.communityRating;
          tag.hasTagHubPage = responseParsed.hasTagHubPage;

          if (responseParsed.newTag) {
            showPickerIfTagNew = true;
            obj.articlesEdit.tagPicker.setTagAfterAddNew(tag);
          } else {
            obj.articlesEdit.tagPicker.setTagAfterSave({
              ...tag,
              pros: tempTagItemPros(),
              cons: tempTagItemCons(),
            });
          }

          obj.releaseBrandTagLock(tag.id);
          obj.articlesEdit.tagPicker.updateSelectedTagAfterSave(tag);

          if (showPickerIfTagNew) {
            obj.articlesEdit.tagPicker.setTagAfterSave({
              ...tag,
              pros: tempTagItemPros(),
              cons: tempTagItemCons(),
            });
          }
        }
      });

      obj.articlesEdit.tagPicker.hideEditLoading();

      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addTagPickerValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeTagPickerValidationClass();
      }
    };
  }

  //TODO on error, close tag picker so user can see the error?
  public onClickHidePinnedTagsForm() {
    this.articlesEdit.onClickTogglePinnedTagsForm(false);
  }

  public onClickConfirmDialog(idElement) {
    if (idElement == "missingSpecDialog_template") {
      this.articlesEdit.articlePinnedTags.addTag();
    } else if (idElement == "dialogSandboxDelete") {
      this.articlesEdit.clearSandboxSection();
    } else if (idElement == "dialogRepublishDelete") {
      this.articlesEdit.clearRepublishSection();
    } else if (idElement == "dialogRepublishCreateAndUpdate") {
      this.articlesEdit.onClickCreateRepublishAndUpdateArticle();
    } else if (idElement == "warningDialog_newsletterSendingConfirmation") {
      this.sendNewsletter();
    }
  }

  public onClickCancelDialog(idElement) {
    if (idElement == "missingSpecDialog_template") {
      this.articlesEdit.articlePinnedTags.filterTags.clearInput();
    }
  }

  private disableBrandSelectorButton() {
    if (
      document
        .getElementsByClassName("btn-sidebar")[0]
        .classList.contains("is-closed")
    ) {
      let brandSelector = document.getElementById("brandSelector");
      let brandSelectorBtnDropdown = brandSelector.querySelector("button");
      if (brandSelectorBtnDropdown) {
        brandSelectorBtnDropdown.classList.add("is-disable");
      }
    }
  }

  public setTagEditLock(tag) {
    this.articlesEdit.tagPicker.showViewLoading();
    this.XHRHdlCaller = "tag_picker_edit";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url = "/api/brand/" + idBrand + "/tag-picker/tags/get/";

    let usrReq_params: Array<Array<string>> = [];

    usrReq_params.push([
      "data",
      ko.toJSON({ idTags: [tag.id], lockItem: true }),
    ]);

    this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
    this.tagXHRHdl.execute();
  }

  private sendSimpleRequest(req, obj) {
    return () => {
      if (req.request.readyState == 4) {
        let responseParsed = JSON.parse(req.request.response);
        if (req.request.status == 200) {
          obj.articlesEdit.handleTagInArticle(obj.XHRHdlCaller);
        } else if (req.request.status == 423) {
          if (obj.XHRHdlCaller == "tag_picker_edit_cancel") {
            obj.articlesEdit.handleTagInArticle(obj.XHRHdlCaller);
          } else {
            obj.getVnAppZone().notification = new vn_app_zone_notification(
              vn_app_zone_notification.TYPE_WARNING,
              responseParsed.message
            );
            obj.getVnAppZone().showNotificationToModule();
          }
        }

        obj.articlesEdit.tagPicker.hideViewLoading();
      }
    };
  }

  public releaseBrandTagLock(idTag) {
    this.articlesEdit.tagPicker.showViewLoading();
    this.XHRHdlCaller = "tag_picker_edit_cancel";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    let usrReq_url = `/api/brand/${idBrand}/tags/release/${idTag}`;

    let usrReq_params: Array<Array<string>> = [];

    usrReq_params.push(["data", ko.toJSON({ idTag })]);

    this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
    this.tagXHRHdl.execute();
  }

  public getTagToEdit() {
    return this.articlesEdit.tagPicker.tagView.getTag();
  }

  public getSandboxEditorContent() {
    return sandboxEditor.getData();
  }

  protected manageResponse(req, obj, successFct) {
    // This allows to intercept request on FE and do whatever you want
    // We will now lock the article edition when session is expired

    if (req.request.readyState == 4 && req.request.status == 423) {
      let lastSaveRecoveryAttempt = obj.articlesEdit
        .getTemplateViewModel()
        .lastSaveRecoveryAttempt();
      if (lastSaveRecoveryAttempt == "") {
        const curDate = new Date();
        lastSaveRecoveryAttempt = `${curDate.toDateString()} ${curDate.toLocaleTimeString()}`;
      }
      const warningMessage = `Your session expired. You will not be able to use save actions and any changes since ${lastSaveRecoveryAttempt} will be lost. Please backup any changes you may need.`;

      obj.articlesEdit.getTemplateViewModel().isGlobalLockEnabled(true);
      obj.articlesEdit.warningDialog_WhenLogOut.hideCancelBtn();
      obj.articlesEdit.warningDialog_WhenLogOut.setIsVisible(true);
      obj.articlesEdit.warningDialog_WhenLogOut.setTitle("Session Expired");
      obj.articlesEdit.warningDialog_WhenLogOut.setMessage(warningMessage);
      obj.articlesEdit.setArticleLockedStatus(true);

      obj.articlesEdit.setArticleAutoSaveError(true);

      obj.clearRecoverySave();
      obj.clearRecoveryWarning();
      obj.startAutosave(null);

      return; // No further action needed
    }

    super.manageResponse(req, obj, successFct);
  }

  public getChartDiv() {
    return chartDiv;
  }

  protected editWatchlist(isAddToWatchlist) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/editWatchlist/" +
      this.getVnAppZone().app.params.id;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", isAddToWatchlist]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetAddedToWatchlist;
    this.XHRHdl.execute();
  }

  protected onGetAddedToWatchlist(req, obj) {
    return () => {
      if (req.request.status == 200) {
        obj.manageResponse(req, obj, () => {
          let responseParsed = JSON.parse(req.request.response);
          obj.articlesEdit.setIsOnWatchlist(responseParsed);
          if (responseParsed) {
            obj.getVnAppZone().notification = new vn_app_zone_notification(
              vn_app_zone_notification.TYPE_SUCCESS,
              "Added to watchlist"
            );
          } else {
            obj.getVnAppZone().notification = new vn_app_zone_notification(
              vn_app_zone_notification.TYPE_SUCCESS,
              "Removed from watchlist"
            );
          }
          obj.getVnAppZone().showNotificationToModule();
        });
      } else {
        let responseParsed = JSON.parse(req.request.response);
        obj.getVnAppZone().notification = new vn_app_zone_notification(
          vn_app_zone_notification.TYPE_ERROR,
          responseParsed.message
        );
        obj.getVnAppZone().showNotificationToModule();
      }

      obj.articlesEdit.setWatchlistButtonEnabled(true);
    };
  }

  public clearbulkImageCaptionEditor() {
    bulkImageCaptionEditor.setData("");
  }

  public clearbulkImageDescriptionEditor() {
    bulkImageDescriptionEditor.setData("");
  }

  public insertVideo(param?, target?, data?) {
    if (target.element) {
      let element = target.element;
      element.parentElement.removeChild(element);
      target = target.editor;
    }

    let videoHTMLTag = this.buildVideoHTMLTag(data);

    if (target == "article_content") {
      this.insertTag(videoHTMLTag, contentEditor);
    }

    if (target == "article_sandbox") {
      this.insertTag(videoHTMLTag, sandboxEditor);
    }

    if (target == "article_republish") {
      this.insertTag(videoHTMLTag, republishEditor);
    }

    if (target == "featured_video") {
      this.articlesEdit.setFeaturedEmbed(null);
      this.articlesEdit.setFeaturedVideo(data);

      this.articlesEdit.setFeaturedVideoTitle(data.title);
      this.articlesEdit.setFeaturedVideoDescription(data.description);
      this.articlesEdit.setShowFeaturedVideoTitle(true);
      this.articlesEdit.setShowFeaturedVideoDescription(true);

      if (!this.articlesEdit.getTemplateViewModel().idContentType()) {
        let idContentType =
          data.details !== null && data.details.idContentType !== null
            ? data.details.idContentType
            : null;
        this.articlesEdit.setIdContentType(idContentType);
      }
      if (
        this.articlesEdit.getTemplateViewModel().selectedCategories().length ==
        0
      ) {
        let idPrimaryCategory =
          data.details !== null && data.details.idPrimaryCategory !== null
            ? data.details.idPrimaryCategory
            : null;
        if (idPrimaryCategory !== null) {
          this.articlesEdit.setIdPrimaryCategory(idPrimaryCategory.toString());
        }
        if (data && data.videoCategories && data.videoCategories.length > 0) {
          //this.articlesEdit.filterCategory.setSelectedItems(data.videoCategories);
          this.articlesEdit.setSelectedCategories(data.videoCategories);
        }
      }
      if (this.articlesEdit.getTemplateViewModel().selectedTags().length == 0) {
        let idPrimaryTag =
          data.details !== null && data.details.idPrimaryTag !== null
            ? data.details.idPrimaryTag
            : null;
        if (idPrimaryTag !== null) {
          this.articlesEdit.setIdPrimaryTag(idPrimaryTag.toString());
        }
        if (data && data.videoTags && data.videoTags.length > 0) {
          this.articlesEdit.setSelectedTags(data.videoTags);
        }
      }
    }

    if (target == "tagPickerEdit_tagVideo") {
      this.articlesEdit.tagPicker.tagEdit.setTagVideo(data);
    }

    this.articlesEdit.videoPickerHelper.hideVideoPicker();

    if (this.articlesEdit.getTemplateViewModel().idPublishStatus() != 3) {
      const { isUnderEmbargo } = data;
      if (isUnderEmbargo) {
        this.articlesEdit.setIsUnderEmbargo(true);
      }
    }
  }

  public handleVideoUpload(files) {
    if (
      this.articlesEdit.videoPickerHelper.getVideoIsNotUploadable() &&
      this.articlesEdit.videoPickerHelper.getFileIsVideo()
    ) {
      //const messages =[{ field: "Video", label:"Size limit exceeded", messages: ["Video uploads cannot exceed 150MB per minute of video."] }]
      //this.articlesEdit.videoPicker.setValidationMessageOnAddVideo(messages)
      this.articlesEdit.videoPickerHelper.clearVideoFileInput();
      return;
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let url: string = `/api/brand/${idBrand}/videos/upload/`;

    const formData = new FormData();
    for (const file of files) {
      formData.append("videos[]", file);
    }

    const uploadPromise = new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.responseType = "json";

      xhr.open("POST", url);

      xhr.onload = () => {
        const response = xhr.response;
        if (xhr.readyState === 4 && xhr.status === 200) resolve(response);
        else reject(response);
      };

      xhr.upload.onprogress = (ev) => {
        console.log("Progress");
        const percentComplete = Math.round((ev.loaded / ev.total) * 100);
        this.articlesEdit.videoPickerHelper.setUploadValue(percentComplete);
      };

      xhr.upload.onloadstart = () => {
        console.log("Upload started");
        this.articlesEdit.videoPickerHelper.setUploadIsInProgress(true);
      };
      xhr.upload.onloadend = () => {
        console.log("Upload finished");
        this.articlesEdit.videoPickerHelper.setUploadIsInProgress(false);
      };

      xhr.send(formData);
    });

    uploadPromise
      //If success
      .then((response) => {
        //response['uploadVideos'][0]['details'] = null;
        //response['uploadVideos'][0]['id'] = 0;
        this.articlesEdit.videoPickerHelper.hideVideoPickerAdd();
        this.articlesEdit.videoPickerHelper.clearVideoFileInput();
        this.articlesEdit.videoPickerHelper.setVideoPickerEditData(
          response["uploadVideos"][0],
          "NEW_VIDEO_UPLOADED"
        );
        this.articlesEdit.videoPickerHelper.showVideoPickerEdit();
        this.articlesEdit.videoPickerHelper.setUploadValue(0);
      })
      .catch((errorResponse) => {
        if (errorResponse) {
          const { type, validations } = errorResponse;
          if (type == "validation") {
            this.articlesEdit.videoPickerHelper.setValidationMessageOnAddVideo(
              validations
            );
            this.articlesEdit.videoPickerHelper.clearVideoFileInput();
            this.articlesEdit.videoPickerHelper.setUploadValue(0);
          }
        } else {
          const messages = [
            {
              field: "Video",
              label: "Upload Error",
              messages: ["Video file cannot be uploaded!"],
            },
          ];
          this.articlesEdit.videoPickerHelper.setValidationMessageOnAddVideo(
            messages
          );
          this.articlesEdit.videoPickerHelper.clearVideoFileInput();
          this.articlesEdit.videoPickerHelper.setUploadValue(0);
        }
      });
  }

  protected buildVideoHTMLTag(video) {
    const { id, title, url, thumbnail } = video;
    let thumbnailUrl = thumbnail
      ? thumbnail.url
      : "/assets/images/replace-video.png";
    return `
            <div class="emaki-displayCard video" data-id="${id}">
                <div class="w-video-info">
                    <h3 class="video-title" data-field="title">${title || ""
      }</h3>
                    <div class="w-img" style="width: auto; height: auto">
                        <img data-field="video" src="${thumbnailUrl || ""
      }"  width="400" height="224" alt="" data-video-url="${url}" data-video-title="${title}">
                    </div>
                </div>
            </div>
        `;
  }

  protected getVideosData() {
    this.getVideoPickerHelper().getVideosData();
  }

  public saveVideo(videoData, param?) {
    this.articlesEdit.videoPickerHelper.showLoadingEditVideo();
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let url: string = "/api/brand/" + idBrand + "/videos/save/";
    let params: Array<Array<string>> = [];

    videoData["idProducer"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .filterUser_producer.idUser();
    videoData["videoTags"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .selectedTags();
    videoData["idPrimaryTag"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .idPrimaryTag();
    videoData["videoCategories"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .selectedCategories();
    videoData["idPrimaryCategory"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .idPrimaryCategory();
    videoData["idContentType"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .idContentType();
    videoData["videoSubtitles"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .subtitlesFiles();

    params.push(["data", ko.toJSON(videoData)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      url,
      params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        if (req.request.readyState == 4) {
          obj.articlesEdit.videoPickerHelper.hideLoadingEditVideo();
          if (req.request.status == 200) {
            obj.getVideoPickerEditTemplate().validations.clearMessages();
            obj.manageResponse(req, obj, function () {
              let responseParsed = JSON.parse(req.request.response);
              let video = responseParsed.video;
              obj.articlesEdit.videoPickerHelper.hideVideoPickerEdit();
              const target =
                obj.articlesEdit.videoPickerHelper.getVideoPickerTarget();
              if (param == "insert-save") {
                obj.insertVideo(param, target, video);
              }
              if (target == "featured_video" && param == "save") {
                obj.insertVideo(param, target, video);
                obj.articlesEdit.videoPickerHelper.hideVideoPickerEdit();
                obj.articlesEdit.setFeaturedVideo(video);
              }
              //refresh video view data
              obj.articlesEdit.videoPickerHelper.setViewVideoData(video);
              obj.getVideosData();
            });
          } else if (req.request.status == 400) {
            let errorResponse = JSON.parse(req.request.response);
            const { validations } = errorResponse;
            obj.getVideoPickerEditTemplate().setValidationMessage(validations);
          } else {
            const messages = [
              {
                field: "Video",
                label: "Video Save Error",
                messages: ["An error occurs"],
              },
            ];
            obj.getVideoPickerEditTemplate().setValidationMessage(messages);
          }
        }
      };
    };
    XHRHdl.execute();
  }

  getVideo(videoId) {
    if (this.contentVideoXHRHdl) {
      this.contentVideoXHRHdl.cancelAndReset();
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;

    let url: string = "/api/brand/" + idBrand + "/videos/get-content-video/";
    let params: Array<Array<string>> = [];
    params.push(["videoId", videoId]);

    this.contentVideoXHRHdl = new XMLHttpRequestHandler(url, params, this);
    this.contentVideoXHRHdl.onReadyStateFunction = this.onVideoRequestReturn;
    this.contentVideoXHRHdl.execute();
  }

  protected onVideoRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        let video = responseParsed.video;

        obj.editVideo(video);
      });
    };
  }

  editVideo(video) {
    this.articlesEdit.videoPickerHelper.editVideo(video);
  }

  protected getUploadUrlSubtitles(): string {
    return (
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/videos/subtitles/upload"
    );
  }

  deleteVideo(video) {
    if (this.deleteVideoXHRHdl) {
      this.deleteVideoXHRHdl.cancelAndReset();
    }
    const { id } = video;
    let idBrand = this.getVnAppZone().app.params.idBrand;

    let url: string = "/api/brand/" + idBrand + "/videos/delete/";
    let params: Array<Array<string>> = [];
    params.push(["videoId", id]);

    this.articlesEdit.videoPickerHelper.showLoading();

    this.deleteVideoXHRHdl = new XMLHttpRequestHandler(url, params, this);
    this.deleteVideoXHRHdl.onReadyStateFunction =
      this.onVideoDeleteRequestReturn;
    this.deleteVideoXHRHdl.execute();
  }

  onVideoDeleteRequestReturn(req, obj) {
    return function () {
      if (req.request.status == 200) {
        obj.manageResponse(req, obj, function () {
          obj.articlesEdit.videoPickerHelper.hideVideoPickerView();
          obj.getVideosData();
        });
      } else if (req.request.status == 400) {
        if (req.request.response) {
          //To avoid syntax error
          let errorResponse = JSON.parse(req.request.response);
          const { validations } = errorResponse;
          obj.articlesEdit.videoPickerHelper.setValidationMessage(validations);
        }
      } else {
        //For all unexpected errors
        const messages = [
          {
            field: "Video",
            label: "Deletion Error",
            messages: ["An error occurs"],
          },
        ];
        obj.articlesEdit.videoPickerHelper.setValidationMessage(messages);
      }
      obj.articlesEdit.videoPickerHelper.hideLoading();
    };
  }

  replaceOrUpdateVideoCardElement(oldVideoElement, newVideoData, target) {
    let element = this.buildVideoHTMLTag(newVideoData);

    let editor = this.getEditor(target);
    const oldVideoElementId = oldVideoElement.dataset.id;

    const selector = `*[data-id="${oldVideoElementId}"]`;
    editor.editable().findOne(selector).remove();

    editor.insertHtml(element, "html", null);
  }

  public getIdBrand() {
    return Number(this.getVnAppZone().app.params.idBrand);
  }

  protected showKeyTakeawayAddedNotification() {
    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_WARNING,
      'A "Key Takeaway" summary has been inserted into the top of the content. !'
    );
    this.getVnAppZone().showNotificationToModule();
  }

  protected setUpCkEditorTagsPickerEditTextArea() {
    classicEditor
      .create(document.querySelector("#tagPickerTagTypeFieldTextArea"), {
        toolbar: ["bold", "|", "italic", "link"],
        link: {
          addTargetToExternalLinks: true,
        },
      })
      .then((newEditor) => {
        tagPickerSpecAreaEditor = newEditor;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  private initializePromptResponseCKEditor() {
    const basicConfig = {
      toolbar: [
        {
          name: "basicstyles",
          items: ["Bold", "Italic", "Strike", "Link", "EmojiPanel"],
        },
      ],
      extraPlugins: "emoji",
      removeButtons: "",
    };
    CKEDITOR.replace("prompt_response", basicConfig);
    promptResponseEditor = CKEDITOR.instances.prompt_response;
  }

  // private initializeSummariesCKEditor(idSUmmariesEditor) {
  //   const basicConfig = {
  //     toolbar: [
  //       {
  //         name: "basicstyles",
  //         items: ["Bold", "Italic", "Strike", "Link", "EmojiPanel"],
  //       },
  //     ],
  //     extraPlugins: "emoji",
  //     removeButtons: "",
  //   };
  //   CKEDITOR.replace(idSUmmariesEditor, basicConfig);
  //   promptResponseEditor = CKEDITOR.instances.prompt_response;
  // }

  public setRichTextTagSpecAreaEditor(value) {
    tagPickerSpecAreaEditor.setData(value);
  }

  public getRichTextTagSpecAreaEditor() {
    return tagPickerSpecAreaEditor.getData();
  }

  public setRichTextForPromptResponseEditor(text: string) {
    promptResponseEditor.setData(text);
  }

  public getRichTextForPromptResponseEditor() {
    return promptResponseEditor.getData();
  }

  public getBrandId() {
    return this.getVnAppZone().app.params.idBrand;
  }

  protected getTagTypes(listTagTypesId) {
    if (listTagTypesId && listTagTypesId.length > 0) {
      this.XHRHdl.cancelAndReset();

      let usrReq_url: string = "/api/tag/types/get/";
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push([
        "data",
        ko.toJSON({
          filters: {
            ids: listTagTypesId,
          },
        }),
      ]);
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

      this.XHRHdl.onReadyStateFunction = this.onGetTagTypesReturn;
      this.XHRHdl.execute();
    }
  }

  protected onGetTagTypesReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.setTagTypesRestriction(
            response.data
          );
        }
      });
    };
  }

  protected validateTagSpecFromSource(
    idField,
    idType,
    label,
    dataType,
    restrictionsArray,
    value = null,
    idBrand = null
  ) {
    let formReq_url: string = "/api/tags/field/validate/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = {
      idType: idType,
      label: label,
      idField: idField,
      dataType: dataType,
      typeRestrictions: restrictionsArray,
      value: value,
      idBrand: idBrand,
    };
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = this.onValidateSpecification;
    XHRHdl.execute();
  }

  public onValidateSpecification(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        let responseParsed = JSON.parse(req.request.response);
        if (responseParsed.data && responseParsed.data.valid) {
          obj.articlesEdit.tagPicker.tagEdit.appendSpecification();
        } else {
          let messages = responseParsed.validations.map((v) => {
            return { field: v.dataField, label: v.label, messages: v.messages };
          });
          obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.validationsList.setMessages(
            messages
          );
          window.scrollTo(0, 0);
        }
      }
    };
  }

  protected getTagsByTypes(keyword, typeRestrictions = []) {
    this.XHRHdl.cancelAndReset();

    let usrReq_url: string = "/api/tags/get_by_types/";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      usrReq_url = "/api/brand/" + idBrand + "/tags/get_by_types/";
    }
    let subViewModel = {
      keyword: keyword,
      tagTypesIds: typeRestrictions,
    };
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetTagByTypesRequestReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagByTypesRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        let tags = responseParsed.data;
        if (tags) {
          if (obj.XHRHdlCaller == "getSuggestions_tagSourcePickerTagFilter") {
            obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.setTags(tags);
          }
        }
      });
    };
  }

  public resetEditedSpec() {
    this.articlesEdit.tagPicker.tagEdit.resetEditedSpec();
  }

  protected addArticlePickerCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showArticlePicker(editor);
          },
        };
      }

      editor.addCommand("articlePickerCommand", showMyDialog(this));

      editor.ui.addButton("ArticleBtn", {
        // add new button and bind our command
        label: "Insert Articles",
        command: "articlePickerCommand",
        toolbar: "insert",
        icon: "/assets/images/article.png",
      });
    });
  }

  protected showArticlePicker(editor) {
    const selectedText = editor.getSelection() && editor.getSelection().getNative() ? editor.getSelection().getNative().toString() : '';
    if (selectedText.length > 0) {
      this.articlesEdit.showArticlePicker(editor.name, selectedText);
    } else {
      this.articlesEdit.showArticlePicker(editor.name);
    }
  }

  /*protected insertArticleElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null && !this.isSensaiChat) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    if(this.isSensaiChat) {
      this.isSensaiChat = false;
    }
    let editor = this.getEditor(target);

    //set cursor position to end of current selection - to insert tag after elements
    if (editor != null) {
      let selectionElement = editor.getSelection().getStartElement();
      let range = null;

      if (
        selectionElement != null &&
        selectionElement.$ &&
        selectionElement.$.nodeName != "BODY" &&
        selectionElement.$.nodeName != "TD" &&
        selectionElement.getParent() != null
      ) {
        range = editor.createRange();
        range.setStartAt(selectionElement, CKEDITOR.POSITION_AFTER_END);
        range.collapse(true);
      } else if (selectionElement == null) {
        range = editor.createRange();
        range.moveToElementEditEnd(range.root);
      }
      editor.insertHtml(element, "html", range);
    }
  }*/
  protected insertArticleElement(elementToReplace, elementHtml, target) {
    const editor = this.getEditor(target);

    if (!editor) {
      console.warn("CKEditor instance not found.");
      return;
    }

    // Handle SensaiChat override
    if (this.isSensaiChat) {
      this.isSensaiChat = false;
    }

    // Ensure the editor is focused
    editor.focus();

    // Remove the element to be replaced from the DOM and CKEditor content
    if (elementToReplace && elementToReplace.parentElement) {
      // Try to match this in the CKEditor document instead
      const editorElement = editor.document.getById(elementToReplace.id);
      if (editorElement) {
        editorElement.remove();
      } else {
        elementToReplace.parentElement.removeChild(elementToReplace);
      }
    }

    const selection = editor.getSelection();
    const ranges = selection.getRanges();

    if (!ranges || ranges.length === 0) {
      console.warn("No selection range found.");
      return;
    }

    const range = ranges[0];

    // Delete current selection or range (including partially selected inline tags like <strong>)
    range.deleteContents();

    // Convert your string of HTML into CKEditor's HTML parser fragment
    const fragment = CKEDITOR.htmlParser.fragment.fromHtml(elementHtml);
    const writer = new CKEDITOR.htmlParser.basicWriter();
    fragment.writeHtml(writer);
    const finalHtml = writer.getHtml();

    // Insert HTML safely
    editor.insertHtml(finalHtml);

    // Optional: snapshot for undo support
    editor.fire('saveSnapshot');
  }
  public getPermalinkParts(permalink) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let usrReq_url: string =
      "/api/brand/" + this.getBrandId() + "/menu/getPermalinksByPartMatch";
    let usrReq_params: Array<Array<string>> = [];
    let subViewModel = {
      permalink: permalink,
    };
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetPermalinkParts;
    this.XHRHdl.execute();
  }
  public onGetPermalinkParts(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        obj.articlesEdit.setPermalinkParts(response.permalinksByPartMatch);
      });
    };
  }

  public cancelFilter() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }

  public abortEmbedGeneration(): void {
    this.embedHelper.abortEmbedGeneration();
  }

  public setIsImageOptimized(val) {
    this.articlesEdit.setIsFeaturedImageMobileOptimized(val);
  }

  public getSensaiArticleReferences(target, idArticle) {
    if (this.SensaiXHRHdl) {
      this.SensaiXHRHdl.cancelAndReset();
    }

    this.articlesEdit.showFeedbackTabLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/sensai/references/" + idArticle + "/";
    let formReq_params: Array<Array<string>> = [];

    this.SensaiXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiArticleReferences;
    this.SensaiXHRHdl.execute();
  }

  public onGetSensaiArticleReferences(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.setSavedFeedbacksHistoryOptions(responseParsed);
      });
    };
  }

  public filterFeedBackHistory(idArticle, uuid) {
    if (this.SensaiXHRHdl) {
      this.SensaiXHRHdl.cancelAndReset();
    }

    this.articlesEdit.showFeedbackTabLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/sensai/feedback/" + idArticle + "/";
    let formReq_params: Array<Array<string>> = [];
    let subViewModel = { uuid: uuid };
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    this.SensaiXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.SensaiXHRHdl.onReadyStateFunction =
      this.onGetSensaiArticleFeedbackHistory;
    this.SensaiXHRHdl.execute();
  }

  public onGetSensaiArticleFeedbackHistory(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);

        let guidelines = obj.organizeSensaiResults(responseParsed);
        obj.articlesEdit.articleReviewHistory.setGuidelines(guidelines);

        obj.articlesEdit.hideFeedbackTabLoading();
      });
    };
  }
  public setDataFromBackend(urlParams) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
    let id: number;
    let takeover = false;
    if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
      this.articlesEdit.getTemplateViewModel().id(id);
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let searchParams = new URLSearchParams();

    if (urlParams["videoId"])
      searchParams.append("videoId", urlParams["videoId"]);

    if (urlParams["idThreadSuggestion"])
      searchParams.append("idThreadSuggestion", urlParams["idThreadSuggestion"]);

    let searchParamsString = searchParams.toString();

    if (searchParamsString)
      searchParamsString = `?${searchParamsString}`;

    let usrReq_url: string = `/api/brand/${idBrand}/articles/getForEdit/${id}${searchParamsString}`;
    let usrReq_params: Array<Array<string>> = [];
    //usrReq_params.push(['data', ko.toJSON(urlParams)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetDataFromBackend;
    this.XHRHdl.execute();
  }

  public onGetDataFromBackend(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        const { article } = response.data;
        obj.setArticleData(article);
      });
    };
  }

  public searchPoll(keyword: string) {
    if (keyword.length < 3) return;

    if (this.pollXhr) {
      this.pollXhr.cancelAndReset();
    }
    const idBrand = this.getVnAppZone().app.params.idBrand;
    const url = `/api/brand/${idBrand}/polls/search/`;
    let params = [];
    params.push(["keyword", keyword]);
    this.pollXhr = new XMLHttpRequestHandler(url, params, this);
    this.pollXhr.mode = XMLHttpRequestHandler_requestType.POST;
    this.pollXhr.onReadyStateFunction = (req, obj) => {
      return () => {
        obj.manageResponse(req, obj, function () {
          if (req.request.readyState == 4 && req.request.status == 200) {
            const response = JSON.parse(req.request.response);
            obj.articlesEdit.setPollOptions(response);
          } else {
            console.error(req.request.response);
            return [];
          }
        });
      };
    };
    this.pollXhr.execute();
  }


  protected getDatasetSuggestion(keyword, limit = null, restrictOwnedTagTypes = false) {

    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = {
      keyword: keyword,
      limit: limit,
      restrictOwnedTagTypes: restrictOwnedTagTypes,
    };
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url: string = '';
    if (idBrand) {
      usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/dataset/";
    } else {
      usrReq_url = "/api/search/tag/dataset/";
    }
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetDatasetSuggestionReturn;
    this.XHRHdl.execute();

  }

  protected onGetDatasetSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let datasets = responseParsed.data.templateTypes;

        obj.articlesEdit.setDatasetFilter(datasets);

      });
    }
  }

  protected getTagTypeByDatasetId(idDataset) {
    //if (this.XHRHdl) {
    //    this.XHRHdl.cancelAndReset();
    //}

    let subViewModel = {
      idDataset: idDataset
    };

    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url: string = '';
    if (idBrand) {
      usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/types/get_by_dataset_id/" + idDataset + "/";
    } else {
      usrReq_url = "/api/search/tag/types/get_by_dataset_id/" + idDataset + "/";
    }
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagTypeByDatasetIdReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagTypeByDatasetIdReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let tagTypes = responseParsed.data;

        obj.articlesEdit.setTagTypeDropdown(tagTypes);

      });
    };
  }

  public deleteAllSelectedTagType() {
    this.articlesEdit.deleteAllSelectedTagType();
  }

  public initiateSensaiChat(userQuery, isQuickPrompt = false) {

    this.loadingIn(document.getElementById("user-query-container"));
    let articleText = contentEditor.getData();
    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    let sessionId = this.articlesEdit.getTemplateViewModel().sessionId();
    // Close any existing EventSource connection
    if (this.eventSource) {
      this.eventSource.close();
    }

    this.articlesEdit.getTemplateViewModel().isChatDisabled(true);

    fetch('/api/sensAI-vault/save-chat-session/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ articleText: articleText, sessionId: sessionId, chatHistory: this.articlesEdit.getTemplateViewModel().chatHistory() })
    }).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    }).then(data => {
      let sessionId = data.sessionId;
      this.articlesEdit.getTemplateViewModel().sessionId(sessionId);
      userQuery = encodeURIComponent(userQuery);
      let formReq_url = `/api/sensAI-vault/sensai-vault-chat/?userQuery=${userQuery}&isQuickPrompt=${isQuickPrompt}&idBrand=${idBrand}&idArticle=${this.articlesEdit.getTemplateViewModel().id()}`;
      this.eventSource = new EventSource(formReq_url);
      this.eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          //console.log("Streaming response:", data);

          if (data.response) {
            this.articlesEdit.addToChatHistory(data.response, "system");
          }

          if (data === "[DONE]") {
            console.log("Streaming finished.");
            this.eventSource.close();
            this.loadingOut(document.getElementById("user-query-container"));
          }
        } catch (e) {
          console.error("Error parsing SSE stream:", e);
        }
      };

      this.eventSource.addEventListener('close', (event) => {
        console.log("Streaming finished gracefully via custom close event.");
        this.eventSource.close();
        this.loadingOut(document.getElementById("user-query-container"));
        this.articlesEdit.getTemplateViewModel().isChatDisabled(false);
      });


      this.eventSource.onerror = (error) => {
        console.error("EventSource error:", error);
        this.eventSource.close();
        this.loadingOut(document.getElementById("user-query-container"));
        this.articlesEdit.getTemplateViewModel().isChatDisabled(false);
      };
    })
  }

  public async scrappingExternalSourceNewsUrl({sourceUrl, isLoadingSrcTimeBtn}) {
    const endpoint = '/api/extract/date-published/';
    isLoadingSrcTimeBtn(true);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({sourceUrl: sourceUrl()}),
      });

      if (!response.ok) {
        console.error('Request failed:', response.status);
        this.showMessage('An error occurred. Please try again later.', 'error');
      } else {
        const data = await response.json();
        const datePublished = data.publicationTime || null;

        this.articlesEdit.sourceNewsDatePicker
            .getTemplateViewModel()
            .singleDatePicker(datePublished);

        const message = datePublished
            ? 'Completed! Found source publication time.'
            : 'Cannot get the date published from the source.';
        const messageType = datePublished ? 'success' : 'alert';

        this.showMessage(message, messageType);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      this.showMessage('An error occurred. Please try again later.', 'error');
    } finally {
      isLoadingSrcTimeBtn(false);
    }
  }


    private showMessage(message : string , type : 'success' | 'alert' | 'error' = 'success') {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }


    public fetchArticleAiSummaries() {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const url = `/api/brand/${idBrand}/article/${idArticle}/summary/get/`;
    return fetch(url)
        .then(res => res.json())
        .then(res => {
            if (res.data) {
                const vm = this.articlesEdit.getTemplateViewModel();
                vm.factualSummary(res.data.factualSummary || '');
                factualSummaryEditor.setData(res.data.factualSummary  || '');
                vm.simpleSummary(res.data.simpleSummary || '');
                simpleSummaryEditor.setData(res.data.simpleSummary  || '');
                vm.satiricalCommentary(res.data.satiricalCommentary || '');
                satiricalCommentaryEditor.setData(res.data.satiricalCommentary  || '');
                vm.reactionPost(res.data.reactionPost || '');
                vm.isFactualSummaryEnabled(res.data.isFactualSummaryEnabled !== false);
                vm.isSimpleSummaryEnabled(res.data.isSimpleSummaryEnabled !== false);
                vm.isSatiricalCommentaryEnabled(res.data.isSatiricalCommentaryEnabled !== false);
            }
        });
      }

      public saveArticleAiSummaries(regenerate = false) {
          const idBrand = this.getIdBrand();
          const idArticle = this.articlesEdit.getId();
          const vm = this.articlesEdit.getTemplateViewModel();
          const url = `/api/brand/${idBrand}/article/${idArticle}/summary/save/`;
              this.loadingIn(document.getElementById("widgets-section-summary"));

          const payload = {
              factualSummary: factualSummaryEditor.getData(),
              simpleSummary: simpleSummaryEditor.getData(),
              satiricalCommentary: satiricalCommentaryEditor.getData(),
       
              reactionPost: vm.reactionPost(),
              isFactualSummaryEnabled: vm.isFactualSummaryEnabled(),
              isSimpleSummaryEnabled: vm.isSimpleSummaryEnabled(),
              isSatiricalCommentaryEnabled: vm.isSatiricalCommentaryEnabled(),
              updateSummariesWithContent: vm.updateSummariesWithContent(),
              regenerate: regenerate
          };
          return fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
          }).then(res => res.json())  .then(res => {
            if (res.data) {
                const vm = this.articlesEdit.getTemplateViewModel();
                vm.factualSummary(res.data.factualSummary || '');
                factualSummaryEditor.setData(res.data.factualSummary  || '');
                factualSummaryEditor.setReadOnly(true);
                vm.simpleSummary(res.data.simpleSummary || '');
                simpleSummaryEditor.setData(res.data.simpleSummary  || '');
                vm.satiricalCommentary(res.data.satiricalCommentary || '');
                satiricalCommentaryEditor.setData(res.data.satiricalCommentary  || '');
                vm.reactionPost(res.data.reactionPost || '');
                vm.isFactualSummaryEnabled(res.data.isFactualSummaryEnabled !== false);
                vm.isSimpleSummaryEnabled(res.data.isSimpleSummaryEnabled !== false);
                vm.isSatiricalCommentaryEnabled(res.data.isSatiricalCommentaryEnabled !== false);
                vm.updateSummariesWithContent(res.data.updateSummariesWithContent !== false);
                    this.loadingOut(document.getElementById("widgets-section-summary"));

            }
        });
      } 

}



// WEBPACK FOOTER //
// ./js/modules/articles_edit_new.ts